var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// ReSharper disable InconsistentNaming
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        class Constants {
            /**
             * True when the app runs in mobile mode. Evaluated at use time via QmcMobileContext.
             */
            static get IS_MOBILE() {
                const ctx = typeof window !== "undefined" ? window.QmcMobileContext : undefined;
                return ctx ? ctx.isMobileContext() : false;
            }
        }
        Constants.FULL_CALENDAR_PREMIUM_LICENSE = '0194430006-fcs-1560406752';
        Constants.DEFAULT_PAGINATION_SIZE = 30;
        Constants.GUID_EMPTY = "00000000-0000-0000-0000-000000000000";
        Constants.DEFAULT_NAV_ID = "be5944c2-2a62-4aef-b747-d298971505e8";
        Constants.OBJECTTYPE_CLIENT = 140000;
        Constants.OBJECTTYPE_EMPLOYEE = 120000;
        Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID = "2c4be6f5-2c40-4c1e-abb0-08334e5178f4";
        Constants.SHOW_ALL_EMPLOYEES_PREDEFINED_SEARCH_ID = "1655659a-5e10-4a1f-b6c6-e69cb74b64c7";
        Constants.DEFAULT_ACTIVITY_ID = "bcafd3ce-f25c-410a-a623-75c77eb15d5c";
        Constants.MESSAGE_INBOX_FOLDER_ID = "fc52cc92-ee6e-48da-b42d-a8111af27686";
        Constants.MESSAGE_SENT_FOLDER_ID = "09aa8d37-065f-444a-a9fa-94d59dc2c125";
        Constants.MESSAGE_RECYCLEBIN_FOLDER_ID = "5f6720c1-ff53-48aa-bda9-a82c10781fe3";
        Constants.DEFAULT_CLIENT_PREDEFINED_SEARCH_ID = "27a653ff-299e-41a4-bc31-973b36ab373e"; // "Meine Betreuten"
        Constants.DEFAULT_COUNTRY_ID = "e8dfa43c-c3d4-408d-87d8-7bf9ccdb0ab7"; // Germany
        Constants.DEFAULT_DISEASE_CODE_SCHEMA = "37783beb-d174-4be4-9394-1ded6328faa4";
        Constants.DEMAND_MEDICATION = "0f11f2ef-8d2b-452f-ac2e-632143fec211";
        Constants.DELETE_REASON_ID = "4905ca15-8437-40bf-8875-4c2f2572057c";
        Constants.EXECUTION_TYPE_SINGLE_ID = "a1ac6cb3-56a7-454a-a7eb-d9adabf8989d";
        Constants.EXECUTION_TYPE_MULTIPLE_ID = "dd8d8de1-b0f3-4fd6-abf0-1cd1cbd2716a";
        Constants.APPROVAL_PENDING_ID = "efd58886-58e4-4562-adcb-27e677167767"; // steht aus
        Constants.APPROVAL_APRROVED_ID = "a8d072b9-8cdb-4e91-810b-df609c6946c3"; // genehmigt
        Constants.JOURNAL_COMMENTTYPE_NORMAL = 'b22fa7fc-8d14-4ae1-8483-729c5df12c07';
        Constants.JOURNAL_COMMENTTYPE_WARNING = '7d1d5043-fe48-4b93-be38-c2bfd8e41d08';
        Constants.SIGNATURE_SIGNING_PERSON_CLIENT = 'd69838db-7965-4df9-9723-b6032ab6f2e8';
        Constants.WV_DOCUMENT_RUBRIC = "02fed28c-33c0-42fe-9b45-d815eb1acccc";
        Constants.WV_YES = "6b1eeda2-f346-4366-b5b4-6d3576e35991";
        Constants.WV_NO = "a1219cb4-18bb-4232-93ee-44a335d39d9a";
        Constants.SMARTACTIONCACHE = 'SmartActionCache';
        Constants.FLS_NO_MISCONTACT = 'e7f1e265-8950-4c2a-9a27-4c4d59bd3f35';
        Common.Constants = Constants;
        class UserSettingConstantsAndDefaults {
        }
        UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL = false;
        UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA_KEY = 'GLOBAL.SHOULDLOADTABLEDATA';
        UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA = true;
        // AZN
        UserSettingConstantsAndDefaults.SHOWDATETOAZN = false;
        //FLS
        UserSettingConstantsAndDefaults.ALLOWEMPTYREPORTS = false;
        UserSettingConstantsAndDefaults.PLANEDRAWDAYS = 30;
        UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE = 14;
        UserSettingConstantsAndDefaults.SHOWDATETOFLS = false;
        UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS = true;
        UserSettingConstantsAndDefaults.SIGNATUREHIDEREPORTS = false;
        UserSettingConstantsAndDefaults.SIGNATUREDIRECTSIGN = false;
        UserSettingConstantsAndDefaults.FLSMINUTESTOSIGN = -1;
        UserSettingConstantsAndDefaults.FLSWEEKPLANNERSHOWHOLIDAY = false;
        UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN = true;
        UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX = false;
        UserSettingConstantsAndDefaults.GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG = true;
        UserSettingConstantsAndDefaults.DEFAULTFLSCARETYPE = Constants.GUID_EMPTY;
        UserSettingConstantsAndDefaults.DEFAULTFLSCONTACTTYPE = Constants.GUID_EMPTY;
        UserSettingConstantsAndDefaults.DEFAULTSIGNINGPERSON = 'd69838db-7965-4df9-9723-b6032ab6f2e8';
        UserSettingConstantsAndDefaults.DEFAULTSIGNINGREASON = Constants.GUID_EMPTY;
        UserSettingConstantsAndDefaults.FLS_WEEKPLANNER_INCLUDE_FUTURE_CASES = false;
        UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY = 'FLS.CASELIST.FILTER';
        UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS = { carerTypeFilterId: Constants.GUID_EMPTY, onlyCurrentCases: true };
        // SECURITY
        UserSettingConstantsAndDefaults.INACTIVITYTIMEOUT = 30;
        // TASK
        UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS = 30;
        UserSettingConstantsAndDefaults.LANDINGPAGE = "dashboard";
        UserSettingConstantsAndDefaults.NAVIGATION_DEFAULT_ID = 'be5944c2-2a62-4aef-b747-d298971505e8';
        // ROSTER
        UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE = true;
        //TIME CLOCK
        UserSettingConstantsAndDefaults.INQUIRE_STAMPIN_ON_LOGIN = false;
        UserSettingConstantsAndDefaults.INQUIRE_STAMPOUT_ON_LOGOUT = false;
        //REPORTING
        UserSettingConstantsAndDefaults.DAYSINPAST = 7;
        UserSettingConstantsAndDefaults.SHOWONLYUNFETCHED = false;
        UserSettingConstantsAndDefaults.SERVERJOBTIMERINTERVALLINSEC = 120;
        Common.UserSettingConstantsAndDefaults = UserSettingConstantsAndDefaults;
        class LocalStorageConstants {
        }
        // General
        LocalStorageConstants.LAST_LANGUAGE_SELECTION = "LastLanguageSelection";
        // Fls Documentation
        LocalStorageConstants.FLS_DOCU_LIST_FILTER_DATE_FROM = "FlsDocuFilterDateFrom";
        LocalStorageConstants.FLS_DOCU_LIST_FILTER_DATE_TO = "FlsDocuFilterDateTo";
        LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE = "FlsDocuHideSignature";
        LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED = "FlsDocuShowOnlyOwnCreated";
        LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES = "FlsDocuShowOnlyOwnCases";
        LocalStorageConstants.FLS_PREVIOUS_STATE = "FlsPreviousState";
        // Fls Summary
        LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING = "FlsSummaryOrderAscending";
        LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH = "FlsSummaryLastSearch";
        // Internal messages
        LocalStorageConstants.MSG_LIST_FILTER_DATE_FROM = "MsgFilterDateFrom";
        LocalStorageConstants.MSG_LIST_FILTER_DATE_TO = "MsgFilterDateTo";
        // Journal
        LocalStorageConstants.JOURNAL_FILTER = "JournalFilter";
        LocalStorageConstants.JOURNAL_LAST_SELECTED_ID = "JournalLastSelectedId";
        LocalStorageConstants.JOURNAL_USE_CURRENT_DATE = "False";
        // Task
        LocalStorageConstants.TASK_LIST_HIDE_FINISHED = "TaskListHideFinished";
        // Appointment
        LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW = "AppointmentTypesToShow";
        // Organisation
        LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID = "OrganisationLastSelectedId";
        //Client Cover Pake
        LocalStorageConstants.CLIENT_COVER = "ClientCover";
        //AZN
        LocalStorageConstants.AZN_PREVIOUS_STATE = "AznPreviousState";
        //Weekplanner
        LocalStorageConstants.WEEKPLANNER_SCROLLPOSITION = "WeekplannerScrollPosition";
        Common.LocalStorageConstants = LocalStorageConstants;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
// ReSharper restore InconsistentNaming
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        ;
        ;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        class HttpBaseProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Common.HttpBaseProvider = HttpBaseProvider;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        class Resolve {
            constructor() {
                console.log('RESOLVE');
                return;
            }
        }
        Common.Resolve = Resolve;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        // Constants for HTTP status codes
        const HTTP_STATUS = {
            OK: 200,
            CREATED: 201,
            UNAUTHORIZED: 401,
            CONFLICT: 409,
            SESSION_EXPIRED: 944
        };
        // Constants for configuration
        const CONFIG = {
            RETRY_DELAY_MS: 250,
            NOTIFICATION_TIMER_MS: 10000,
            WAIT_FOR_TOKEN: 'WaitForToken',
            INVALID_TOKEN_ERROR: 'error="invalid_token"',
            /** Refresh token this many seconds before it expires. */
            TOKEN_REFRESH_BUFFER_SECONDS: 60
        };
        // DOM Element IDs
        const DOM_IDS = {
            SESSION: 'session',
            WRAPPER: 'wrapper',
            LOAD_PLACEHOLDER: 'load-placeholder'
        };
        // Session storage keys
        const STORAGE_KEYS = {
            ACCESS_TOKEN: 'accessToken',
            REFRESH_TOKEN: 'refreshToken',
            STARTED: 'started',
            LOGIN_LOCK: 'loginLock'
        };
        class BaseService {
            /**
             * Creates an instance of BaseService.
             * @param $http - Angular HTTP service
             * @param $q - Angular promise service
             */
            constructor($http, $q) {
                var _a;
                this.$http = $http;
                this.$q = $q;
                /** In-memory cache for getCached results (key => { value, expiresAt, sizeEstimate }). */
                this.getCachedStore = new Map();
                /** Sum of sizeEstimate for all entries (used when maxSizeInBytes is set). */
                this.getCachedTotalBytes = 0;
                /** In-flight promises for getCached to avoid concurrent identical requests (key => promise). */
                this.getCachedInFlight = new Map();
                // State
                this.loggingOut = false;
                this.isLoggedIn = false;
                this.isRefreshing = false;
                this.useExternallySuppliedToken = false;
                /** When non-null, a refresh is in progress; callers wait on this to get the new token. */
                this.refreshPromise = null;
                /** In-flight renewToken() promise so 401 handlers can wait for the same refresh. */
                this.renewTokenInFlight = null;
                const sessionData = this.getSessionData();
                this.MAX_RETRIES = (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.retries) !== null && _a !== void 0 ? _a : 5;
                this.apiData = {
                    url: sessionData.api,
                    key: sessionData.apiKey,
                    refresh: sessionData.apiRefreshKey
                };
                if (!sessionStorage.getItem(STORAGE_KEYS.STARTED)) {
                    sessionStorage.clear();
                    this.setApiData(this.apiData.key, this.apiData.refresh);
                    sessionStorage.setItem(STORAGE_KEYS.STARTED, 'true');
                }
                this.webClientBasePath = sessionData.baseUrl;
                this.languageId = sessionData.userLanguageId;
                this.useExternallySuppliedToken = this.checkExternalTokenMode();
            }
            // ============================================
            // Public API
            // ============================================
            api() {
                return this.apiData;
            }
            displayNotifications(messages, title, type, icon) {
                if (messages === null)
                    return;
                const $qui = new qmwcUI();
                for (const element of messages) {
                    console.log(element);
                    const message = element.replace('Bad Request: ', '');
                    $qui.notify({
                        message,
                        title,
                        icon,
                        status: type,
                        timer: CONFIG.NOTIFICATION_TIMER_MS
                    });
                }
            }
            getResourceList(searchString = '', onlyActive = true) {
                return this.get('/Resource', { searchString, onlyActive });
            }
            getInstituteList(searchString = '', onlyActive = true) {
                return this.get('/Institute', { searchString, onlyActive });
            }
            getVehicleList(searchString = '') {
                return this.get('/Resource/Vehicle', { listSearch: searchString });
            }
            // ============================================
            // Protected HTTP Methods
            // ============================================
            get(path, params = {}, successDataManipulation, options) {
                return this.performGetRequest(false, path, params, successDataManipulation, 1, this.$q.defer(), options);
            }
            getPagination(path, params = {}, successDataManipulation, options) {
                return this.performGetRequest(false, path, params, successDataManipulation, 1, this.$q.defer(), options);
            }
            getItem(path, params = {}, successDataManipulation, options) {
                return this.performGetRequest(false, path, params, successDataManipulation, 1, this.$q.defer(), options);
            }
            cachedGetItem(path, params = {}, successDataManipulation, options) {
                return this.performGetRequest(true, path, params, successDataManipulation, 1, this.$q.defer(), options);
            }
            uncachedGet(path, params = {}, successDataManipulation, options) {
                return this.performGetRequest(false, path, params, successDataManipulation, 1, this.$q.defer(), options);
            }
            cachedGet(path, params = {}, successDataManipulation, options) {
                return this.performGetRequest(true, path, params, successDataManipulation, 1, this.$q.defer(), options);
            }
            /** Estimates size in bytes for cache eviction (string length or JSON.stringify length). */
            getCachedEstimateSize(value) {
                if (value == null)
                    return 0;
                if (typeof value === 'string')
                    return value.length;
                try {
                    return JSON.stringify(value).length;
                }
                catch (_a) {
                    return 0;
                }
            }
            /** Evicts oldest cache entry (first in Map order). Returns true if one was evicted. */
            getCachedEvictOldest() {
                const firstKey = this.getCachedStore.keys().next().value;
                if (firstKey === undefined)
                    return false;
                const entry = this.getCachedStore.get(firstKey);
                this.getCachedStore.delete(firstKey);
                if (entry !== undefined)
                    this.getCachedTotalBytes -= entry.sizeEstimate;
                return true;
            }
            /**
             * Returns a promise from cache if present and not expired (TTL), or deduplicates in-flight request for the same key.
             * Otherwise calls fetch(), caches the result and returns it.
             * Cache is cleared on logout (does not survive login of a different user).
             * @param key - Unique cache key (e.g. JSON.stringify(params))
             * @param fetch - Function that returns the promise to execute (e.g. () => this.getItem(...))
             * @param options - Optional maxSize, ttlMs (default 3 min), maxSizeInBytes (evict oldest when total bytes exceed)
             */
            getCached(key, fetch, options) {
                var _a, _b;
                const now = Date.now();
                const ttlMs = (_a = options === null || options === void 0 ? void 0 : options.ttlMs) !== null && _a !== void 0 ? _a : BaseService.GET_CACHED_DEFAULT_TTL_MS;
                const entry = this.getCachedStore.get(key);
                if (entry !== undefined) {
                    if (now < entry.expiresAt) {
                        return this.$q.resolve(entry.value);
                    }
                    this.getCachedStore.delete(key);
                    this.getCachedTotalBytes -= entry.sizeEstimate;
                }
                const inFlight = this.getCachedInFlight.get(key);
                if (inFlight) {
                    return inFlight;
                }
                const maxSize = (_b = options === null || options === void 0 ? void 0 : options.maxSize) !== null && _b !== void 0 ? _b : BaseService.GET_CACHED_DEFAULT_MAX_SIZE;
                const maxSizeInBytes = options === null || options === void 0 ? void 0 : options.maxSizeInBytes;
                const promise = fetch().then((data) => {
                    const sizeEstimate = this.getCachedEstimateSize(data);
                    while (this.getCachedStore.size >= maxSize) {
                        this.getCachedEvictOldest();
                    }
                    if (maxSizeInBytes !== undefined && maxSizeInBytes > 0) {
                        while (this.getCachedTotalBytes + sizeEstimate > maxSizeInBytes && this.getCachedStore.size > 0) {
                            this.getCachedEvictOldest();
                        }
                    }
                    this.getCachedStore.set(key, { value: data, expiresAt: Date.now() + ttlMs, sizeEstimate });
                    this.getCachedTotalBytes += sizeEstimate;
                    this.getCachedInFlight.delete(key);
                    return data;
                }).catch((err) => {
                    this.getCachedInFlight.delete(key);
                    throw err;
                });
                this.getCachedInFlight.set(key, promise);
                return promise;
            }
            /** Returns a cached value when present and not expired; otherwise undefined. */
            peekCached(key) {
                const entry = this.getCachedStore.get(key);
                if (entry === undefined) {
                    return undefined;
                }
                if (Date.now() >= entry.expiresAt) {
                    this.getCachedStore.delete(key);
                    this.getCachedTotalBytes -= entry.sizeEstimate;
                    return undefined;
                }
                return entry.value;
            }
            /** Stores or replaces a cache entry and refreshes its TTL. */
            setCached(key, value, options) {
                var _a, _b;
                const ttlMs = (_a = options === null || options === void 0 ? void 0 : options.ttlMs) !== null && _a !== void 0 ? _a : BaseService.GET_CACHED_DEFAULT_TTL_MS;
                const existing = this.getCachedStore.get(key);
                if (existing !== undefined) {
                    this.getCachedTotalBytes -= existing.sizeEstimate;
                    this.getCachedStore.delete(key);
                }
                const sizeEstimate = this.getCachedEstimateSize(value);
                const maxSize = (_b = options === null || options === void 0 ? void 0 : options.maxSize) !== null && _b !== void 0 ? _b : BaseService.GET_CACHED_DEFAULT_MAX_SIZE;
                const maxSizeInBytes = options === null || options === void 0 ? void 0 : options.maxSizeInBytes;
                while (this.getCachedStore.size >= maxSize) {
                    this.getCachedEvictOldest();
                }
                if (maxSizeInBytes !== undefined && maxSizeInBytes > 0) {
                    while (this.getCachedTotalBytes + sizeEstimate > maxSizeInBytes && this.getCachedStore.size > 0) {
                        this.getCachedEvictOldest();
                    }
                }
                this.getCachedStore.set(key, {
                    value,
                    expiresAt: Date.now() + ttlMs,
                    sizeEstimate
                });
                this.getCachedTotalBytes += sizeEstimate;
            }
            post(path, object, options) {
                return this.performMutationRequest('POST', path, object, {}, options);
            }
            put(path, object) {
                return this.putParameter(path, {}, object);
            }
            putParameter(path, params = {}, object) {
                return this.performMutationRequest('PUT', path, object, params);
            }
            delete(path) {
                return this.performMutationRequest('DELETE', path, undefined);
            }
            performLogout() {
                this.logout();
            }
            getRefreshToken() {
                let result = sessionStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
                if (!result || result.trim() === '' || result.trim() === CONFIG.INVALID_TOKEN_ERROR) {
                    result = this.getSessionData().apiRefreshKey;
                }
                return result;
            }
            getAccessToken() {
                var _a, _b, _c, _d;
                if (localStorage.getItem(STORAGE_KEYS.LOGIN_LOCK) === 'active') {
                    return '';
                }
                this.useExternallySuppliedToken = this.checkExternalTokenMode();
                if (this.useExternallySuppliedToken) {
                    const injectedToken = (_a = window.te) !== null && _a !== void 0 ? _a : '';
                    if ((injectedToken === null || injectedToken === void 0 ? void 0 : injectedToken.length) && injectedToken.trim() !== CONFIG.INVALID_TOKEN_ERROR) {
                        return injectedToken;
                    }
                }
                let result = sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
                if (!(result === null || result === void 0 ? void 0 : result.length) || result.trim() === CONFIG.INVALID_TOKEN_ERROR) {
                    result = (_c = (_b = document.getElementById(DOM_IDS.SESSION)) === null || _b === void 0 ? void 0 : _b.getAttribute('data-api-key')) !== null && _c !== void 0 ? _c : '';
                }
                if (!(result === null || result === void 0 ? void 0 : result.length) || result.trim() === CONFIG.INVALID_TOKEN_ERROR) {
                    result = (_d = window.te) !== null && _d !== void 0 ? _d : '';
                }
                if (this.useExternallySuppliedToken && !(result === null || result === void 0 ? void 0 : result.length)) {
                    return CONFIG.WAIT_FOR_TOKEN;
                }
                return result;
            }
            /**
             * Returns a promise that resolves with a valid access token, refreshing if the current token
             * is expired or expires within TOKEN_REFRESH_BUFFER_SECONDS. While a refresh is in flight,
             * all callers wait on the same refresh and then receive the new token.
             */
            ensureValidAccessToken() {
                const token = this.getAccessToken();
                if (token === CONFIG.WAIT_FOR_TOKEN || (this.useExternallySuppliedToken && !(token === null || token === void 0 ? void 0 : token.length))) {
                    return this.$q.resolve(token);
                }
                if (!(token === null || token === void 0 ? void 0 : token.length) || token.trim() === CONFIG.INVALID_TOKEN_ERROR) {
                    return this.$q.resolve(token);
                }
                // Embedded via LegacyClientIntegration: tokens are injected by the shell (postMessage), not refreshed here.
                if (this.isExternalTokenSupplyMode()) {
                    return this.$q.resolve(token);
                }
                if (!this.isTokenExpiredOrExpiringSoon(token)) {
                    return this.$q.resolve(token);
                }
                if (this.refreshPromise !== null) {
                    return this.refreshPromise;
                }
                this.refreshPromise = this.renewToken()
                    .then((response) => {
                    if (response === 'ERROR') {
                        return this.$q.reject(response);
                    }
                    return this.getAccessToken();
                })
                    .finally(() => {
                    this.refreshPromise = null;
                });
                return this.refreshPromise;
            }
            renewToken() {
                var _a, _b;
                // Embedded via LegacyClientIntegration: tokens are injected by the shell (postMessage), not refreshed here.
                if (this.isExternalTokenSupplyMode()) {
                    return (_a = this.renewTokenInFlight) !== null && _a !== void 0 ? _a : this.$q.resolve('');
                }
                const token = this.getRefreshToken();
                if (!(token === null || token === void 0 ? void 0 : token.length)) {
                    return this.$q.reject();
                }
                if (this.isRefreshing) {
                    return (_b = this.renewTokenInFlight) !== null && _b !== void 0 ? _b : this.$q.resolve('');
                }
                this.isRefreshing = true;
                const urlTokenRefresh = `${this.webClientBasePath}Token`;
                const dbConnection = this.getSessionData().dbConnection;
                const promise = this.$http({
                    url: urlTokenRefresh,
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({ refreshToken: token, dbConnection: dbConnection })
                }).then((response) => {
                    this.isRefreshing = false;
                    if (response.status === HTTP_STATUS.OK && response.data.accessToken && response.data.refreshToken) {
                        this.setApiData(response.data.accessToken, response.data.refreshToken);
                        return { accessKey: response.data.accessToken, refreshKey: response.data.refreshToken };
                    }
                    if (response.status === HTTP_STATUS.CONFLICT) {
                        return { accessKey: this.getAccessToken(), refreshKey: this.getRefreshToken() };
                    }
                    sessionStorage.clear();
                    this.logout();
                    return 'ERROR';
                }).catch((e) => {
                    this.isRefreshing = false;
                    if ((e === null || e === void 0 ? void 0 : e.status) === HTTP_STATUS.CONFLICT) {
                        return { accessKey: this.getAccessToken(), refreshKey: this.getRefreshToken() };
                    }
                    sessionStorage.clear();
                    this.logout();
                    return 'ERROR';
                }).finally(() => {
                    this.renewTokenInFlight = null;
                });
                this.renewTokenInFlight = promise;
                return promise;
            }
            // ============================================
            // Private Methods - HTTP Request Handling
            // ============================================
            performGetRequest(cached, path, params = {}, successDataManipulation, retries = 1, deferred = this.$q.defer(), options) {
                if (this.shouldRejectRequest(deferred)) {
                    return deferred.promise;
                }
                this.withValidToken(() => {
                    deferred.promise = this.performGetRequest(cached, path, params, successDataManipulation, retries, deferred, options);
                }).then((token) => {
                    if (token === null)
                        return;
                    this.$http({
                        url: this.apiData.url + path,
                        method: 'GET',
                        cache: cached,
                        headers: this.getAuthHeaders(token),
                        params: params
                    }).then((response) => {
                        if (this.handleSessionExpired(response.status))
                            return;
                        if (this.handleUnauthorized(response.status, deferred, () => {
                            deferred.promise = this.performGetRequest(cached, path, params, successDataManipulation, retries, deferred, options);
                        }))
                            return;
                        if (successDataManipulation) {
                            response.data = successDataManipulation(response.data);
                        }
                        deferred.resolve(response.data);
                        this.isLoggedIn = true;
                        if (path.indexOf('languages') === -1 && !this.loggingOut) {
                            this.showMainContent();
                        }
                    }).catch((response) => {
                        var _a;
                        console.log('error in base service:', response);
                        if (this.handleSessionExpired(response.status))
                            return;
                        if (this.handleUnauthorized(response.status, deferred, () => {
                            deferred.promise = this.performGetRequest(cached, path, params, successDataManipulation, retries, deferred, options);
                        }))
                            return;
                        const status = response === null || response === void 0 ? void 0 : response.status;
                        if ((options === null || options === void 0 ? void 0 : options.silentOnClientError) && status >= 400 && status < 500) {
                            deferred.resolve(null);
                            return;
                        }
                        if (retries < this.MAX_RETRIES) {
                            this.performGetRequest(cached, path, params, successDataManipulation, retries + 1, deferred, options);
                        }
                        else {
                            this.notification(response, response.status);
                            deferred.reject((_a = response.data) !== null && _a !== void 0 ? _a : response.status);
                        }
                    });
                }).catch((err) => {
                    if (err === 'ERROR') {
                        this.logout();
                    }
                    else {
                        deferred.reject(err);
                    }
                });
                return deferred.promise;
            }
            performMutationRequest(method, path, object, params = {}, requestOptions, deferred = this.$q.defer()) {
                if (this.shouldRejectRequest(deferred)) {
                    return deferred.promise;
                }
                this.withValidToken(() => {
                    deferred.promise = this.performMutationRequest(method, path, object, params, requestOptions);
                }).then((token) => {
                    if (token === null)
                        return;
                    const config = {
                        url: this.apiData.url + path,
                        method: method,
                        headers: this.getAuthHeaders(token),
                        params: method === 'PUT' ? params : undefined,
                        data: object
                    };
                    if (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeout) {
                        config.timeout = requestOptions.timeout;
                    }
                    this.$http(config).then((response) => {
                        const isSuccess = method === 'POST'
                            ? (response.status === HTTP_STATUS.CREATED || response.status === HTTP_STATUS.OK)
                            : response.status === HTTP_STATUS.OK;
                        if (isSuccess) {
                            deferred.resolve(response.data);
                        }
                        else {
                            this.handleMutationError(response, deferred, method, path, object, params, requestOptions);
                        }
                    }).catch((response) => {
                        this.handleMutationError(response, deferred, method, path, object, params, requestOptions);
                    });
                }).catch((err) => {
                    if (err === 'ERROR') {
                        this.logout();
                    }
                    else {
                        deferred.reject(err);
                    }
                });
                return deferred.promise;
            }
            handleMutationError(response, deferred, method, path, object, params = {}, requestOptions) {
                if (response != null && response.status === -1) {
                    deferred.reject(response.data);
                    return;
                }
                if (this.handleUnauthorized(response.status, deferred, () => {
                    deferred.promise = this.performMutationRequest(method, path, object, params, requestOptions);
                }))
                    return;
                if (this.handleSessionExpired(response.status))
                    return;
                this.notification(response, response.status);
                deferred.reject(response.data);
            }
            // ============================================
            // Private Methods - Authentication
            // ============================================
            getAuthHeaders(token) {
                return {
                    'Authorization': `Bearer ${token}`,
                    'x-language-id': `${this.languageId}`
                };
            }
            /**
             * Reads exp (expiration) from JWT payload in seconds since epoch. Returns null if not a JWT or no exp.
             */
            getTokenExpirationSeconds(token) {
                if (!token || token.indexOf('.') < 0)
                    return null;
                try {
                    const parts = token.split('.');
                    if (parts.length !== 3)
                        return null;
                    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
                    const decoded = JSON.parse(decodeURIComponent(atob(payload)
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')));
                    return typeof decoded.exp === 'number' ? decoded.exp : null;
                }
                catch (_a) {
                    return null;
                }
            }
            /** True if token is expired or expires within bufferSeconds (default TOKEN_REFRESH_BUFFER_SECONDS). */
            isTokenExpiredOrExpiringSoon(token, bufferSeconds = CONFIG.TOKEN_REFRESH_BUFFER_SECONDS) {
                const expSec = this.getTokenExpirationSeconds(token);
                if (expSec == null)
                    return false; // not a JWT or no exp: do not force refresh
                const nowSec = Math.floor(Date.now() / 1000);
                return expSec <= nowSec + bufferSeconds;
            }
            shouldRejectRequest(deferred) {
                if (this.loggingOut) {
                    deferred.reject('logging out');
                    this.logout();
                    return true;
                }
                return false;
            }
            shouldWaitForToken(token) {
                return this.isRefreshing || token === CONFIG.WAIT_FOR_TOKEN;
            }
            /**
             * Ensures a valid token, schedules retry when waiting for token; returns token or null if retry was scheduled.
             * Caller must run the actual request in .then(token => { if (token !== null) { ... } }) and handle .catch for refresh errors.
             */
            withValidToken(retry) {
                return this.ensureValidAccessToken().then((token) => {
                    if (this.shouldWaitForToken(token)) {
                        this.scheduleRetry(retry);
                        return null;
                    }
                    return token;
                });
            }
            scheduleRetry(callback) {
                setTimeout(callback, CONFIG.RETRY_DELAY_MS);
            }
            handleSessionExpired(status) {
                if (status === HTTP_STATUS.SESSION_EXPIRED) {
                    this.logout();
                    return true;
                }
                return false;
            }
            /** On 401: no token → logout. Token present → try refresh (or wait for in-flight refresh); on success retry request, on failure logout. */
            handleUnauthorized(status, deferred, retryCallback) {
                if (status !== HTTP_STATUS.UNAUTHORIZED)
                    return false;
                const token = this.getAccessToken();
                const noToken = !(token === null || token === void 0 ? void 0 : token.length) || token.trim() === CONFIG.INVALID_TOKEN_ERROR || token === CONFIG.WAIT_FOR_TOKEN;
                if (noToken) {
                    this.logout();
                    return true;
                }
                if (this.isExternalTokenSupplyMode()) {
                    if (retryCallback) {
                        this.scheduleRetry(retryCallback);
                    }
                    else {
                        deferred.reject({ status: HTTP_STATUS.UNAUTHORIZED, data: null });
                    }
                    return true;
                }
                const doRetry = () => {
                    if (retryCallback)
                        retryCallback();
                    else
                        deferred.reject({ status: HTTP_STATUS.UNAUTHORIZED, data: null });
                };
                if (this.refreshPromise !== null) {
                    this.refreshPromise.then(doRetry).catch(() => this.logout());
                    return true;
                }
                this.renewToken().then((response) => {
                    if (response === 'ERROR') {
                        this.logout();
                    }
                    else if (response !== '') {
                        doRetry();
                    }
                    // response === '' means refresh was already in progress; refreshPromise will be used by the caller that started it
                }).catch(() => {
                    this.logout();
                });
                return true;
            }
            setApiData(accessToken, refreshToken) {
                sessionStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
                sessionStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
                const sessionElement = document.getElementById(DOM_IDS.SESSION);
                if (sessionElement) {
                    sessionElement.setAttribute('data-api-key', accessToken);
                    sessionElement.setAttribute('data-api-refresh-key', refreshToken);
                }
                this.apiData.refresh = refreshToken;
                this.apiData.key = accessToken;
            }
            // ============================================
            // Private Methods - Session & Logout
            // ============================================
            logout(noReturn = false) {
                if (this.loggingOut || window.clientExchange) {
                    return;
                }
                let hash = '';
                if (location.hash.length > 1 && !noReturn) {
                    hash = location.hash.substring(2);
                }
                this.loggingOut = true;
                this.refreshPromise = null;
                this.renewTokenInFlight = null;
                this.getCachedStore.clear();
                this.getCachedTotalBytes = 0;
                this.getCachedInFlight.clear();
                const params = new URLSearchParams();
                params.set('returnUrl', hash);
                const dbConnection = this.getSessionData().dbConnection;
                if (dbConnection) {
                    params.set('dbConnectionString', dbConnection);
                }
                const url = `${this.webClientBasePath}Logout?${params.toString()}`;
                sessionStorage.clear();
                const currentUrl = location.href.toLowerCase();
                const loginUrl = `${this.webClientBasePath}Login`.toLowerCase();
                const logoutUrl = `${this.webClientBasePath}Logout`.toLowerCase();
                if (!currentUrl.startsWith(loginUrl) && !currentUrl.startsWith(logoutUrl)) {
                    location.href = url;
                }
                this.hideMainContent();
            }
            getSessionData() {
                var _a;
                return (_a = $('#session').data()) !== null && _a !== void 0 ? _a : {};
            }
            /** True when embedded (hideNav / client exchange); access token comes from the parent shell, not PUT /Token. */
            isExternalTokenSupplyMode() {
                return !!window.clientExchange || $('body').hasClass('hideNav');
            }
            checkExternalTokenMode() {
                return this.isExternalTokenSupplyMode();
            }
            // ============================================
            // Private Methods - UI
            // ============================================
            showMainContent() {
                var _a, _b;
                (_a = document.getElementById(DOM_IDS.WRAPPER)) === null || _a === void 0 ? void 0 : _a.removeAttribute('style');
                (_b = document.getElementById(DOM_IDS.LOAD_PLACEHOLDER)) === null || _b === void 0 ? void 0 : _b.setAttribute('style', 'display: none;');
            }
            hideMainContent() {
                var _a, _b;
                (_a = document.getElementById(DOM_IDS.LOAD_PLACEHOLDER)) === null || _a === void 0 ? void 0 : _a.removeAttribute('style');
                (_b = document.getElementById(DOM_IDS.WRAPPER)) === null || _b === void 0 ? void 0 : _b.setAttribute('style', 'display: none;');
            }
            // ============================================
            // Private Methods - Error Handling
            // ============================================
            notification(response, status) {
                var _a, _b;
                if (!this.isLoggedIn || this.loggingOut)
                    return;
                console.warn('Error', response);
                if ((response === null || response === void 0 ? void 0 : response.data) == null && status !== HTTP_STATUS.UNAUTHORIZED) {
                    this.displayNotifications(['Ein Kommunikationsfehler ist aufgetreten'], 'Fehler', 'warning', 'qm-icon-error');
                }
                const data = response === null || response === void 0 ? void 0 : response.data;
                if (data == null)
                    return;
                // Handle both camelCase and PascalCase property names
                const globalErrors = (_a = data.globalErrors) !== null && _a !== void 0 ? _a : data.GlobalErrors;
                const fieldErrors = (_b = data.fieldErrors) !== null && _b !== void 0 ? _b : data.FieldErrors;
                if (globalErrors) {
                    this.displayNotifications(this.formatErrors(response, globalErrors), 'Fehler', 'warning', 'qm-icon-error');
                }
                if (fieldErrors) {
                    this.displayNotifications(this.formatErrors(response, fieldErrors), 'Hinweis', 'warning', 'qm-icon-information');
                }
            }
            formatErrors(response, errorList) {
                if (!response || !errorList)
                    return [];
                const result = [];
                if (!Array.isArray(errorList)) {
                    // errorList is a Record<string, string[]>
                    for (const key in errorList) {
                        if (Array.isArray(errorList[key])) {
                            result.push(...errorList[key]);
                        }
                    }
                }
                else {
                    // errorList is string[]
                    for (const element of errorList) {
                        result.push(`${response.statusText}: ${element}`);
                    }
                }
                return result;
            }
        }
        BaseService.GET_CACHED_DEFAULT_MAX_SIZE = 50;
        BaseService.GET_CACHED_DEFAULT_TTL_MS = 3 * 60 * 1000; // 3 minutes
        BaseService.$inject = ['$http', '$q'];
        Common.BaseService = BaseService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        class UserInterface {
            /**
             * Creates an instance of UserInterface.
             *
             * @memberOf UserInterface
             */
            constructor() {
                this.successNote = {
                    message: "Eintrag wurde gespeichert!",
                    title: "Erfolgreich",
                    icon: "qm-icon-information",
                    status: "default",
                    timer: 3500
                };
                this.deleteNote = {
                    message: "Eintrag wurde gelöscht!",
                    title: "Erfolgreich",
                    icon: "qm-icon-delete",
                    status: "warning",
                    timer: 3500
                };
                this.deleteNotes = {
                    message: "Einträge wurden gelöscht!",
                    title: "Erfolgreich",
                    icon: "qm-icon-delete",
                    status: "warning",
                    timer: 3500
                };
                this.downloadNote = {
                    message: "Download wird vorbereitet!",
                    title: "Bitte warten",
                    icon: "qm-icon-information",
                    status: "default",
                    timer: 3500
                };
                this.promptOptions = {
                    delete: {
                        title: "Termine",
                        icon: "qm-icon-calendar_7",
                        text: 'Wollen Sie den Eintrag wirklich löschen?'
                    },
                    updateCalendar: {
                        title: "Serientermin",
                        icon: "qm-icon-calendar_7",
                        text: 'Serientermin bearbeiten',
                        fields: [{ select: ["a", "b"] }]
                    }
                };
            }
            /**
             *
             *
             * @protected
             * @returns {boolean}
             *
             * @memberOf UserInterface
             */
            isMobile() { return QMC.Common.Constants.IS_MOBILE; }
            ;
            /**
                             * Returns a qmc calendar event which can be shown in the calendar
                             * @param appointment The appointment object
                             */
            createCalendarEvent(appointment, randomId = null, typeDefaults = []) {
                const event = {};
                event.id = appointment.objectId;
                event.objectId = appointment.objectId;
                event.dateFrom = moment(appointment.dateFrom).format('YYYY-MM-DD');
                event.mid = appointment.mainAppointmentId;
                event.title = appointment.title;
                event.description = appointment.description;
                event.start = moment(appointment.dateFrom);
                event.end = moment(appointment.dateTo);
                event.participantObjectId = appointment.participantObjectId;
                event.allDay = appointment.isAllDay;
                event.isFinished = appointment.isFinished;
                event.isPrivate = appointment.isPrivate;
                event.isRecurring = appointment.isRecurring;
                event.recurrenceSettings = appointment.recurrenceSettings;
                event.isTypeAppointment = appointment.isTypeAppointment;
                event.isTypeFlsDocumentation = appointment.isTypeFlsDocumentation;
                event.appointmentType = appointment.appointmentTypeId;
                event.mainAppointmentId = appointment.mainAppointmentId;
                event.isTypeTask = appointment.isTypeTask;
                event.editable = false;
                event.color = appointment.colorHtml;
                event.className = "col-" + appointment.colorHtml.replace('#', '');
                event.iconCode = "";
                event.textColor = this.getTextColor(appointment.colorHtml);
                event.permissions = appointment.permissions;
                event.permFlag = appointment.permFlag;
                if (event.isFinished)
                    event.iconCode += "<i class='qm-icon-check'></i> ";
                if (event.isPrivate)
                    event.iconCode += "<i class='qm-icon-lock'></i> ";
                if (event.isRecurring)
                    event.iconCode += "<i class='fa fa-refresh'></i> ";
                if (event.isDeleted)
                    event.iconCode += "<i class='qm-icon-garbage_can'></i> ";
                if (appointment.appointmentTypeId === 401000)
                    event.editable = true;
                if (appointment.appointmentTypeId === 401008)
                    event.iconCode += "<i class='qm-icon-earth'></i> ";
                if (randomId)
                    event.id = randomId;
                if (typeDefaults.length > 0) {
                    const defaultColor = typeDefaults.filter(x => x.typeId == appointment.appointmentTypeId)[0];
                    if (defaultColor) {
                        event.borderColor = defaultColor.colorHtml;
                        event.backgroundColor = appointment.colorHtml;
                    }
                }
                return event;
            }
            getTextColor(color) {
                const r = parseInt('0x' + color.substr(1, 2));
                const g = parseInt('0x' + color.substr(3, 2));
                const b = parseInt('0x' + color.substr(5, 2));
                const hsp = (r * 299 + g * 587 + b * 114) / 1000;
                // Using the HSP value, determine whether the color is light or dark
                if (hsp > 123) {
                    //light color, return black
                    return '#000000';
                }
                else {
                    //dark color return white
                    return '#FFFFFF';
                }
            }
            /**
             * Select value text pair from a dataSet
             *
             * @param {*} dataSet
             * @param {*} filters
             * @returns {Common.ISelectListItem[]}
             *
             * @memberOf UserInterface
             */
            select(dataSet, filters) {
                var filterChache = filters.text.split(',');
                var options = dataSet.map(function (obj) {
                    if (filterChache.length > 1)
                        return {
                            text: obj[filterChache[0]] + ', ' + obj[filterChache[0]],
                            value: obj[filters.value]
                        };
                    return {
                        text: obj[filters.text],
                        value: obj[filters.value]
                    };
                });
                return options;
            }
            /**
             * Notification
             *
             * @param {any} note
             *
             * @memberOf UserInterface
             */
            notify(note, message) {
                var timestamp = new Date().getTime();
                var randomNum = timestamp + Math.floor((Math.random() * 1000) + 1);
                var _timer = 1500, _overlay = 0;
                if (note.hasOwnProperty("timer"))
                    _timer = note.timer;
                if (note.hasOwnProperty("overlay"))
                    _overlay = note.overlay;
                setTimeout(showNotify, _overlay);
                setTimeout(hideNotify, _timer);
                function showNotify() {
                    $("#qm-notification")
                        .prepend("<div id='notify-" + randomNum + "' class='animated slideInDown qm-msg " + note.status + "'><i class='" + note.icon + "'></i><span class='title'>" + note.title + "</span><span class='text'>" + note.message + "</span></div>");
                    setTimeout(function () {
                        if (QMC.Common.Constants.IS_MOBILE)
                            $("#notify-" + randomNum).css("margin-left", "220px");
                    }, 200);
                    $("#notify-" + randomNum).click(function () {
                        $(this).addClass("slideOutUp");
                        var modal = this;
                        setTimeout(function () {
                            $(modal).remove();
                        }, 800);
                    });
                }
                function hideNotify() {
                    $("#notify-" + randomNum).addClass("slideOutUp");
                    setTimeout(function () {
                        $("#notify-" + randomNum).remove();
                    }, 800);
                }
            }
            /**
             * Add time to date
             *
             * @param {Date} date
             * @param {Date} time
             * @returns {Date}
             *
             * @memberOf UserInterface
             */
            addTimeToDate(date, time) {
                date = moment(date).toDate();
                time = moment(time).toDate();
                date.setHours(time.getHours());
                date.setMinutes(time.getMinutes());
                return moment(date).toDate();
            }
            /**
             * get the duration between two dates in hours
             *
             * @param {Date} start
             * @param {Date} end
             * @returns {number}
             *
             * @memberOf UserInterface
             */
            getDurationInHours(start, end) {
                /**
                 * Updated Version
                 */
                //  var duration = moment.duration(moment(end).diff(moment(start)));
                //  return duration.asHours();
                var a = moment(start).year(1).month(1).day(1);
                var b = moment(end).year(1).month(1).day(1);
                var duration = moment.duration(b.diff(a));
                return duration.asHours();
            }
            /**
             * get the duration between two dates in days
             *
             * @param {Date} start
             * @param {Date} end
             * @returns {number}
             *
             * @memberOf UserInterface
             */
            getDurationInDays(start, end) {
                var a = moment(start).hours(0).minute(0).seconds(0);
                var b = moment(end).hours(0).minute(0).seconds(0);
                var duration = moment.duration(b.diff(a));
                return duration.asDays();
            }
            /**
             * round time by a given part
             *
             * @param {Date} time
             * @param {number} part
             * @returns {Date}
             *
             * @memberOf UserInterface
             */
            roundTime(time, part) {
                var rounded = Math.round(moment(time).minute() / part) * part;
                var d = new Date(time);
                d.setMinutes(rounded);
                d.setSeconds(0);
                return d;
            }
            getDisplayedPropertiesFromSchema(schema) {
                const result = [];
                for (const prop in schema.table) {
                    result.push(schema.table[prop].label);
                }
                return result.filter(x => x); //Get rid of invalid values (just to be sure)
            }
        }
        Common.UserInterface = UserInterface;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        class Filter {
            constructor() { }
            static Humanize(userService) {
                const settingName = 'HUMANIZETIME';
                const getNavigatorLanguage = () => { var _a; return ((_a = navigator.languages) === null || _a === void 0 ? void 0 : _a.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'de'; };
                console.log("LANG", getNavigatorLanguage());
                moment.locale(getNavigatorLanguage());
                function createString(date, setting) {
                    if (setting < 0)
                        return moment(date).format('DD.MM.YYYY HH:mm');
                    else if (setting === 0)
                        return moment(date).fromNow();
                    else {
                        if (moment(date).isBefore(moment().add(-setting, 'h')))
                            return moment(date).format('DD.MM.YYYY HH:mm');
                        return moment(date).fromNow();
                    }
                }
                filterStub.$stateful = true;
                function filterStub(date) {
                    const fromStorage = sessionStorage.getItem(settingName);
                    if (!fromStorage) {
                        sessionStorage.setItem(settingName, 'loading');
                        userService.getUserSettings([settingName]).then((data) => {
                            const value = parseInt(data[0].value && data[0].value.length > 0 ? data[0].value : '24');
                            sessionStorage.setItem(settingName, value + '');
                            return '';
                        });
                        return '';
                    }
                    else if (fromStorage === 'loading') {
                        return '';
                    }
                    return createString(date, parseInt(fromStorage));
                }
                return filterStub;
            }
            static NotEmpty() {
                return function (string) {
                    if (string == null)
                        return;
                    return string.length === 0 ? "-" : string;
                };
            }
            static FullNameFormat() {
                return function (string) {
                    if (typeof string != 'string')
                        return string;
                    if (string.indexOf(',') > 1)
                        return string.split(',')[1] + " " + string.split(',')[0];
                    return string;
                };
            }
            static Shortner() {
                return function (string) {
                    if (string.length > 20)
                        return string.substring(0, 8) + "..." + string.substring(string.length - 8, string.length);
                    else
                        return string;
                };
            }
            static Html($sce) {
                return function (val) {
                    return $sce.trustAsHtml(val);
                };
            }
            static DisplayFormat($sce) {
                return function (item, format) {
                    if (item == undefined)
                        return;
                    switch (format) {
                        case 'heading': return item;
                        case 'boolean': return item ? "Ja" : "Nein"; // ICONS
                        case 'number': return item.toString(); // try it
                        case 'string': return item;
                        case 'date': return moment(item).format('DD.MM.YYYY');
                        case 'multiple':
                            var html = "<ul>";
                            for (var i in item)
                                html += '<li>' + item[i] + '</li>';
                            return $sce.trustAsHtml(html + "</ul>");
                        case 'description': return $sce.trustAsHtml(item);
                        default: return item;
                    }
                };
            }
            static StartFrom() {
                return function (input, start) {
                    if (input == (null || undefined) || start == (null || undefined))
                        return [];
                    start = +start; //parse to int
                    return input.slice(start);
                };
            }
        }
        Common.Filter = Filter;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        class SupportPlanHelper {
            static getActiveSupportPlanPhaseColor(phaseState) {
                switch (phaseState) {
                    case 'Exceeded':
                        return 'active-phase-content-red';
                    case 'Warning':
                    case 'Canceled':
                        return 'active-phase-content-yellow';
                    case 'CompletedEnded':
                    case 'CompletedContinued':
                    case 'IsDone':
                    default:
                        return 'active-phase-content-green';
                }
            }
            static getActiveSupportPlanPhase(phase, lng) {
                if (lng) {
                    switch (phase) {
                        case 'Planning':
                            return lng.translate(20016245, 'Planung');
                        case 'ExecutingPhase':
                            return lng.translate(20016246, 'Durchführungsphase');
                        case 'PeriodEvaluation':
                            return lng.translate(20016247, 'Zwischenevaluierung');
                        case 'FinalEvaluation':
                            return lng.translate(20016248, 'Abschlussevaluierung');
                        case 'CareReport':
                            return lng.translate(20016249, 'Berichtsphase');
                        case 'CareSummarization':
                            return lng.translate(20016250, 'Zusammenfassung');
                        case 'CompletedCareplan':
                            return lng.translate(20016251, 'Beendeter Betreuungsplan');
                        default:
                            return '';
                    }
                }
            }
            static getActiveSupportPlanPhaseState(phaseState, lng) {
                let result = '';
                switch (phaseState) {
                    case 'Ongoing':
                        result = lng.translate(20016252, 'Laufend');
                        break;
                    case 'CompletedEnded':
                        result = lng.translate(20016253, 'Beendet mit Entlassung');
                        break;
                    case 'CompletedContinued':
                        result = lng.translate(20016254, 'Beendet mit Fortschreibung');
                        break;
                    case 'Canceled':
                        result = lng.translate(20016255, 'Abgebrochen');
                        break;
                    default:
                        result = '';
                        break;
                }
                return result;
            }
            static getActiveSupportPlanPhaseText(planPhase, lng, $qui) {
                let result = '';
                let today = new Date();
                let dateEnd = planPhase.dateEnd;
                let dateEndStr = moment(dateEnd).format('DD.MM.YYYY');
                //check Phase und setze Text
                switch (planPhase.phase) {
                    case 'Planning':
                    case 'Planung':
                        if (moment(today) > moment(dateEnd))
                            result = $qui.formatString(lng.translate(20016256, 'Zwischenplanung hätte bis zum {0} angelegt werden müssen'), dateEndStr);
                        else
                            result = $qui.formatString(lng.translate(20016257, 'Zwischenplanung anlegen (bis {0})'), dateEndStr);
                        break;
                    case 'ExecutingPhase':
                    case 'Durchführungsphase':
                        result = lng.translate(20016258, 'Durchführung des Betreuungsplans');
                        break;
                    case 'PeriodEvaluation':
                    case 'Zwischenevaluierung':
                        if (moment(today) > moment(dateEnd))
                            result = $qui.formatString(lng.translate(20016259, 'Zwischenevaluierung hätte bis zum {0} durchgeführt werden müssen'), dateEndStr);
                        else
                            result = $qui.formatString(lng.translate(20016260, 'Zwischenevaluierung durchführen (bis {0})'), dateEndStr);
                        break;
                    case 'FinalEvaluation':
                    case 'Abschlussevaluierung':
                        if (moment(today) > moment(dateEnd))
                            result = $qui.formatString(lng.translate(20016261, 'Betreuungsplan hätte bis zum {0} evaluiert werden müssen'), dateEndStr);
                        else
                            result = $qui.formatString(lng.translate(20016262, 'Betreuungsplan evaluieren (bis {0})'), dateEndStr);
                        break;
                    case 'CareReport':
                    case 'Berichtsphase':
                        if (moment(today) > moment(dateEnd))
                            result = $qui.formatString(lng.translate(20016263, 'Betreuungsbericht hätte bis zum {0} erstellt werden müssen'), dateEndStr);
                        else
                            $qui.formatString(lng.translate(20016264, 'Betreuungsbericht erstellen (bis {0})'), dateEndStr);
                        break;
                    case 'CareSummarization':
                    case 'Zusammenfassung':
                        $qui.formatString(lng.translate(20016265, 'Zusammenfassung des Betreuungsplans ({0})'), dateEndStr);
                        break;
                    case 'CompletedCareplan':
                    case 'Beendeter Betreuungsplan':
                        $qui.formatString(lng.translate(20016266, 'Beendeter Betreuungsplan ({0})'), dateEndStr);
                        break;
                    default:
                        result = '';
                        break;
                }
                return result;
            }
            static getActiveSupportPlanLink(careplanId) {
                let sUrl = $('#session').data().ceUrl;
                if (sUrl && careplanId !== '') {
                    if (sUrl.endsWith('/')) {
                        sUrl = sUrl.slice(0, -1);
                    }
                    sUrl = sUrl + '/care/careplan/' + careplanId;
                }
                return sUrl;
            }
        }
        Common.SupportPlanHelper = SupportPlanHelper;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Registers an angular controller
     * @param moduleName The name of the angular module
     * @param controllerName The name of the controller
     */
    function Controller(moduleName, controllerName) {
        return function decoratorFactory(target, decoratedPropertyName) {
            angular
                .module(moduleName)
                .controller(controllerName, target);
        };
    }
    QMC.Controller = Controller;
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Creates the directive factory function and sets the dependencies of the directive and registers the directive
     * @param moduleName The name of the angular module
     * @param directiveName The name of the service
     * @param dependencies The dependencies of the directive
     */
    function Directive(moduleName, directiveName, dependencies = []) {
        return function decoratorFactory(target, decoratedPropertyName) {
            // Create directive
            const directive = (...args) => {
                return new target(...args);
            };
            // Dependency injection
            directive.$inject = dependencies;
            // Angular registration
            angular
                .module(moduleName)
                .directive(directiveName, directive);
        };
    }
    QMC.Directive = Directive;
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Injects this class with the given dependencies
     * @param dependencies The dependencies of this class
     */
    function Inject(...dependencies) {
        return function decoratorFactory(target, decoratedPropertyName) {
            var $inject = target.$inject = [];
            $inject = $inject.concat(dependencies);
            target.prototype.$inject = $inject;
            target.$inject = $inject;
        };
    }
    QMC.Inject = Inject;
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Registers an angular service
     * @param moduleName The name of the angular module
     * @param serviceName The name of the service
     */
    function Service(moduleName, serviceName) {
        return function decoratorFactory(target, decoratedPropertyName) {
            angular
                .module(moduleName)
                .service(serviceName, target);
        };
    }
    QMC.Service = Service;
})(QMC || (QMC = {}));
(() => {
    sessionStorage.clear();
    angular.element(document).ready(function () {
        if (!window.clientExchange) {
            angular.bootstrap(document, ['QMC']);
        }
        else {
            const waitForInit = () => {
                var _a;
                if ((_a = window.te) === null || _a === void 0 ? void 0 : _a.length) {
                    setTimeout(() => {
                        angular.bootstrap(document, ['QMC']);
                    });
                }
                else
                    setTimeout(waitForInit, 50);
            };
            waitForInit();
        }
    });
    function config($locationProvider, $stateProvider, $urlRouterProvider, qmcBase, $httpProvider, $sceDelegateProvider, $qProvider) {
        $httpProvider.defaults.cache = true;
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.when('/ambulant', '/');
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'http://service.daarwin.de/**',
            'https://service.daarwin.de/**',
            'http://localhost:4200/*'
        ]);
        //$qProvider.errorOnUnhandledRejections(false);
        // $compileProvider.debugInfoEnabled(false);
        $stateProvider
            .state('dashboard', {
            url: '/',
            templateUrl: qmcBase + '/Dashboard',
            controller: 'HomeController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Dashboard');
                    }]
            }
        }).state('changelog', {
            url: '/changelog',
            templateUrl: qmcBase + '/Changelog/Index',
            controller: 'ChangelogController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Changelog');
                    }]
            }
        }).state('license', {
            url: '/license',
            templateUrl: qmcBase + '/License/Index',
            controller: 'HomeController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: License');
                    }]
            }
        });
        $stateProvider
            .state('404', {
            url: '/404',
            templateUrl: qmcBase + '/error/404',
            controller: 'HomeController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.warn('Current State: Page not Found');
                    }]
            }
        });
        $stateProvider
            .state('changePassword', {
            url: '/user/changepassword',
            templateUrl: qmcBase + '/ChangePassword',
            controller: 'ChangePasswordController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.warn('Current State: change password');
                    }]
            }
        }).state('settings', {
            url: '/user/settings',
            templateUrl: qmcBase + '/Settings',
            controller: 'UserSettingsController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.warn('Current State: User Settings');
                    }]
            }
        }).state('globalsettings', {
            url: '/user/globalsettings',
            templateUrl: qmcBase + '/GlobalSettings',
            controller: 'UserGlobalSettingsController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.warn('Current State: User Global Settings');
                    }]
            }
        }).state('navconfiguration', {
            url: '/navconfiguration',
            templateUrl: qmcBase + '/NavConfiguration',
            controller: 'NavConfigurationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.warn('Current State: User Global Settings');
                    }]
            }
        });
    }
    // Init Empty Modules
    const baseUrl = $('#session').data().baseUrl;
    angular
        .module('QMC.Common', [])
        .constant('qmcBase', baseUrl.substring(0, baseUrl.length - 1))
        .run(['QmcLanguageService', (qmcLanguageService) => {
            qmcLanguageService.loadLanguageTags();
        }]);
    angular.module('QMC.Documents', []);
    angular.module('QMC.Directives', []);
    angular.module('QMC.Input', []);
    angular.module('QMC.Udf', []);
    angular.module('QMC.Aufgaben', []);
    angular.module('QMC.Arbeitszeitnachweis', ['ui.router']);
    angular.module('QMC.Klient', ['ui.router']);
    angular.module('QMC.Medikamente', ['ui.router']);
    angular.module('QMC.Fachleistung', ['ui.router', 'QMC.Klient', 'QMC.Home']);
    angular.module('QMC', ['ui.router', 'ui.router.state.events', 'ngMessages', 'ui.select', 'ngSanitize', 'qmc-ui', 'QMC.Common', 'QMC.Home', 'QMC.Documents', 'QMC.Directives', 'QMC.Input', 'QMC.Udf', 'QMC.Arbeitszeitnachweis',
        'QMC.Aufgaben', 'QMC.ClientInformation', 'QMC.Fachleistung', 'QMC.Holiday', 'QMC.Klient', 'QMC.Medikamente', 'QMC.Nachrichten', 'QMC.Reporting', 'QMC.Stammdaten', 'QMC.Tagebuch',
        'QMC.Termin', 'QMC.Roster', 'QMC.Employee'])
        .filter("humanize", ['UserService', QMC.Common.Filter.Humanize])
        .filter("displayFormat", ['$sce', QMC.Common.Filter.DisplayFormat])
        .filter("notEmpty", QMC.Common.Filter.NotEmpty)
        .filter("shortner", QMC.Common.Filter.Shortner)
        .filter("unsafeHtml", ['$sce', QMC.Common.Filter.Html])
        .filter("fullNameFormat", QMC.Common.Filter.FullNameFormat)
        .filter("startFrom", QMC.Common.Filter.StartFrom)
        .config(config)
        .config(decorateStateServiceForQuietTransitionRejections)
        .run(['$rootScope', '$state', 'QmcPermissionService', function ($rootScope, $state, permissionService) {
            const rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
            jQuery.htmlPrefilter = function (html) {
                return html.replace(rxhtmlTag, "<$1></$2>");
            };
            if (location.href.indexOf("hideNav=true") > 0) {
                $('body').addClass('hideNav');
            }
            else {
                $('body').removeClass('hideNav');
            }
            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                if (!$state.history)
                    $state.history = [];
                if (fromState.name && fromState.name.length > 0)
                    $state.history.unshift({
                        name: fromState.name,
                        url: fromState.url,
                        params: fromParams
                    });
                $state.history = $state.history.slice(0, 5); // limit to last 5 entries
            });
            // apply rights for topmenu items:
            const objTypeAppointment = 400000;
            const objTypeMessage = 750000;
            const objTypeGlobalSettings = 870000;
            permissionService.getPermissionsByObjectTypes([objTypeAppointment, objTypeMessage, objTypeGlobalSettings]).then(data => {
                var _a, _b, _c;
                if ((_a = data.find(x => x.objectType === objTypeMessage)) === null || _a === void 0 ? void 0 : _a.moduleAccess)
                    document.getElementById('MENU.MESSAGE').style.display = '';
                if ((_b = data.find(x => x.objectType === objTypeAppointment)) === null || _b === void 0 ? void 0 : _b.moduleAccess)
                    document.getElementById('MENU.APPOINTMENT').style.display = '';
                if ((_c = data.find(x => x.objectType === objTypeGlobalSettings)) === null || _c === void 0 ? void 0 : _c.moduleAccess)
                    document.getElementById('MENU.GLOBALSETTINGS').style.display = '';
            });
        }]);
    config.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase', '$httpProvider', '$sceDelegateProvider', '$qProvider'];
    /**
     * ui-router may reject transition promises (e.g. superseded / noop) with `null`, which Angular reports as
     * "Possibly unhandled rejection". Attach a no-op rejection handler so the promise is always observed.
     */
    function attachQuietRejectionHandler(value) {
        const p = value;
        if (p != null && typeof p.catch === 'function') {
            p.catch(angular.noop);
        }
    }
    function wrapStateTransitionFn(fn) {
        return ((...args) => {
            const result = fn(...args);
            attachQuietRejectionHandler(result);
            return result;
        });
    }
    function decorateStateServiceForQuietTransitionRejections($provide) {
        $provide.decorator('$state', ['$delegate', ($delegate) => {
                $delegate.go = wrapStateTransitionFn($delegate.go.bind($delegate));
                if (typeof $delegate.transitionTo === 'function') {
                    $delegate.transitionTo = wrapStateTransitionFn($delegate.transitionTo.bind($delegate));
                }
                if (typeof $delegate.reload === 'function') {
                    $delegate.reload = wrapStateTransitionFn($delegate.reload.bind($delegate));
                }
                return $delegate;
            }]);
    }
    decorateStateServiceForQuietTransitionRejections.$inject = ['$provide'];
    angular.module('QMC.Common')
        .config(['$httpProvider', QMC.Common.HttpBaseProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcLanguageService_1;
        let QmcLanguageService = QmcLanguageService_1 = class QmcLanguageService extends Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.isDebug = false;
                this.languageTags = {};
                this.lastLoadTime = 0;
                const ele = angular.element('#session');
                this.languageId = ele.data('user-language-id');
                try {
                    this.isDebug = ele.data('debug').toLowerCase() === 'true';
                }
                catch (e) {
                    this.isDebug = false;
                    console.log(e);
                }
                ;
                this.loadLanguageTags();
            }
            loadLanguageTags() {
                const ele = angular.element('#session');
                this.languageId = ele.data('user-language-id');
                this.isDebug = ele.data('debug');
                const now = Date.now();
                if (!this.languageId || this.isLoading || now - this.lastLoadTime < QmcLanguageService_1.MIN_LOAD_INTERVAL_MS)
                    return;
                this.isLoading = true;
                this.lastLoadTime = now;
                super.getItem(`/languages/${this.languageId}/tags`, { fromTag: 20000000, toTag: 29999999, asDict: true, dbConnectionString: ele.data('db-connection') })
                    .then((data) => {
                    this.languageTags = data.languageTags;
                }).finally(() => {
                    this.isLoading = false;
                    if (this.timeout)
                        clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => { this.loadLanguageTags(); }, this.languageTags && Object.keys(this.languageTags).length === 0 ? 1200000 : 60000 * 15);
                });
            }
            translate(tag, defaultValue = '') {
                if (Object.keys(this.languageTags).length === 0) {
                    this.loadLanguageTags();
                }
                const value = this.languageTags[tag];
                if (value && value.length > 0) {
                    return value;
                }
                return defaultValue;
                //return this.isDebug ? `*JD* ${defaultValue}` : defaultValue;
            }
            getLanguages() {
                return this.get('/Languages', {}, (data) => {
                    return data;
                });
            }
            getCurrentLanguageId() {
                this.languageId = $('#session').data().userLanguageId;
                return this.languageId;
            }
            updateCurrentLanguageId(languageId) {
                return this.put('/User/Language', { languageId });
            }
            setLanguageTag(tag = 0, data) {
                return this.putParameter('/Languages/' + tag, { languageId: this.languageId }, '"' + data + '"').then((data) => {
                    return data;
                });
            }
        };
        QmcLanguageService.MIN_LOAD_INTERVAL_MS = 5000;
        QmcLanguageService = QmcLanguageService_1 = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Common', 'QmcLanguageService')
        ], QmcLanguageService);
        Common.QmcLanguageService = QmcLanguageService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let QmcMediaService = class QmcMediaService extends Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
            }
            convertToHtml(base64, sourceType) {
                return this.post('/Media/Converter/ToHtml', { base64, sourceType }).then((data) => {
                    return data;
                });
            }
            convertToPdf(base64, sourceType) {
                return this.post('/Media/Converter/ToPdf', { base64, sourceType }).then((data) => {
                    return data;
                });
            }
            getTextBlocks() {
                return super.get("/TextBlock", {}, (data) => {
                    return data;
                });
            }
            getTextTemplates() {
                return super.get("/TextTemplate", {}, (data) => {
                    return data;
                });
            }
            getTextTemplateContent(id) {
                return super.getItem("/TextTemplate/" + id, {}, (data) => {
                    return data;
                });
            }
            getMediaFile(id, mediaType) {
                return super.getItem("/Document/Media/" + id, { mediaType }, (data) => {
                    return data;
                });
            }
            getMediaThumbnail(id, mediaType, maxSize = 50) {
                return super.getItem("/Document/Media/" + id, { mediaType, maxSize }, (data) => {
                    return data;
                });
            }
            getMediaAttachement(documentId, attachmentId) {
                return super.getItem(`/Document/Media/${documentId}/${attachmentId}`, {}, (data) => {
                    return data;
                });
            }
            postMediaAttachement(data) {
                return super.post(`/Document/Media`, data).then((data) => {
                    return data;
                });
            }
            deleteMediaAttachementDirect(attachmentId) {
                return super.delete(`/Document/Media/${attachmentId}`).then((data) => {
                    return data;
                });
            }
            deleteMediaAttachement(documentId, attachmentId) {
                return super.delete(`/Document/Media/${documentId}/${attachmentId}`).then((data) => {
                    return data;
                });
            }
        };
        QmcMediaService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Common', 'QmcMediaService')
        ], QmcMediaService);
        Common.QmcMediaService = QmcMediaService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let QmcPermissionService = class QmcPermissionService extends Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.cacheTTL = 1000 * 60 * 1; // 1minutes
                this.permissionCache = {};
                this.pendingObjectTypeRequests = {};
                this.pendingMultipleRequests = {};
                this.pendingUserObjectTypeRequests = {};
            }
            buildObjectTypesKey(objectTypes) {
                return objectTypes.slice().sort((a, b) => a - b).join(',');
            }
            isCacheValid(objectType) {
                const cache = this.permissionCache[objectType];
                return cache !== undefined && cache !== 'loading' && new Date().getTime() - cache.timestamp <= this.cacheTTL;
            }
            getCachedValue(objectType) {
                const cache = this.permissionCache[objectType];
                if (cache === 'loading')
                    return new Promise((resolve, reject) => {
                        setTimeout(async () => {
                            const result = await this.getCachedValue(objectType);
                            if (result)
                                resolve(result);
                            else
                                reject('Not in cache');
                        }, 250);
                    });
                if (!this.isCacheValid(objectType)) {
                    delete this.permissionCache[objectType];
                    return Promise.reject('Not in cache');
                }
                ;
                return Promise.resolve(cache.result);
            }
            setCachedValue(objectType, value) {
                const cache = this.permissionCache[objectType];
                if (value.length === 1 && cache !== 'loading' && (cache === null || cache === void 0 ? void 0 : cache.result.length) > 1) {
                    const temp = value[0];
                    value = cache.result;
                    value[0] = temp;
                }
                this.permissionCache[objectType] = { timestamp: new Date().getTime(), result: value };
            }
            /**
             * Gets the permissions by object type.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            getPermissionsByObjectType(objectType, force = false) {
                if (!force && this.pendingObjectTypeRequests[objectType])
                    return this.pendingObjectTypeRequests[objectType];
                const loadFromServer = () => {
                    if (this.pendingObjectTypeRequests[objectType])
                        return this.pendingObjectTypeRequests[objectType];
                    this.permissionCache[objectType] = 'loading';
                    const promise = this.get('/Permission', { objectType }, (data) => {
                        this.setCachedValue(objectType, data);
                        return data;
                    }).finally(() => {
                        delete this.pendingObjectTypeRequests[objectType];
                    });
                    this.pendingObjectTypeRequests[objectType] = promise;
                    return promise;
                };
                if (force)
                    return loadFromServer();
                return this.getCachedValue(objectType)
                    .catch(() => loadFromServer());
            }
            /**
             * Gets the permissions by object types.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            getPermissionsByObjectTypes(objectTypes, force = false) {
                const cacheKey = this.buildObjectTypesKey(objectTypes);
                if (!force && this.pendingMultipleRequests[cacheKey])
                    return this.pendingMultipleRequests[cacheKey];
                const loadFromServer = () => {
                    if (this.pendingMultipleRequests[cacheKey])
                        return this.pendingMultipleRequests[cacheKey];
                    objectTypes.forEach(x => this.permissionCache[x] = 'loading');
                    const promise = this.get('/Permission/Multiple', { objectTypes }, (data) => {
                        data.forEach(x => this.setCachedValue(x.objectType, [x]));
                        return data;
                    }).finally(() => {
                        delete this.pendingMultipleRequests[cacheKey];
                    });
                    this.pendingMultipleRequests[cacheKey] = promise;
                    return promise;
                };
                if (force)
                    return loadFromServer();
                return this.$q.all(objectTypes.map(x => this.getCachedValue(x)))
                    .then(all => all.map(x => x[0]))
                    .catch(() => loadFromServer());
            }
            /** Gets the permissions for Media / Documents.
             * @param objectTypeBase The object type to get the permissions OBJEKTTYPE_DOCUMENT.
             * @param wvTypeId The wv subtyp.
             * @param folderCategoryId The Document Category for which we get the permission
             */
            getMediaPermissions(objectTypeBase, wvTypeId, folderCategoryId) {
                return this.get('/Permission/Media', { objectTypeBase: objectTypeBase, wvTypeId: wvTypeId, folderCategoryId: folderCategoryId }, (data) => {
                    return data;
                });
            }
            /**
             * Gets the permissions for a dataset.
             * @param objectId The objectId of the dataset to get the permissions for.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            getPermissionsForDataset(objectId, objectType) {
                return this.get('/Permission/DataSet', { objectId: objectId, objectType: objectType }, (data) => {
                    return data;
                });
            }
            /**
             * Gets the permissions for a specific user related to a specific type.
             * @param userId The userId to get the permissions for.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            getPermissionsForGivenUserAndObjectType(userId, objectType) {
                const cacheKey = `${userId}:${objectType}`;
                if (this.pendingUserObjectTypeRequests[cacheKey])
                    return this.pendingUserObjectTypeRequests[cacheKey];
                const promise = this.get('/Permission/ObjectInAllowedNewPermsList', { userId: userId, objectType: objectType }, (data) => {
                    return data;
                }).finally(() => {
                    delete this.pendingUserObjectTypeRequests[cacheKey];
                });
                this.pendingUserObjectTypeRequests[cacheKey] = promise;
                return promise;
            }
            getLicense() {
                return super.get('/Navigation/License', {}).then((data) => {
                    return data;
                });
            }
            isLicenseAvailable(key) {
                return super.get(`/Navigation/License`, { allKeys: true }).then((data) => {
                    return data.some(x => x === key || x === 'NOLIC');
                });
            }
        };
        QmcPermissionService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Common', 'QmcPermissionService')
        ], QmcPermissionService);
        Common.QmcPermissionService = QmcPermissionService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let QmcMarkItemService = class QmcMarkItemService extends Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
            }
            getMarkItems() {
                return this.getItem('/MarkItem/', {}, (data) => {
                    return data;
                });
            }
            getSelectedMarkItems(parentObjectId, parentObjectType) {
                return this.getItem('/SelectedMarkItem/' + parentObjectId + '/' + parentObjectType, {}, (data) => {
                    return data;
                });
            }
            checkIfItemsAreMarked(parentObjectIds, parentObjectType) {
                return this.getItem('/SelectedMarkItem/CheckIfMarked/' + parentObjectType, { parentObjectIds: parentObjectIds }, (data) => {
                    return data;
                });
            }
            putSelectedMarkItems(data) {
                return this.put('/SelectedMarkItem/', data).then((data) => {
                    return data;
                });
            }
        };
        QmcMarkItemService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Common', 'QmcMarkItemService')
        ], QmcMarkItemService);
        Common.QmcMarkItemService = QmcMarkItemService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let QmcIdentityService = class QmcIdentityService extends Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
            }
            /**
             * Gets the claims of the currently logged in user.
             */
            getIdentity() {
                return this.getItem('/Identity', {}, (data) => {
                    return data;
                });
            }
            setSecretToken() {
                const deferred = this.$q.defer();
                this.$http({
                    url: this.apiData.url + '/TokenExchange',
                    method: 'POST',
                    data: { access: this.getAccessToken(), refresh: this.getRefreshToken() }
                }).then((response) => {
                    if (response.status === 201 || response.status === 200)
                        deferred.resolve(response.data);
                    else
                        deferred.reject(response.data);
                }).catch((response) => {
                    deferred.reject(response.data);
                });
                return deferred.promise.then((data) => { return data; });
            }
            getSecretToken(id) {
                const deferred = this.$q.defer();
                this.$http({
                    url: this.apiData.url + '/TokenExchange/' + id,
                    method: 'GET'
                }).then((response) => {
                    if (response.status === 200)
                        deferred.resolve(response.data);
                    else
                        deferred.reject(response.data);
                }).catch((response) => {
                    deferred.reject(response.data);
                });
                return deferred.promise.then((data) => { return data; });
            }
        };
        QmcIdentityService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Common', 'QmcIdentityService')
        ], QmcIdentityService);
        Common.QmcIdentityService = QmcIdentityService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        angular.module('QMC.Common').directive('qmLicense', ['QmcPermissionService', '$qui', (permissionService, $qui) => {
                return {
                    restrict: 'E',
                    templateUrl: './License/Directive',
                    transclude: true,
                    scope: {
                        granted: '=?',
                        key: '@?',
                        route: '@?',
                        loading: '=?'
                    },
                    link: (scope) => {
                        function checkLicenseByRoute(route) {
                            var _a, _b;
                            const license = getLicense();
                            return (_b = (_a = license.filter(x => x.url.toLowerCase() === route.toLowerCase())[0]) === null || _a === void 0 ? void 0 : _a.granted) !== null && _b !== void 0 ? _b : false;
                        }
                        function checkLicenseByKey(key) {
                            var _a, _b;
                            const license = getLicense();
                            return (_b = (_a = license.filter(x => x.license.toLowerCase() === key.toLowerCase())[0]) === null || _a === void 0 ? void 0 : _a.granted) !== null && _b !== void 0 ? _b : false;
                        }
                        function getLicense() {
                            const license = window.license;
                            if (license === 'loading')
                                return [];
                            if (!license || !Array.isArray(license)) {
                                window.license = 'loading';
                                permissionService.getLicense().then((data) => {
                                    window.license = data;
                                    scope.loading = false;
                                });
                                return [];
                            }
                            scope.loading = false;
                            return license;
                        }
                        function checkLicense() {
                            if (!scope.key && !scope.route) {
                                scope.loading = false;
                                scope.granted = false;
                            }
                            scope.granted = scope.key ? checkLicenseByKey(scope.key) : scope.route ? checkLicenseByRoute(scope.route) : false;
                            $qui.scopeApply(scope);
                            if (scope.loading) {
                                setTimeout(() => { checkLicense(); }, 200);
                            }
                        }
                        scope.loading = true;
                        checkLicense();
                    }
                };
            }
        ]);
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let QmcPrivateContentService = class QmcPrivateContentService extends Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
            }
            /**
             * Gets a single private content.
             * @param objectType The parent object to get the content for (e.g. fls-docu).
             * @param referenceObjectId The reference to get the content for (e.g. client).
             */
            getPrivateContent(parentId, referenceObjectId) {
                return this.getItem('/PrivateContent/' + parentId + '/' + referenceObjectId, {}, (data) => {
                    return data;
                });
            }
            putPrivateContent(parentId, referenceObjectId, data) {
                return this.put('/PrivateContent/' + parentId + '/' + referenceObjectId, data).then((data) => {
                    return data;
                });
            }
            postPrivateContent(data) {
                return this.post('/PrivateContent/', data).then((data) => {
                    return data;
                });
            }
        };
        QmcPrivateContentService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Common', 'QmcPrivateContentService')
        ], QmcPrivateContentService);
        Common.QmcPrivateContentService = QmcPrivateContentService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        class Utilities {
            static confirm(obj, cb, prompt = '#prompt', staticBD = false) {
                $(prompt).modal({ backdrop: staticBD ? 'static' : true, keyboard: false });
                obj.callback = function (bool) {
                    cb(bool);
                };
            }
            static arraysEqual(_arr1, _arr2) {
                if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length)
                    return false;
                const arr1 = _arr1.concat().sort();
                const arr2 = _arr2.concat().sort();
                for (let i = 0; i < arr1.length; i++) {
                    if (arr1[i] !== arr2[i])
                        return false;
                }
                return true;
            }
        }
        Common.Utilities = Utilities;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        /**
         * Smart action keyword check class
         *
         * @export
         * @class SmartAction
         */
        class SmartAction {
            constructor(permissionService, userService, clientService, lng, $scope) {
                this.clientService = clientService;
                this.lng = lng;
                this.$scope = $scope;
                this.keyWords = [];
                this.keyWordGroups = ["impfung", "arzt", "krankheit", "termin", "abwesenheit", "nachricht", "aufgabe", "dokument", "kassenbuch", "kontaktperson"];
                this.activeKeys = {};
                this.ignoredKeys = [];
                this.loading = true;
                if (!permissionService || !clientService || !lng)
                    return;
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                this.cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                // nothing cached and not already loading, completely rebuild
                if (!this.cacheObject.permissions) {
                    this.cacheObject.permissions = { loading: true };
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(this.cacheObject));
                    if (!window.license || window.license === 'loading')
                        permissionService.getLicense().then((license) => {
                            window.license = license !== null && license !== void 0 ? license : []; //since we already got it, might as well set it in windowstore. might reduce waittime later
                            this.createKeyWords(permissionService, userService);
                        });
                    else
                        this.createKeyWords(permissionService, userService);
                }
                // data is already beeing loaded, wait for it
                else if (this.cacheObject.permissions && this.cacheObject.permissions.loading) {
                    this.waitForPermissionCache();
                }
                // data is already present, use it
                else {
                    this.keyWords = this.cacheObject.keyWords;
                    this.loading = false;
                }
                // init person lists needed by several SAs
                // loading int
                this.cacheObject.clientList = { loading: true };
                this.cacheObject.employeeList = { loading: true };
                sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(this.cacheObject));
                // clientlist
                this.clientService.getClientPersonList("", true).then((data) => {
                    this.cacheObject.clientList = data.map((x) => ({ value: x.objectId, text: x.displayTitle }));
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(this.cacheObject));
                });
                // employeelist
                this.clientService.getEmployeeList().then((data) => {
                    this.cacheObject.employeeList = data.map((x) => ({ value: x.objectId, text: x.displayTitle }));
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(this.cacheObject));
                });
                // personlists
                this.clientService.getAllPersonLists().then((data) => {
                    this.cacheObject.personLists = data.map((x) => ({ value: x.objectId, text: x.name + ' (' + this.lng.translate(20000292, 'Verteiler') + ')' }));
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(this.cacheObject));
                });
                this.resetSmartAction();
            }
            resetSmartAction() {
                this.ignoredKeys = [];
                for (const keyword of this.keyWordGroups) {
                    this.activeKeys[keyword] = [];
                }
                if (this.$scope && !this.$scope.$$phase)
                    this.$scope.$apply();
            }
            checkKeyWord(searchContent) {
                if (this.loading) {
                    setTimeout(() => {
                        this.checkKeyWord(searchContent);
                    }, 500);
                    return;
                }
                searchContent = searchContent.toLowerCase();
                for (let i = 0; i < this.keyWordGroups.length; i++) {
                    if (!this.keyWords[i])
                        continue;
                    for (let j = 0; j < this.keyWords[i].length; j++) {
                        if (searchContent.search(this.keyWords[i][j]) !== -1 && this.keyWords[i][j] !== '' && this.ignoredKeys.indexOf(this.keyWords[i][j]) === -1) {
                            if (!this.activeKeys[this.keyWordGroups[i]].includes(this.keyWords[i][j])) {
                                this.activeKeys[this.keyWordGroups[i]].push(this.keyWords[i][j]);
                                if (this.$scope && !this.$scope.$$phase)
                                    this.$scope.$apply();
                                // do this second scope apply to make absolutly sure changes get triggered 'immediatly'
                                setTimeout(() => {
                                    if (this.$scope && !this.$scope.$$phase)
                                        this.$scope.$apply();
                                }, 250);
                            }
                        }
                    }
                }
            }
            createKeyWords(permissionService, userService) {
                const keyWords = [];
                permissionService.getPermissionsByObjectTypes([140005, 140003, 140002, 400000, 140033, 750001, 840501, 140032, 330003, 140006]).then((perms) => {
                    if (perms[0].new)
                        keyWords[0] = ["impfung", "impfen"];
                    if (perms[1].new)
                        keyWords[1] = ["arzt", "doktor"];
                    if (perms[2].new)
                        keyWords[2] = ["krank", "krankheit", "grippe", "fieber"];
                    if (perms[3].new)
                        keyWords[3] = ["termin", "verabredung", "meeting"];
                    if (perms[4].new)
                        keyWords[4] = ["abwesend", "abwesenheit"];
                    if (perms[5].new)
                        keyWords[5] = ["nachricht", "mail", "meldung"];
                    if (perms[6].new)
                        keyWords[6] = ["aufgabe", "task"];
                    if (perms[7].new)
                        keyWords[7] = ["dokument", "datei"];
                    if (perms[8].new && window.license.some(x => x.license === 'KASSENBUCH' && x.granted))
                        keyWords[8] = ["kassenbuch"];
                    if (perms[9].new)
                        keyWords[9] = ["kontakt", "kontaktperson"];
                    if (userService) {
                        userService.getUserSettings([
                            "SMARTACTIONS.VACCINATION",
                            "SMARTACTIONS.DOCVISIT",
                            "SMARTACTIONS.DISEASE",
                            "SMARTACTIONS.APPOINTMENT",
                            "SMARTACTIONS.ABSENTEEISM",
                            "SMARTACTIONS.INTERNALMESSAGE",
                            "SMARTACTIONS.TASK",
                            "SMARTACTIONS.DOCUMENT",
                            "SMARTACTIONS.ACCOUNTINGBOOK",
                            "SMARTACTIONS.CONTACTPERSON",
                        ]).then((data) => {
                            for (let i = 0; i < keyWords.length; i++) {
                                this.addKeywords(i, keyWords, data);
                            }
                            this.keyWords = keyWords;
                            this.loading = false;
                            this.savePermissionCache({
                                140005: perms[0],
                                140003: perms[1],
                                140002: perms[2],
                                400000: perms[3],
                                140033: perms[4],
                                750001: perms[5],
                                840501: perms[6],
                                140032: perms[7],
                                330003: perms[8],
                                140006: perms[9]
                            }, keyWords);
                        });
                    }
                    else {
                        this.keyWords = keyWords;
                        this.loading = false;
                        this.savePermissionCache({
                            140005: perms[0],
                            140003: perms[1],
                            140002: perms[2],
                            400000: perms[3],
                            140033: perms[4],
                            750001: perms[5],
                            840501: perms[6],
                            140032: perms[7],
                            330003: perms[8],
                            140006: perms[9]
                        }, keyWords);
                    }
                });
            }
            addKeywords(index, keyWords, data) {
                if (!data[index] || !keyWords[index])
                    return;
                if (data[index].value === "")
                    keyWords[index] = undefined;
                else {
                    keyWords[index] = [];
                    data[index].value.split(";").forEach(item => keyWords[index].push(item.toLowerCase().trim()));
                }
            }
            savePermissionCache(permissions, keyWords) {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                cacheObject.permissions = permissions;
                cacheObject.keyWords = keyWords;
                sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(cacheObject));
            }
            waitForPermissionCache() {
                const cacheObject = JSON.parse(sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE));
                if (cacheObject.permissions.loading) {
                    setTimeout(() => { this.waitForPermissionCache(); }, 250);
                    return;
                }
                this.keyWords = cacheObject.keyWords;
                this.loading = false;
            }
        }
        Common.SmartAction = SmartAction;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        Common.personalLocalStorage = {
            getItem: (key) => localStorage.getItem(`${$('#session').data().userId}_${key}`),
            setItem: (key, value) => localStorage.setItem(`${$('#session').data().userId}_${key}`, value),
            removeItem: (key) => localStorage.removeItem(`${$('#session').data().userId}_${key}`)
        };
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let QmcWvService = class QmcWvService extends Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
            }
            getWvList(wvId) {
                return this.get(`/WV/${wvId}`, {}, (data) => {
                    return data;
                });
            }
            getWv(wvId, itemId) {
                return this.getItem(`/WV/${wvId}/${itemId}`, {}, (data) => {
                    return data;
                });
            }
            putWv(wvId, itemId, data) {
                return this.put(`/WV/${wvId}/${itemId}`, data).then((data) => {
                    return data;
                });
            }
            postWv(wvId, data) {
                return this.post(`/WV/${wvId}`, data).then((data) => {
                    return data;
                });
            }
            deleteWv(wvId, itemId) {
                return this.delete(`/WV/${wvId}/${itemId}`).then((data) => {
                    return data;
                });
            }
            /************** SUB WV **************/
            getSubWvList(subWvId, wvId) {
                return this.get(`/SubWV/${subWvId}/${wvId}`, {}, (data) => {
                    return data;
                });
            }
            getSubWv(subWvId, wvId, itemId) {
                return this.getItem(`/SubWV/${subWvId}/${wvId}/${itemId}`, {}, (data) => {
                    return data;
                });
            }
            putSubWv(subWvId, wvId, itemId, data) {
                return this.put(`/SubWV/${subWvId}/${wvId}/${itemId}`, data).then((data) => {
                    return data;
                });
            }
            postSubWv(subWvId, wvId, data) {
                return this.post(`/SubWV/${subWvId}/${wvId}`, data).then((data) => {
                    return data;
                });
            }
            deleteSubWv(subWvId, wvId, itemId) {
                return this.delete(`/SubWV/${subWvId}/${wvId}/${itemId}`).then((data) => {
                    return data;
                });
            }
            getSubWvListForParent(subWvId, wvId) {
                return this.get(`/SubWV/ForParent/${wvId}/${subWvId}`, {}, (data) => {
                    return data;
                });
            }
        };
        QmcWvService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Common', 'QmcWvService')
        ], QmcWvService);
        Common.QmcWvService = QmcWvService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        class DetailUI extends Common.UserInterface {
            constructor() {
                super(...arguments);
                this.smartAufgabeForm = {
                    form: [
                        {
                            label: "Aufgabe",
                            placeholder: "",
                            type: "String",
                            lngTag: "20014007",
                            required: true,
                            model: "taskName",
                            validate: {
                                message: "Bitte die Aufgabe angeben.",
                                messageTag: 20014008
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Kategorie",
                            placeholder: "Kategorie auswählen",
                            type: "Select",
                            lngTag: "20000137",
                            dataSource: "getCategoryList",
                            model: "categoryId",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Priorität",
                            placeholder: "Priorität auswählen",
                            type: "Select",
                            lngTag: "20014013",
                            dataSource: "getPriorityList",
                            model: "priorityId",
                            id: "priorityList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            placeholder: "Erledigungstyp auswählen ...",
                            label: "Erledigungstyp",
                            type: "Select",
                            lngTag: "20014014",
                            dataSource: "getExecutionTypeList",
                            model: "executionTypeId",
                            id: "executionTypeList",
                            required: true,
                            validate: {
                                message: "Bitte Erledigungstyp angeben.",
                                messageTag: 20014021
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigungsfrist",
                            placeholder: "zu erledigen bis",
                            type: "Date",
                            model: "dateToFinishTill",
                            startDate: new Date(),
                            lngTag: "20014005",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Termin(e) verwenden",
                            type: "Checkbox",
                            model: "isAppointment",
                            id: "isAppointment",
                            lngTag: "20014030",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            placeholder: "Mitarbeiter auswählen",
                            type: "Select2",
                            lngTag: "20014010",
                            dataSource: "getParticipantsList",
                            multiple: true,
                            id: "participantsTypeList",
                            model: "participants",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Beschreibung",
                            placeholder: "Beschreibung eingeben ...",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: "20014019",
                            model: "taskDescription",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        }
                    ],
                    actions: {
                        put: "putAufgabe",
                        post: "addAufgabe",
                    }
                };
                this.smartContactpersonForm = {
                    form: [
                        {
                            placeholder: "Klient auswählen",
                            label: "Klient",
                            type: "Select",
                            lngTag: 20017049,
                            required: true,
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "parentObjectId",
                            style: {
                                class: "col-xs-12",
                            },
                            validate: {
                                message: "Bitte einen Klienten angeben.",
                                messageTag: 21003000
                            }
                        },
                        {
                            placeholder: "Kontaktpersonart auswählen",
                            label: "Kontaktpersonart",
                            type: "Select",
                            lngTag: 20004003,
                            required: true,
                            dataSource: "getContactPersonTypeList",
                            model: "contactPersonTypeId",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Art auswählen!"
                            }
                        }, {
                            placeholder: "Anrede auswählen",
                            label: "Anrede",
                            type: "Select",
                            lngTag: 20004005,
                            dataSource: "getSalutationList",
                            model: "salutationId",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Anrede auswählen!"
                            }
                        }, {
                            placeholder: "Titel auswählen",
                            label: "Titel",
                            type: "Select",
                            lngTag: 21002024,
                            dataSource: "getTitleList",
                            model: "titleId",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Vorname",
                            label: "Vorname",
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Nachname",
                            label: "Nachname",
                            type: "String",
                            lngTag: 20000058,
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Nachnamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            label: "Geburtsdatum",
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21003020,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12"
                            }
                        }, {
                            label: "Kontaktsperre",
                            type: "Checkbox",
                            model: "isContactBan",
                            lngTag: 20004512,
                            id: "isContactBan",
                            style: {
                                class: "medium"
                            }
                        }
                    ],
                    actions: {
                        post: "addContactperson",
                        put: "putContactperson"
                    }
                };
                this.smartAppointmentForm = {
                    form: [{
                            label: "Betreff",
                            placeholder: "Betreff",
                            type: "String",
                            model: "title",
                            required: true,
                            validate: {
                                message: "Bitte den Betreff angeben.",
                                messageTag: 20018024
                            },
                            style: {
                                class: "col-xs-12",
                                icon: "fa fa-font"
                            }
                        },
                        {
                            type: "Select2",
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klient auswählen",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            placeholder: "Mitarbeiter auswählen",
                            type: "Select2",
                            id: "selectedEmployeeIds",
                            dataSource: "getEmployeeList",
                            model: "selectedEmployeeIds",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: "20000130",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                displayDateTo: true,
                                disableTime: "isAllDay"
                            }
                        },
                        {
                            placeholder: "Ort",
                            label: "Ort",
                            type: "String",
                            model: "location",
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-fa fa-map-marker"
                            }
                        },
                        {
                            label: "Bemerkung",
                            placeholder: "Bemerkung eingeben ...",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: "20000049",
                            model: "description",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Privat",
                            type: "Checkbox",
                            lngTag: 20018014,
                            model: "isPrivate",
                            id: "isPrivate",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Erledigt",
                            type: "Checkbox",
                            lngTag: 20000120,
                            model: "isFinished",
                            id: "isFinished",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Ganztägig",
                            type: "Checkbox",
                            lngTag: 20018016,
                            model: "isAllDay",
                            id: "isAllDay",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },],
                    actions: {
                        put: "putAppointment",
                        post: "addAppointment"
                    }
                };
                this.smartAbsenteeismForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Abwesenheitsgrund",
                            label: "Abwesenheitsgrund",
                            type: "Select",
                            lngTag: 21008001,
                            dataSource: "getWvList",
                            model: "absenteeismReasonId",
                            required: true,
                            validate: {
                                message: "Bitte einen Grund auswählen.",
                                messageTag: 21008002
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putAbsenteeism",
                        post: "addAbsenteeism"
                    }
                };
                this.smartDiseaseForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: 20000130,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Codeschema",
                            label: "Codeschema",
                            type: "Select2",
                            dataSource: "getDiseaseWvList",
                            model: "diseaseCodeSchemaId",
                            lngTag: 20007002,
                            required: true,
                            validate: {
                                message: "Bitte das Codeschema angeben.",
                                messageTag: 21003005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit",
                            label: "Krankheit",
                            type: "Autocomplete",
                            model: "diseaseName",
                            lngTag: 20001049,
                            required: true,
                            id: "liveDiseases",
                            validate: {
                                message: "Bitte die Krankheit angeben."
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putDisease",
                        post: "addDisease",
                    }
                };
                this.smartDocVisitForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            multiple: true,
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            lngTag: 20000045,
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Uhrzeit",
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "time",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt/Med. Organisation",
                            label: "Arzt/Med. Organisation",
                            type: "Select2",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            model: "treaterId",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }, {
                            placeholder: "Diagnose",
                            label: "Diagnose",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20010503,
                            model: "diagnose",
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "fa fa-user-md"
                            },
                        },],
                    actions: {
                        put: "putDocVisit",
                        post: "addDocVisit"
                    }
                };
                this.smartVaccinationForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            label: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            type: "DateRange",
                            lngTag: 20000130,
                            model: {
                                dateFrom: "date",
                                dateTo: "dateFollowupAppointment"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt auswählen",
                            label: "Arzt",
                            type: "Select2",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            model: "doctorId",
                            required: true,
                            validate: {
                                message: "Bitte den Arzt angeben.",
                                messageTag: 21003014
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit auswählen",
                            label: "Krankheit",
                            type: "Select2",
                            dataSource: "getDiseases",
                            model: "diseaseId",
                            lngTag: 20001049,
                            required: true,
                            id: "disease",
                            validate: {
                                message: "Bitte eine Krankheit angeben",
                                messageTag: 21003006
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Impfstoff Handelsname",
                            label: "Impfstoff",
                            type: "String",
                            lngTag: 20009512,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-stethoscope"
                            },
                        }, {
                            placeholder: "Chargen-Nr",
                            label: "Chargen-Nr",
                            type: "String",
                            model: "batchNumber",
                            lngTag: 20009507,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putVaccination",
                        post: "addVaccination"
                    }
                };
            }
        }
        Common.DetailUI = DetailUI;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let DokumentDirectiveController = class DokumentDirectiveController {
            constructor(scope, $qui, $state, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.$state = $state;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.participants = [];
                this.fileObject = {
                    id: null,
                    objectId: null,
                    base64String: null,
                    date: null,
                    documentId: null,
                    fileName: null
                };
                this.files = [];
                this.formState = 'new';
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                //right now the smartFormAktion for Documents is working only for clients
                this.objectType = 140032;
                this.parentObjectType = 140000;
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    this.participants = [];
                    if (val.length > 1) {
                        for (let i = 0; i < val.length; i++) {
                            if (val[i].objType) {
                                if (val[i].objType === 140000) {
                                    clientsList.push(val[i].value);
                                }
                            }
                        }
                        this.participants = clientsList;
                    }
                    else {
                        this.participants = val;
                    }
                    this.clientID = this.participants.length === 1 ? this.participants[this.participants.length - 1] : null;
                }, true);
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.wv && !this.loading.client) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            showStructure(id) {
                return id && id !== Common.Constants.GUID_EMPTY;
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140032]) {
                    this.new = cacheObject.permissions[140032].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            }
            getClientList() {
                return this.clientList;
            }
        };
        DokumentDirectiveController = __decorate([
            QMC.Controller('QMC.Common', 'DokumentDirectiveController'),
            QMC.Inject('$scope', '$qui', '$state', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], DokumentDirectiveController);
        let DokumentDirective = class DokumentDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Dokument";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'DokumentDirectiveController';
                this.bindToController = true;
            }
        };
        DokumentDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickDokument', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], DokumentDirective);
        Common.DokumentDirective = DokumentDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let KassenbuchController = class KassenbuchController {
            constructor(scope, $qui, userService, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.userService = userService;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.accountingBookList = [];
                this.depositList = [];
                this.voucherTypeList = [];
                this.depositTypeList = [];
                this.formState = 'new';
                this.waitForPermissionCache();
                this.initForm();
                this.stammdatenService.getAccountingBookReferences().then((data) => {
                    const values = data.map(x => ({ value: x.objectId, text: x.displayTitle, group: x.objectTypeCaption }));
                    values.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                    values.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                    this.references = values;
                });
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    if (val.length > 1) {
                        for (let i = 0; i < val.length; i++) {
                            if (val[i].objType) {
                                if (val[i].objType === 140000) {
                                    clientsList.push(val[i].value);
                                }
                            }
                        }
                        this.form.participants = clientsList;
                    }
                    else {
                        this.form.participants = val;
                    }
                    this.form.clientId = this.form.participants[this.form.participants.length - 1];
                }, true);
                this.scope.$watch('vm.form.clientId', (newValue, oldValue) => {
                    if (newValue === oldValue || !newValue)
                        return;
                    if (newValue.value)
                        this.form.clientId = newValue.value;
                    if (!this.clientList.some(x => x.value === this.form.clientId))
                        this.form.clientId = oldValue;
                    if (this.form.clientId !== null && this.form.clientId !== undefined)
                        this.getAccountingBookList();
                });
                this.scope.$watch('vm.form.accountingBookId', () => {
                    if (this.form.accountingBookId !== null && this.form.accountingBookId !== undefined) {
                        for (let i = 0; i <= this.accountingBookList.length; i++) {
                            if (this.accountingBookList[i].value === this.form.accountingBookId) {
                                this.form.currency = this.accountingBookList[i].currency;
                                break;
                            }
                        }
                    }
                });
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[330003]) {
                    this.new = cacheObject.permissions[330003].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
                this.stammdatenService.getAccountingBookWv().then((datawvList) => {
                    this.form.clientId = this.form.participants[0];
                    this.wvList = datawvList;
                    this.userService.getUserSettings(["KLIENT.BELEGNUMMER_BUCHUNGSKREIS", "KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT", "KASSENBUCH.ShowFiBuDataInSearchDialog"], false).then((data) => {
                        this.generateVoucherNrPossible = (data[0].value.toLowerCase() !== "" && data[0].value.toLowerCase() !== Common.Constants.GUID_EMPTY);
                        this.generateVoucherNrPreselection = data[1].value.toLowerCase() === "true";
                        this.form.createVoucherNr = this.generateVoucherNrPreselection;
                        this.form.generateVoucherNrPossible = this.generateVoucherNrPossible;
                        this.getDepositList();
                        this.getDepositTypeList();
                        this.getVoucherTypeList();
                    });
                });
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                }
            }
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    clientId: null,
                    accountingBookId: null,
                    parentObjectId: null,
                    isDeposit: false,
                    voucherTypeId: null,
                    createVoucherNr: false,
                    generateVoucherNrPossible: false,
                    voucherNr: null,
                    voucherText: null,
                    amount: null,
                    currency: null,
                    comment: null,
                    date: new Date(),
                    participants: [],
                    version: null
                };
            }
            checkCanSave() {
                const canSave = (this.form.client !== null) && (this.form.accountingBookId !== null) &&
                    (this.form.isDeposit !== null) && (this.form.voucherTypeId !== null) && (this.form.date !== null) &&
                    (this.form.voucherText !== null) && (this.form.amount !== null);
                return canSave;
            }
            getClientList() {
                return this.clientList;
            }
            getAccountingBookList() {
                if (this.form.clientId !== '') {
                    this.stammdatenService.getAccountingBookList(this.form.clientId).then((dataAccountingBookList) => {
                        this.accountingBookList = dataAccountingBookList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.caption,
                                currency: obj.currency
                            };
                        });
                    });
                }
                return this.accountingBookList;
            }
            getDepositList() {
                this.depositList = [{
                        value: true,
                        text: "Einnahme"
                    }, {
                        value: false,
                        text: "Ausgabe"
                    }];
            }
            getVoucherTypeList() {
                this.voucherTypeList = this.wvList.paymentVoucherTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            }
            getDepositTypeList() {
                this.depositTypeList = this.wvList.depositVoucherTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            }
            addAccountingBookEntry() {
                this.form.amount = parseFloat(this.form.amount.toString().replace(',', '.'));
                this.stammdatenService.postAccountingBookEntry(this.form).then(() => {
                    this.initForm();
                    $('div.additional-field-dynamic.kassenbuch').fadeOut("slow").addClass("deactivated");
                });
            }
            putAccountingBookEntry(form) {
                if (form) {
                    $('div.additional-field-dynamic.kassenbuch').fadeOut("slow").addClass("deactivated");
                }
            }
        };
        KassenbuchController = __decorate([
            QMC.Controller('QMC.Common', 'KassenbuchDirectiveController'),
            QMC.Inject('$scope', '$qui', "UserService", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], KassenbuchController);
        let KassenbuchDirective = class KassenbuchDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Kassenbuch";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'KassenbuchDirectiveController';
                this.bindToController = true;
            }
        };
        KassenbuchDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickKassenbuch', ["UserService", "StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], KassenbuchDirective);
        Common.KassenbuchDirective = KassenbuchDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let ContactpersonController = class ContactpersonController {
            constructor(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.formState = 'new';
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    if (val.length > 1) {
                        for (let i = 0; i < val.length; i++) {
                            if (val[i].objType) {
                                if (val[i].objType === 140000) {
                                    clientsList.push(val[i].value);
                                }
                            }
                        }
                        this.form.participants = clientsList;
                    }
                    else {
                        this.form.participants = val;
                    }
                    this.form.parentObjectId = this.form.participants[this.form.participants.length - 1];
                }, true);
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.wv && !this.loading.client) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140006]) {
                    this.new = cacheObject.permissions[140006].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
                this.stammdatenService.getContactPersonWvList().then((datawvList) => {
                    this.wvList = datawvList;
                    this.loading.wv = false;
                });
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList;
                    this.loading.client = false;
                }
            }
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    contactPersonTypeId: null,
                    salutationId: null,
                    titleId: null,
                    forename: null,
                    name: null,
                    birthday: new Date(),
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    comment: null,
                    isContactBan: false,
                    participants: []
                };
            }
            getClientList() {
                return this.clientList;
            }
            getContactPersonTypeList() {
                return this.wvList.contactPersonTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            }
            getSalutationList() {
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then((data) => {
                        this.wvList = data;
                        return this.wvList.salutationWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.salutationWvList.map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
            }
            getTitleList() {
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then((data) => {
                        this.wvList = data;
                        return this.wvList.titleWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.titleWvList.map(obj => ({
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    }));
            }
            addContactperson(form) {
                this.stammdatenService.postContactPerson(this.form).then(() => {
                    $('div.additional-field-dynamic.kontaktperson').fadeOut("slow").addClass("deactivated");
                });
            }
            putContactperson(form) {
                if (form) {
                    $('div.additional-field-dynamic.kontaktperson').fadeOut("slow").addClass("deactivated");
                }
            }
        };
        ContactpersonController = __decorate([
            QMC.Controller('QMC.Common', 'ContactpersonDirectiveController'),
            QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], ContactpersonController);
        let ContactpersonDirective = class ContactpersonDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Contactperson";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'ContactpersonDirectiveController';
                this.bindToController = true;
            }
        };
        ContactpersonDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickContactperson', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], ContactpersonDirective);
        Common.ContactpersonDirective = ContactpersonDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let AufgabeDirectiveController = class AufgabeDirectiveController {
            constructor(scope, $qui, taskService, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.taskService = taskService;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.participants = [];
                this.formState = 'new';
                this.loading = {
                    employee: true,
                    personList: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const employeesList = [];
                    for (let i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 120000) {
                                employeesList.push(val[i].value);
                            }
                        }
                    }
                    this.form.participants = employeesList;
                    this.form.participants.push($('#session').data().personId);
                });
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.wv && !this.loading.employee && !this.loading.personList) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[840501]) {
                    this.new = cacheObject.permissions[840501].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForPersonListsCache();
                this.waitForEmployeeListCache();
                this.taskService.getTaskWv().then((dataTaskWv) => {
                    this.wv = dataTaskWv;
                    this.loading.wv = false;
                });
            }
            waitForEmployeeListCache() {
                const cacheObject = JSON.parse(sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE));
                if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
                    setTimeout(() => { this.waitForEmployeeListCache(); }, 250);
                }
                else {
                    this.participants = cacheObject.employeeList.concat(this.participants);
                    this.loading.employee = false;
                }
            }
            waitForPersonListsCache() {
                const cacheObject = JSON.parse(sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE));
                if (!cacheObject.personLists || cacheObject.personLists.loading) {
                    setTimeout(() => { this.waitForPersonListsCache(); }, 250);
                }
                else {
                    this.participants = this.participants.concat(cacheObject.personLists);
                    this.loading.personList = false;
                }
            }
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    taskName: null,
                    categoryId: null,
                    priorityId: null,
                    executionTypeId: null,
                    dateToFinishTill: new Date(),
                    isAppointment: false,
                    participants: [],
                    taskDescription: null
                };
            }
            getParticipantsList() {
                return this.participants;
            }
            getCategoryList() {
                return this.wv.categoryWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            }
            getPriorityList() {
                return this.wv.priorityWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            }
            getExecutionTypeList() {
                return this.wv.executionTypeWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            }
            addAufgabe(form) {
                this.taskService.postTask(form).then(() => {
                    $('div.additional-field-dynamic.aufgabe').fadeOut("slow").addClass("deactivated");
                });
            }
            putAufgabe(form) {
                if (form) {
                    this.taskService.putTask(form.objectId, form).then(() => {
                        $('div.additional-field-dynamic.aufgabe').fadeOut("slow").addClass("deactivated");
                    });
                }
            }
        };
        AufgabeDirectiveController = __decorate([
            QMC.Controller('QMC.Common', 'AufgabeDirectiveController'),
            QMC.Inject('$scope', '$qui', "AufgabenService", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], AufgabeDirectiveController);
        let AufgabeDirective = class AufgabeDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Aufgabe";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'AufgabeDirectiveController';
                this.bindToController = true;
            }
        };
        AufgabeDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickAufgabe', ["AufgabenService", "StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], AufgabeDirective);
        Common.AufgabeDirective = AufgabeDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let AppointmentDirectiveController = class AppointmentDirectiveController {
            constructor(scope, $qui, terminService, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.terminService = terminService;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.employeeList = [];
                this.formState = 'new';
                this.loading = {
                    client: true,
                    employee: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    const employeesList = [];
                    for (let i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 120000) {
                                employeesList.push(val[i].value);
                            }
                            else {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    this.form.participants = clientsList;
                    this.form.selectedEmployeeIds = employeesList;
                }, true);
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.client && !this.loading.employee) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[400000]) {
                    this.new = cacheObject.permissions[400000].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
                this.waitForEmployeeListCache();
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList;
                    this.loading.client = false;
                }
            }
            waitForEmployeeListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
                    setTimeout(() => { this.waitForEmployeeListCache(); }, 250);
                }
                else {
                    this.employeeList = cacheObject.employeeList;
                    this.loading.employee = false;
                }
            }
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    title: null,
                    participants: [],
                    selectedEmployeeIds: [],
                    participantIds: [],
                    dateTo: new Date(),
                    dateFrom: new Date(),
                    location: null,
                    description: null,
                    isPrivate: false,
                    isFinished: false,
                    isAllDay: false,
                    version: null
                };
            }
            getClientList() {
                return this.clientList;
            }
            getEmployeeList() {
                return this.employeeList;
            }
            addAppointment(form) {
                if (form.selectedEmployeeIds !== undefined)
                    form.participantIds = form.selectedEmployeeIds.concat(form.participants);
                else if (form.participants !== undefined)
                    form.participantIds = form.participants;
                this.terminService.postAppointment(form).then(() => {
                    $('div.additional-field-dynamic.termin').fadeOut("slow").addClass("deactivated");
                });
            }
            putAppointment(form) {
                if (form) {
                    if (form.selectedEmployeeIds !== undefined)
                        form.participantIds = form.selectedEmployeeIds.concat(form.participants);
                    else if (form.participants !== undefined)
                        form.participantIds = form.participants;
                    this.terminService.putAppointment(false, form.objectId, form.dateFrom, false, form).then(() => {
                        $('div.additional-field-dynamic.termin').fadeOut("slow").addClass("deactivated");
                    });
                }
            }
        };
        AppointmentDirectiveController = __decorate([
            QMC.Controller('QMC.Common', 'AppointmentDirectiveController'),
            QMC.Inject('$scope', '$qui', "TerminService", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], AppointmentDirectiveController);
        let AppointmentDirective = class AppointmentDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Appointment";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'AppointmentDirectiveController';
                this.bindToController = true;
            }
        };
        AppointmentDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickAppointment', ["TerminService", "StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], AppointmentDirective);
        Common.AppointmentDirective = AppointmentDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let AbsenteeismDirectiveController = class AbsenteeismDirectiveController {
            constructor(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.wvList = [];
                this.clientList = [];
                this.formState = 'new';
                this.loading = {
                    employee: true,
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    for (let i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.wv && !this.loading.client && !this.loading.employee) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140033]) {
                    this.new = cacheObject.permissions[140033].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
                this.waitForEmployeeListCache();
                this.stammdatenService.getAbsenteeismWv().then((data) => {
                    this.wvList = this.ui.select(data.absenteeismReasonWvList, { value: 'objectId', text: 'name' });
                    this.loading.wv = false;
                });
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            }
            waitForEmployeeListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
                    setTimeout(() => { this.waitForEmployeeListCache(); }, 250);
                }
                else {
                    this.clientList = this.clientList.concat(cacheObject.employeeList);
                    this.loading.employee = false;
                }
            }
            initForm() {
                this.form = {
                    id: null,
                    participants: [],
                    objectId: null,
                    dateTo: new Date(),
                    dateFrom: new Date(),
                    absenteeismReasonId: null,
                    parentObjectId: null,
                    comment: null
                };
            }
            getWvList() {
                return this.wvList;
            }
            getClientList() {
                return this.clientList;
            }
            addAbsenteeism(form) {
                for (let i = 0; i < form.participants.length; i++) {
                    const data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    this.stammdatenService.postAbsenteeism(data);
                }
                $('div.additional-field-dynamic.abwesenheit').fadeOut("slow").addClass("deactivated");
            }
            ;
        };
        AbsenteeismDirectiveController = __decorate([
            QMC.Controller('QMC.Common', 'AbsenteeismDirectiveController'),
            QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], AbsenteeismDirectiveController);
        let AbsenteeismDirective = class AbsenteeismDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Away";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'AbsenteeismDirectiveController';
                this.bindToController = true;
            }
        };
        AbsenteeismDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickAway', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], AbsenteeismDirective);
        Common.AbsenteeismDirective = AbsenteeismDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let DiseaseDirectiveController = class DiseaseDirectiveController {
            constructor(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.formState = 'new';
                this.diseases = [];
                this.wvList = [];
                this.clientList = [];
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    for (let i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.wv && !this.loading.client) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140002]) {
                    this.new = cacheObject.permissions[140002].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
                this.stammdatenService.getDiseaseWvList().then((data) => {
                    this.wvList = this.ui.select(data.diseaseCodeSchemaWvList, { value: 'id', text: 'name' });
                    this.loading.wv = false;
                    setTimeout(() => {
                        this.events();
                    }, 500);
                });
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList;
                    this.loading.client = false;
                }
            }
            events() {
                var vm = this;
                $('#liveDiseases .typeahead').typeahead({
                    source: function (query, process) {
                        vm.stammdatenService.getDiseasesBySearchText(vm.form.diseaseCodeSchemaId, query).then(function (data) {
                            vm.diseases = data.items;
                            process(data.items.map(function (obj) {
                                return obj.name;
                            }));
                        });
                    },
                    updater: function (item) {
                        /* Find the id to the selected text */
                        for (var i = 0; i < vm.diseases.length; i++) {
                            if (vm.diseases[i].name === item)
                                vm.form.diseaseId = vm.diseases[i].id;
                        }
                        return item;
                    }
                });
            }
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    comment: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    diseaseCodeSchemaId: QMC.Common.Constants.DEFAULT_DISEASE_CODE_SCHEMA,
                    diseaseId: null,
                    parentObjectId: null
                };
            }
            getDiseaseWvList() {
                return this.wvList;
            }
            getClientList() {
                return this.clientList;
            }
            addDisease(form) {
                for (let i = 0; i < form.participants.length; i++) {
                    const data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    this.stammdatenService.postDisease(data);
                }
                $('div.additional-field-dynamic.krankheit').fadeOut("slow").addClass("deactivated");
            }
            ;
        };
        DiseaseDirectiveController = __decorate([
            QMC.Controller('QMC.Common', 'DiseaseDirectiveController'),
            QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], DiseaseDirectiveController);
        let DiseaseDirective = class DiseaseDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Disease";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'DiseaseDirectiveController';
                this.bindToController = true;
            }
        };
        DiseaseDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickSick', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], DiseaseDirective);
        Common.DiseaseDirective = DiseaseDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let DocVisitDirectiveController = class DocVisitDirectiveController {
            constructor(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.formState = 'new';
                this.diseases = [];
                this.doctors = [];
                this.medOrgas = [];
                this.clientList = [];
                this.loading = {
                    client: true,
                    employee: false,
                    //employee: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    for (let i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.wv && !this.loading.client && !this.loading.employee) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140003]) {
                    this.new = cacheObject.permissions[140003].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
                //this.waitForEmployeeListCache();
                this.stammdatenService.getDoctorList().then((data) => {
                    this.doctors = this.ui.select(data, { value: 'id', text: 'displayTitle', group: this.lng.translate(20010508, 'Arzt') });
                    this.stammdatenService.getMedicalOrganisationList().then((data) => {
                        this.medOrgas = this.ui.select(data, { value: 'id', text: 'name', group: this.lng.translate(20023005, 'Medizinische Organisation') });
                        this.loading.wv = false;
                    });
                });
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            }
            //private waitForEmployeeListCache() {
            //    const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
            //    const cacheObject = JSON.parse(cache);
            //    if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
            //        setTimeout(() => { this.waitForEmployeeListCache() }, 250);
            //    } else {
            //        this.clientList = this.clientList.concat(cacheObject.employeeList);
            //        this.loading.employee = false;
            //    }
            //}
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    time: new Date(),
                    participants: [],
                    doctorId: null,
                    diagnose: null,
                    discipline: null,
                    forename: null,
                    name: null,
                    parentObjectId: null
                };
            }
            getDoctors() {
                return this.doctors.concat(this.medOrgas);
            }
            getClientList() {
                return this.clientList;
            }
            addDocVisit(form) {
                for (let i = 0; i < form.participants.length; i++) {
                    const data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    data.treaterObjectType = this.getTreaterObjectType(form.treaterId);
                    this.stammdatenService.postDoctorsVisit(data).then(() => {
                    });
                }
                $('div.additional-field-dynamic.arzt').fadeOut("slow").addClass("deactivated");
            }
            ;
            getTreaterObjectType(treaterId) {
                if (this.doctors.some(x => x.value === treaterId))
                    return 110000;
                if (this.medOrgas.some(x => x.value === treaterId))
                    return 310000;
                return 0;
            }
        };
        DocVisitDirectiveController = __decorate([
            QMC.Controller('QMC.Common', 'DocVisitDirectiveController'),
            QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], DocVisitDirectiveController);
        let DocvisitDirective = class DocvisitDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Docvisit";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'DocVisitDirectiveController';
                this.bindToController = true;
            }
        };
        DocvisitDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickDoctor', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], DocvisitDirective);
        Common.DocvisitDirective = DocvisitDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        let VaccinationDirectiveController = class VaccinationDirectiveController {
            constructor(scope, $qui, $q, stammdatenService, clientService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.$q = $q;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.formState = 'new';
                this.diseases = [];
                this.wvList = [];
                this.clientList = [];
                this.doctors = [];
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', (val) => {
                    if (!val)
                        val = [];
                    const clientsList = [];
                    for (let i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', () => {
                    if (!this.loading.wv && !this.loading.client) {
                        this.$qui.functionWaiter("createForm", this);
                    }
                }, true);
            }
            waitForPermissionCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140005]) {
                    this.new = cacheObject.permissions[140005].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(() => { this.waitForPermissionCache(); });
                    return;
                }
            }
            getData() {
                this.waitForClientListCache();
                this.stammdatenService.getVaccinationWv().then((data) => {
                    this.wvList = this.ui.select(data.diseaseVaccinationWvList, { value: 'id', text: 'name' });
                    this.stammdatenService.getDoctorList().then((data) => {
                        this.doctors = this.ui.select(data, { value: 'id', text: 'displayTitle' });
                        this.loading.wv = false;
                    });
                });
            }
            waitForClientListCache() {
                const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                const cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(() => { this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            }
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    participants: [],
                    date: new Date(),
                    dateFollowupAppointment: null,
                    caption: null,
                    comment: null,
                    batchNumber: null,
                    diseaseId: null,
                    doctorId: null
                };
            }
            getDiseases() {
                return this.wvList;
            }
            getClientList() {
                return this.clientList;
            }
            getDoctors() {
                return this.doctors;
            }
            addVaccination(form) {
                for (let i = 0; i < form.participants.length; i++) {
                    const data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    this.stammdatenService.postVaccination(data);
                }
                $('div.additional-field-dynamic.impfung').fadeOut("slow").addClass("deactivated");
            }
            ;
        };
        VaccinationDirectiveController = __decorate([
            QMC.Controller('QMC.Common', 'VaccinationDirectiveController'),
            QMC.Inject('$scope', '$qui', "$q", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
        ], VaccinationDirectiveController);
        let VaccinationDirective = class VaccinationDirective {
            constructor() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Vaccination";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'VaccinationDirectiveController';
                this.bindToController = true;
            }
        };
        VaccinationDirective = __decorate([
            QMC.Directive('QMC.Common', 'qmFormQuickImmunization', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
        ], VaccinationDirective);
        Common.VaccinationDirective = VaccinationDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        let ContingentDirective = class ContingentDirective {
            constructor(flsService, userService, $qui) {
                this.flsService = flsService;
                this.userService = userService;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmOpen: '=',
                    qmCase: '=',
                    qmDate: '='
                };
                this.templateUrl = 'Templates/Contingent';
                this.link = (scope, element, attrs) => {
                    var _a, _b;
                    scope.id = 'qmContingent_' + ((_b = (_a = scope.qmCase) === null || _a === void 0 ? void 0 : _a.objectId) !== null && _b !== void 0 ? _b : Math.random().toString(36).substr(2, 9));
                    scope.dontShowIndirect = window.dontShowIndirectContingent;
                    if (scope.dontShowIndirect === undefined) {
                        this.userService.getUserSettings(["FLS.CONTINGENT.DONTSHOWINDRECT",]).then((data) => {
                            scope.dontShowIndirect = $.grep(data, function (e) { return e.key === "FLS.CONTINGENT.DONTSHOWINDRECT"; })[0].value.toLowerCase() === "true";
                            window.dontShowIndirectContingent = scope.dontShowIndirect;
                        });
                    }
                    scope.qmOpen = () => {
                        if (!scope.qmCase)
                            return;
                        scope.date = scope.qmDate ? angular.copy(scope.qmDate) : moment().startOf('day').toDate();
                        $('#' + scope.id).modal('show');
                        this.$qui.scopeApply(scope);
                    };
                    scope.$watch('date', (newVal, oldVal) => {
                        const newValDate = new Date(newVal);
                        const oldValDate = new Date(oldVal);
                        if (JSON.stringify(newValDate).substring(1, 11) === JSON.stringify(oldValDate).substring(1, 11) || !newVal)
                            return;
                        scope.load = true;
                        this.flsService.getContingent(scope.qmCase.objectId, scope.date).then((data) => {
                            scope.contingent = data;
                        }).finally(() => {
                            scope.load = false;
                        });
                    });
                    scope.$watch('qmCase', (newVal, oldVal) => {
                        if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                            return;
                        scope.date = undefined;
                        scope.contingent = undefined;
                    });
                    scope.showTargetDetails = (contingent) => {
                        return !scope.dontShowIndirect && contingent.targetedAmounts.direct && contingent.targetedAmounts.indirect;
                    };
                };
            }
        };
        ContingentDirective = __decorate([
            QMC.Directive('QMC.Directives', 'qmContingent', ['FachleistungService', 'UserService', '$qui'])
        ], ContingentDirective);
        Directives.ContingentDirective = ContingentDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        let IncludeDirective = class IncludeDirective {
            constructor($qui, $timeout, identityService) {
                this.$qui = $qui;
                this.$timeout = $timeout;
                this.identityService = identityService;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmPath: '=',
                    qmId: '@',
                    qmHeaderName: '@',
                    qmParams: '='
                };
                this.templateUrl = 'Templates/Include';
                this.link = (scope, element, attrs) => {
                    let secret = '';
                    let frame = null;
                    let iFrame = null;
                    if (scope.qmId === (null || undefined))
                        scope.qmId = '_' + Math.random().toString(36).substring(2, 11);
                    if (scope.qmHeaderName === (null || undefined))
                        scope.qmHeaderName = 'header';
                    const ceBaseUrl = $('#session').data().ceUrl;
                    if (!ceBaseUrl || ceBaseUrl.length === 0) {
                        element.innerHtml = "<strong>No exchange client url supplied</strong>";
                        return;
                    }
                    this.identityService.setSecretToken().then((data) => {
                        console.warn('got token token', data);
                        secret = data;
                        createIFrame();
                    });
                    scope.$watch('qmPath', () => {
                        createIFrame();
                    });
                    this.$timeout(() => {
                        frame = $('#' + scope.qmId);
                        createIFrame();
                    });
                    const createIFrame = () => {
                        var _a;
                        scope.loading = true;
                        if (frame === null || scope.qmPath === '' || secret === '')
                            return;
                        frame.remove('#' + scope.qmId + '_frame');
                        iFrame = document.createElement('iframe');
                        let color = '';
                        const colors = window.bodyColorClasses.split(' ');
                        for (let i = 0; i < colors.length; i++) {
                            if (document.body.classList.contains(colors[i])) {
                                color = colors[i];
                                break;
                            }
                        }
                        iFrame.src = (scope.qmPath.startsWith('http') ? '' : ceBaseUrl) + scope.qmPath
                            + '?secret=' + secret
                            + '&color=' + color
                            + '&oldClientUrl=' + location.origin + location.pathname
                            + '&dbConnection=' + $('#session').data().dbConnection
                            + '&' + new URLSearchParams(scope.qmParams).toString();
                        iFrame.style = 'width: 100%; height: 100%; border:0px;';
                        iFrame.id = scope.qmId + '_frame';
                        iFrame.sandbox = 'allow-downloads allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation';
                        frame.append(iFrame);
                        resize();
                        const onLoad = () => {
                            var _a;
                            scope.loading = false;
                            this.$qui.scopeApply(this);
                            (_a = document.getElementById(scope.qmId + '_frame')) === null || _a === void 0 ? void 0 : _a.removeEventListener('load', onLoad);
                        };
                        (_a = document.getElementById(scope.qmId + '_frame')) === null || _a === void 0 ? void 0 : _a.addEventListener('load', onLoad);
                    };
                    const resize = () => {
                        if (iFrame === null)
                            return;
                        const isMobile = QMC.Common.Constants.IS_MOBILE;
                        iFrame.style.height = 0 + "px";
                        const headerHeight = document.getElementById(scope.qmHeaderName) ? $('#' + scope.qmHeaderName).height() : 0;
                        if (isMobile) {
                            iFrame.style.height = Math.floor(window.innerHeight - 60 - $('#version-footer').height()) + "px";
                        }
                        else {
                            iFrame.style.height = Math.floor($('#page-wrapper').height() - headerHeight - $('#version-footer').height()) - 65 + "px";
                        }
                    };
                    createIFrame();
                    window.onresize = () => { resize(); };
                };
            }
        };
        IncludeDirective = __decorate([
            QMC.Directive('QMC.Directives', 'qmInclude', ['$qui', '$timeout', 'QmcIdentityService'])
        ], IncludeDirective);
        Directives.IncludeDirective = IncludeDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        let MarkItemDirective = class MarkItemDirective {
            constructor(markItemService, userService) {
                this.markItemService = markItemService;
                this.userService = userService;
                this.scope = {
                    saveMarkItem: '@',
                    qmBtnCircle: '=',
                    qmParentObjectIds: '=?',
                    qmParentObjectId: '=?',
                    qmParentObjectType: '@',
                    markItems: '@',
                    selectedMarkItems: '='
                };
                this.restrict = 'EA';
                this.templateUrl = 'Templates/MarkItem';
                this.link = (scope) => {
                    //first try to get the selectedMarkItems, for not showing validation error
                    scope.loadElements = () => {
                        if (scope.qmParentObjectIds == undefined || scope.qmParentObjectIds == null || scope.qmParentObjectIds.length == 0) {
                            scope.qmParentObjectIds = [];
                            scope.qmParentObjectIds.push(scope.qmParentObjectId);
                        }
                        this.markItemService.getMarkItems().then((data) => {
                            scope.markItems = data;
                            this.markItemService.getSelectedMarkItems(scope.qmParentObjectIds[0], scope.qmParentObjectType).then((data) => {
                                scope.selectedMarkItems = data;
                                for (let i = 0; i < scope.markItems.length; i++) {
                                    scope.markItems[i].isSelected = false;
                                    for (let j = 0; j < scope.selectedMarkItems.length; j++) {
                                        if (scope.markItems[i].id === scope.selectedMarkItems[j].markItemId) {
                                            scope.markItems[i].isSelected = true;
                                            if (scope.enableReason) {
                                                scope.markItems[i].reason = scope.selectedMarkItems[j].reason;
                                            }
                                        }
                                    }
                                }
                            });
                        });
                    };
                    this.userService.getUserSettings(['MARKIEREN.GRUND'], false).then((data) => {
                        scope.enableReason = data[0].value.toLowerCase() === 'true';
                        scope.loadElements();
                    });
                    scope.initModal = () => {
                        scope.loadElements();
                    };
                    scope.saveSelectedMarkItems = () => {
                        scope.selectedMarkItems = [];
                        for (let j = 0; j < scope.qmParentObjectIds.length; j++) {
                            const data = {
                                parentObjectId: scope.qmParentObjectIds[j],
                                parentObjectType: parseInt(scope.qmParentObjectType),
                                markItems: [],
                                id: null,
                                objectId: null
                            };
                            for (let i = 0; i < scope.markItems.length; i++) {
                                if (scope.markItems[i].isSelected) {
                                    data.markItems.push({ key: scope.markItems[i].id, value: scope.enableReason && scope.markItems[i].reason && scope.markItems[i].reason.length > 0 ? scope.markItems[i].reason : '' });
                                    scope.selectedMarkItems.push({ key: scope.markItems[i].id, value: scope.enableReason && scope.markItems[i].reason && scope.markItems[i].reason.length > 0 ? scope.markItems[i].reason : '' });
                                }
                            }
                            this.markItemService.putSelectedMarkItems(data);
                        }
                    };
                };
            }
        };
        MarkItemDirective = __decorate([
            QMC.Directive('QMC.Directives', 'qmMarkItem', ['QmcMarkItemService', 'UserService'])
        ], MarkItemDirective);
        Directives.MarkItemDirective = MarkItemDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        class MaximizeModalButton {
            constructor() {
                this.isMax = false;
            }
            toggle(buttonElement) {
                $(buttonElement).parents().find('.modal-dialog.resizable').toggleClass('modal-fullscreen');
                this.isMax = !this.isMax;
            }
        }
        angular.module('QMC.Directives').component('qmMaximizeModalButton', {
            controller: [MaximizeModalButton],
            controllerAs: 'vm',
            replace: true,
            template: '<span class="close hidden-xs" ng-click="vm.toggle($event.currentTarget)">' +
                '<i ng-if="!vm.isMax"  class="fa fa-expand" aria-hidden="true"> </i>' +
                '<i ng-if="vm.isMax" class="fa fa-compress" aria-hidden="true"> </i>' +
                '</span>'
        });
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        let PrivateContent = class PrivateContent {
            constructor(privateContentService, permissionService, $qui) {
                this.privateContentService = privateContentService;
                this.permissionService = permissionService;
                this.$qui = $qui;
                this.scope = {
                    savePrivateContent: '@',
                    qmReference: '=',
                    qmParent: '=',
                    qmObjectType: '=',
                    qmFloating: '=',
                    qmMuted: '='
                };
                this.restrict = 'EA';
                this.templateUrl = 'Templates/PrivateContent';
                this.link = (scope) => {
                    this.getPermission(scope);
                    scope.newPC = true;
                    scope.sn = { comment: '' };
                    scope.init = false;
                    scope.openModal = () => {
                        scope.loading = true;
                        $("#privateContentModal" + scope.qmParent).modal("show");
                        this.privateContentService.getPrivateContent(scope.qmParent, scope.qmReference).then((data) => {
                            if (data !== null) {
                                scope.newPC = false;
                                scope.sn.comment = data.comment;
                            }
                            else {
                                scope.newPC = true;
                                scope.sn.comment = '';
                            }
                            scope.loading = false;
                            if (!scope.init) {
                                scope.init = true;
                            }
                        });
                    };
                    scope.save = () => {
                        document.getElementById("pcSaveBtn").focus();
                        scope.loading = true;
                        if (scope.newPC) {
                            this.privateContentService.postPrivateContent({
                                referenceObjectId: scope.qmReference,
                                parentObjectId: scope.qmParent,
                                parentObjectType: scope.qmObjectType,
                                comment: scope.sn.comment,
                                id: null,
                                objectId: null
                            }).then((response) => {
                                $("#privateContentModal" + scope.qmParent).modal("hide");
                            }).finally(() => {
                                scope.loading = false;
                            });
                        }
                        // recycle an existing pc
                        else {
                            this.privateContentService.putPrivateContent(scope.qmParent, scope.qmReference, {
                                comment: scope.sn.comment,
                                id: null,
                                objectId: null
                            }).then((response) => {
                                $("#privateContentModal" + scope.qmParent).modal("hide");
                            }).finally(() => {
                                scope.loading = false;
                            });
                        }
                    };
                };
            }
            getPermission(scope) {
                var storagePermission = sessionStorage.getItem("privateContentPermission");
                if (storagePermission && storagePermission !== '') {
                    var data = JSON.parse(storagePermission);
                    if (Date.now() - this.$qui.createDateFromString(data.timeStamp) < 5 * 60 * 1000) { // only if permission is max 5 minutes old
                        scope.delete = data.delete && data.moduleAccess;
                        scope.new = data.new && data.moduleAccess;
                        scope.modify = data.modify && data.moduleAccess;
                        scope.view = data.view && data.moduleAccess;
                    }
                    else {
                        //getPermission();
                        this.$qui.cachePrivateContentPermission(this.permissionService);
                        setTimeout(() => { this.getPermission(scope); }, 500);
                    }
                }
                else {
                    //getPermission();
                    this.$qui.cachePrivateContentPermission(this.permissionService);
                    setTimeout(() => { this.getPermission(scope); }, 500);
                }
            }
            ;
        };
        PrivateContent = __decorate([
            QMC.Directive('QMC.Directives', 'qmPrivateContent', ['QmcPrivateContentService', 'QmcPermissionService', '$qui'])
        ], PrivateContent);
        Directives.PrivateContent = PrivateContent;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
function qmQuickMessageDirective(internalMessageService, $qui, lngService, permissionService) {
    const cacheName = 'QuickMessageCache';
    return {
        scope: {
            qmTitle: '@',
            qmSubject: '<',
            qmMessage: '<',
            qmBtn: '<',
            qmBtnCircle: '<',
            qmLabel: '@',
            qmIcon: '@',
            qmId: '@',
            qmBtnClass: '@',
            open: '<'
        },
        restrict: 'E',
        templateUrl: 'Templates/QuickMessage',
        link: function (scope) {
            scope.sn = { createSummernote: null };
            scope.$watch('open', function () {
                if (scope.open) {
                    scope.openModal();
                }
            });
            if (!scope.qmId) {
                scope.qmId = '_' + Math.random().toString(36).slice(2, 11);
            }
            if (!scope.qmMessage) {
                scope.qmMessage = lngService.translate(20000251, 'Melden');
            }
            if (!scope.qmIcon) {
                scope.qmIcon = 'fa-envelope-o';
            }
            if (!scope.qmTitle) {
                scope.qmTitle = lngService.translate(20000251, 'Melden');
            }
            scope.openModal = function () {
                scope.form = {
                    subject: scope.qmSubject || '',
                    messageText: scope.qmMessage || '',
                    recipientIds: [],
                    attachments: []
                };
                scope.file = {
                    uploads: [],
                    names: []
                };
                scope.sn.createSummernote();
                $('#messageModal-' + scope.qmId).modal('show');
            };
            function loadPermissionAndRecipients() {
                sessionStorage.setItem(cacheName, JSON.stringify({
                    loading: true
                }));
                permissionService.getPermissionsByObjectTypes([750001, 750003]).then(function (perm) {
                    if (!perm[0].new) {
                        return;
                    }
                    scope.permission = true;
                    scope.permissionAttachement = perm[1].new;
                    internalMessageService.getAvailableRecipients().then(function (data) {
                        scope.availableRecipients = [];
                        scope.loading = false;
                        for (const item of data) {
                            if (item.objectType === 190000) {
                                scope.availableRecipients.push({
                                    value: item.objectId,
                                    text: item.lastName + ' (' + lngService.translate(20000250, 'Liste') + ')'
                                });
                            }
                            else {
                                let name = item.lastName;
                                if (item.firstName.length > 0) {
                                    name = name + ', ' + item.firstName;
                                }
                                scope.availableRecipients.push({
                                    value: item.objectId,
                                    text: name
                                });
                            }
                        }
                        sessionStorage.setItem(cacheName, JSON.stringify({
                            timestamp: new Date(),
                            data: scope.availableRecipients,
                            permission: scope.permission,
                            permissionAttachement: scope.permissionAttachement
                        }));
                    });
                });
            }
            scope.init = function () {
                scope.loading = true;
                scope.permission = false;
                const rawCache = sessionStorage.getItem(cacheName);
                if (rawCache) {
                    const cache = JSON.parse(rawCache);
                    cache.timestamp = new Date(cache.timestamp);
                    if (Math.round((cache.timestamp.getTime() - Date.now()) / 1000 / 60) <= 15) {
                        scope.permission = cache.permission;
                        scope.permissionAttachement = cache.permissionAttachement;
                        scope.availableRecipients = cache.data;
                        scope.loading = false;
                        return;
                    }
                    if (cache.loading) {
                        setTimeout(function () { scope.init(); }, 250);
                        return;
                    }
                }
                loadPermissionAndRecipients();
            };
            scope.init();
            scope.send = function () {
                for (let i = 0; i < scope.file.uploads.length; i++) {
                    scope.form.attachments.push({
                        fileName: scope.file.names[i],
                        attachmentBase64String: scope.file.uploads[i]
                    });
                }
                scope.loading = true;
                internalMessageService.postMessage(scope.form).then(function () {
                    $('#messageModal-' + scope.qmId).modal('hide');
                    $('div.additional-field-dynamic.nachricht').fadeOut('slow').addClass('deactivated');
                }).finally(function () {
                    scope.loading = false;
                });
            };
            scope.openFileSelector = function () {
                $('#fileselect-' + scope.qmId).click();
            };
            scope.removeFile = function (index) {
                scope.file.uploads.splice(index, 1);
                scope.file.names.splice(index, 1);
            };
            scope.fileTypeIcon = function (fileName) {
                const type = fileName.split('.')[fileName.split('.').length - 1].toLocaleLowerCase();
                let icon = 'fa fa-';
                switch (type) {
                    case 'jpg':
                    case 'gif':
                    case 'png':
                        icon += 'file-image-o';
                        break;
                    case 'txt':
                        icon += 'file-txt-o';
                        break;
                    case 'xdoc':
                    case 'doc':
                        icon += 'file-word-o';
                        break;
                    case 'zip':
                    case 'rar':
                        icon += 'file-zip-o';
                        break;
                    case 'pdf':
                        icon += 'file-pdf-o';
                        break;
                    case 'csv':
                    case 'xlxs':
                        icon += 'file-excel-o';
                        break;
                    case 'xppt':
                    case 'ppt':
                        icon += 'file-powerpoint-o';
                        break;
                    default:
                        icon += 'file-o';
                }
                return icon;
            };
        }
    };
}
angular.module('QMC.Directives').directive('qmQuickMessage', [
    'NachrichtenService',
    '$qui',
    'QmcLanguageService',
    'QmcPermissionService',
    qmQuickMessageDirective
]);
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        let SurveyDirective = class SurveyDirective {
            constructor(userService) {
                this.userService = userService;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {};
                this.templateUrl = 'Templates/Survey';
                this.link = (scope) => {
                    this.userService.getSurvey().then((data) => {
                        scope.survey = data;
                        if (data) {
                            setTimeout(() => $('#surveyModal').modal('show'), 5000); //delay show of modal to prevent automatic close on app init
                        }
                    });
                    scope.closeSurvey = (dismissSurvey, performed = false) => {
                        if (dismissSurvey)
                            this.userService.dismissSurvey(scope.survey.surveyId, performed);
                        $('#surveyModal').modal('hide');
                    };
                    scope.participateInSurvey = () => {
                        scope.closeSurvey(true, true);
                        window.open(scope.survey.link, '_blank').focus();
                    };
                };
            }
        };
        SurveyDirective = __decorate([
            QMC.Directive('QMC.Directives', 'qmSurvey', ['UserService'])
        ], SurveyDirective);
        Directives.SurveyDirective = SurveyDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
/**
 * Directive that logs out the user after a configurable period of inactivity.
 * Uses SECURITY.INACTIVITYTIMEOUT from user settings (value in minutes).
 * 0 or negative disables idle logout.
 */
(function () {
    'use strict';
    const IDLE_EVENTS = [
        'DOMMouseScroll', 'mousedown', 'mousemove', 'mousewheel',
        'MSPointerDown', 'MSPointerMove', 'keydown', 'keyup', 'keypress',
        'touchmove', 'touchstart', 'wheel', 'focusin', 'focus'
    ];
    const CHECK_INTERVAL_MS = 10000;
    // focus does not bubble; use capture so we get it when any element receives focus
    const USE_CAPTURE_EVENTS = { focus: true };
    function idleLogoutDirective(userService) {
        return {
            restrict: 'E',
            scope: {},
            template: '',
            link: function (scope) {
                let idleInterval;
                let interactionCallback = null;
                let timeoutMs = 0;
                function clearIdleInterval() {
                    if (idleInterval != null) {
                        clearInterval(idleInterval);
                        idleInterval = null;
                    }
                }
                function cleanupListeners() {
                    if (interactionCallback == null)
                        return;
                    document.removeEventListener('visibilitychange', interactionCallback);
                    IDLE_EVENTS.forEach(function (eventName) {
                        const capture = USE_CAPTURE_EVENTS[eventName] === true;
                        document.removeEventListener(eventName, interactionCallback, capture);
                    });
                    interactionCallback = null;
                }
                function setupIdleTimeout(timeoutMinutes) {
                    timeoutMs = timeoutMinutes * 60 * 1000;
                    if (timeoutMs <= 0)
                        return;
                    window.activityTimestamp = Date.now();
                    function checkIdle() {
                        if ((Date.now() - window.activityTimestamp) >= timeoutMs) {
                            clearIdleInterval();
                            cleanupListeners();
                            userService.logout();
                        }
                    }
                    interactionCallback = function () {
                        checkIdle();
                        window.activityTimestamp = Date.now();
                    };
                    IDLE_EVENTS.forEach(function (eventName) {
                        const capture = USE_CAPTURE_EVENTS[eventName] === true;
                        document.addEventListener(eventName, interactionCallback, capture);
                    });
                    document.addEventListener('visibilitychange', interactionCallback);
                    idleInterval = setInterval(checkIdle, CHECK_INTERVAL_MS);
                }
                userService.getUserSettings(['SECURITY.INACTIVITYTIMEOUT'])
                    .then(function (data) {
                    const raw = data[0].value;
                    const timeoutMinutes = parseInt(raw && raw.length ? raw : '0', 10) || 0;
                    setupIdleTimeout(timeoutMinutes);
                })
                    .catch(function () {
                    setupIdleTimeout(30);
                });
                scope.$on('$destroy', function () {
                    clearIdleInterval();
                    cleanupListeners();
                });
            }
        };
    }
    angular.module('qmc-ui').directive('qmIdleLogout', ['UserService', idleLogoutDirective]);
})();
function qmTableDirective($languageService, $timeout, $qui) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        priority: 101,
        scope: {
            qmData: '=',
            qmCardToggle: '=?',
            qmHasAvatar: '=?',
            qmTitle: '@',
            qmScopeCallback: '&',
            qmFilter: '=?',
            qmFilterProperties: '=?',
            qmItems: '=?',
            qmCards: '=?',
            qmLoading: '=',
            qmToggleProp: '=',
            qmToggle: '=',
            qmCalculateProp: '=',
            qmCalculatePropToTime: '=',
            qmCalculated: '=?',
            qmCreateTable: '=',
            qmStandardData: '@',
            qmColor: '@',
            qmPage: '=?',
            qmPaginationInfo: '=?',
            qmNoBox: '=?',
            qmLocalPagination: '=?',
            qmLocalPaginationSize: '=?',
            qmOnSort: '&?'
        },
        templateUrl: 'Element/Table',
        link: (scope, element, attrs) => {
            class Callback {
                constructor(name, param) {
                    this.run = () => {
                        scope.qmScopeCallback()[this.n](this.p);
                    };
                    this.p = param;
                    this.n = name;
                }
            }
            scope.randomId = '_' + Math.random().toString(36).substring(2, 11);
            const $qui = new qmwcUI();
            // Cache for sorted and filtered data
            let cachedSortedData = [];
            let cachedFilteredData = [];
            let lastFilterValue = '';
            let lastSortType = null;
            let lastSortReverse = false;
            // Cache for localPaginationFilter performance optimization
            let itemIndexCache = new Map();
            let lastPaginationData = [];
            let lastPaginationPage = -1;
            let lastPaginationSize = -1;
            let lastPaginationCardToggle = undefined;
            let cachedPaginationInfo = null;
            // Optimized sorting function with caching
            const sortData = (data, sortType, sortReverse) => {
                if (!data || !sortType)
                    return data;
                if (cachedSortedData.length === data.length && lastSortType === sortType && lastSortReverse === sortReverse) {
                    return cachedSortedData;
                }
                const sorted = [...data].sort((a, b) => {
                    var _a, _b;
                    const aVal = (_a = a[sortType.model]) === null || _a === void 0 ? void 0 : _a.value;
                    const bVal = (_b = b[sortType.model]) === null || _b === void 0 ? void 0 : _b.value;
                    if (aVal === bVal)
                        return 0;
                    if (aVal === null || aVal === undefined)
                        return 1;
                    if (bVal === null || bVal === undefined)
                        return -1;
                    return aVal < bVal ? -1 : 1;
                });
                if (sortReverse) {
                    sorted.reverse();
                }
                cachedSortedData = sorted;
                lastSortType = sortType;
                lastSortReverse = sortReverse;
                return sorted;
            };
            // Optimized filter function with caching for transformed table data
            const filterData = (data, filter, filterProperties) => {
                if (!(filter === null || filter === void 0 ? void 0 : filter.length))
                    return data;
                if (cachedFilteredData.length === data.length && lastFilterValue === filter) {
                    return cachedFilteredData;
                }
                const filtered = data.filter(row => {
                    if (!(filterProperties === null || filterProperties === void 0 ? void 0 : filterProperties.length)) {
                        return Object.values(row).some(val => val && typeof val === 'object' && 'value' in val &&
                            val.value.toString().toLowerCase().includes(filter.toLowerCase()));
                    }
                    return filterProperties.some(prop => {
                        var _a;
                        const val = (_a = row[prop]) === null || _a === void 0 ? void 0 : _a.value;
                        return val === null || val === void 0 ? void 0 : val.toString().toLowerCase().includes(filter.toLowerCase());
                    });
                });
                cachedFilteredData = filtered;
                lastFilterValue = filter;
                return filtered;
            };
            // Filter function for original raw data
            const filterOriginalData = (data, filter, filterProperties) => {
                if (!(filter === null || filter === void 0 ? void 0 : filter.length))
                    return data;
                const filtered = data.filter(row => {
                    if (!(filterProperties === null || filterProperties === void 0 ? void 0 : filterProperties.length)) {
                        // Search in all string values of the original data
                        return Object.values(row).some(val => {
                            if (val && typeof val === 'string') {
                                return val.toLowerCase().includes(filter.toLowerCase());
                            }
                            return false;
                        });
                    }
                    return filterProperties.some(prop => {
                        const val = row[prop];
                        return val === null || val === void 0 ? void 0 : val.toString().toLowerCase().includes(filter.toLowerCase());
                    });
                });
                return filtered;
            };
            scope.page = (input) => {
                scope.qmPage = input;
            };
            if (scope.qmLocalPagination !== false) {
                scope.qmPaginationInfo = {
                    totalItemsCount: 0,
                    totalPages: 0
                };
                scope.qmLocalPaginationSize = scope.qmLocalPaginationSize ? scope.qmLocalPaginationSize : 30;
            }
            scope.sortReverse = false;
            scope.sortType = null;
            scope.isRendering = false;
            if (!scope.qmHasAvatar) {
                scope.qmHasAvatar = false;
            }
            if (scope.qmToggleProp != null) {
                scope.toggleFilter = (entry) => {
                    if (scope.qmToggleProp == null)
                        return true;
                    if (scope.qmToggleProp.charAt(0) === '!') {
                        const prop = scope.qmToggleProp.substr(1, scope.qmToggleProp.length);
                        if (entry[prop] != null) {
                            return scope.qmToggle ? !(entry[prop].value) : true;
                        }
                    }
                    if (entry[scope.qmToggleProp] != null) {
                        return scope.qmToggle ? entry[scope.qmToggleProp].value : true;
                    }
                    return false;
                };
            }
            // Track viewport width to handle responsive behavior
            // The viewport width is the ONLY decision factor for mobile/desktop view - not the device type
            const mobileContext = window.QmcMobileContext;
            const MOBILE_BREAKPOINT = mobileContext ? mobileContext.TABLE_BREAKPOINT_PX : 768;
            const updateViewportState = () => {
                const isMobileWidth = window.innerWidth < MOBILE_BREAKPOINT;
                // Only update scope if value actually changed to avoid unnecessary digest cycles
                if (scope.mobile !== isMobileWidth) {
                    scope.mobile = isMobileWidth;
                    scope.tablet = isMobileWidth; // tablet behaves the same as mobile for view switching
                    $qui.scopeApply(scope);
                }
            };
            // Initial values based on viewport width only
            scope.mobile = window.innerWidth < MOBILE_BREAKPOINT;
            scope.tablet = window.innerWidth < MOBILE_BREAKPOINT;
            // Listen for resize events (debounced)
            let resizeTimeout = null;
            const handleResize = () => {
                if (resizeTimeout) {
                    clearTimeout(resizeTimeout);
                }
                resizeTimeout = setTimeout(() => {
                    updateViewportState();
                }, 150);
            };
            $(window).on('resize.qmTable' + scope.randomId, handleResize);
            // Check if server-side pagination is active
            const isServerSidePagination = () => {
                return scope.qmPage !== null && scope.qmPage !== undefined &&
                    scope.qmPaginationInfo !== null && scope.qmPaginationInfo !== undefined &&
                    scope.qmLocalPagination === false;
            };
            scope.setSortType = (obj) => {
                var _a, _b, _c;
                // Compare by model property, not object reference (objects are recreated on table reload)
                const isSameColumn = ((_a = scope.sortType) === null || _a === void 0 ? void 0 : _a.model) === (obj === null || obj === void 0 ? void 0 : obj.model);
                if (isSameColumn) {
                    // Toggle sort direction when clicking the same column
                    scope.sortReverse = !scope.sortReverse;
                }
                else {
                    // New column selected, start with ascending
                    scope.sortType = obj;
                    scope.sortReverse = false;
                }
                // If server-side pagination is active, trigger callback for server-side sorting
                if (isServerSidePagination() && scope.qmOnSort) {
                    const sortBy = ((_b = scope.sortType) === null || _b === void 0 ? void 0 : _b.model) || ((_c = scope.sortType) === null || _c === void 0 ? void 0 : _c.key) || '';
                    scope.qmOnSort({
                        sortBy: sortBy,
                        sortDescending: scope.sortReverse
                    });
                }
                else {
                    scope.getItems();
                }
            };
            scope.$watch('qmFilter', (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    cachedFilteredData = [];
                    itemIndexCache.clear();
                    cachedPaginationInfo = null;
                    scope.getItems();
                }
            });
            // Clear cache when relevant data changes
            scope.$watch('qmCardToggle', () => {
                itemIndexCache.clear();
                cachedPaginationInfo = null;
            });
            scope.$watch('qmPage', () => {
                // Only recalculate pagination info, keep index cache
                cachedPaginationInfo = null;
            });
            scope.getTotalItems = () => {
                if (scope.qmPaginationInfo) {
                    return scope.qmPaginationInfo.totalItemsCount;
                }
                return scope.qmData.length;
            };
            scope.propFilter = (row) => {
                var _a;
                if (!((_a = scope.qmFilter) === null || _a === void 0 ? void 0 : _a.length) || ((scope.qmPage !== null) && scope.qmPaginationInfo && scope.qmLocalPagination === false)) {
                    return true;
                }
                for (const key in row) {
                    const value = row[key].value;
                    if (!value || typeof value !== 'string' || (scope.qmFilterProperties && scope.qmFilterProperties.length > 0 && !scope.qmFilterProperties.includes(key))) {
                        continue;
                    }
                    if (row[key].dType && row[key].dType.toLowerCase() === 'date' && !row[key].withTime) {
                        const dateValue = value.substring(0, value.indexOf('T') > 0 ? value.indexOf('T') : value.length);
                        if (dateValue === null || dateValue === void 0 ? void 0 : dateValue.toLowerCase().includes(scope.qmFilter.toLowerCase())) {
                            return true;
                        }
                    }
                    if (value === null || value === void 0 ? void 0 : value.toLowerCase().includes(scope.qmFilter.toLowerCase())) {
                        return true;
                    }
                }
                return false;
            };
            scope.localPaginationFilter = (row) => {
                if (!scope.qmLocalPaginationSize)
                    return true;
                scope.qmItems = scope.qmItems ? scope.qmItems : scope.qmData.data;
                const items = scope.qmCardToggle ? scope.qmCards : scope.qmItems;
                // Cache pruning: Clear cache when data changes
                const dataChanged = lastPaginationData !== items ||
                    lastPaginationPage !== scope.qmPage ||
                    lastPaginationSize !== scope.qmLocalPaginationSize ||
                    lastPaginationCardToggle !== scope.qmCardToggle;
                if (dataChanged) {
                    itemIndexCache.clear();
                    lastPaginationData = items;
                    lastPaginationPage = scope.qmPage;
                    lastPaginationSize = scope.qmLocalPaginationSize;
                    lastPaginationCardToggle = scope.qmCardToggle;
                    cachedPaginationInfo = null;
                }
                // Cache pagination info
                if (!cachedPaginationInfo) {
                    cachedPaginationInfo = {
                        totalItemsCount: items.length,
                        totalPages: Math.ceil(items.length / scope.qmLocalPaginationSize)
                    };
                    scope.qmPaginationInfo = cachedPaginationInfo;
                }
                else {
                    scope.qmPaginationInfo = cachedPaginationInfo;
                }
                const currentRangeStart = scope.qmPage * scope.qmLocalPaginationSize;
                const currentRangeEnd = (scope.qmPage + 1) * scope.qmLocalPaginationSize;
                // Optimized index search with caching
                let itemIndex = -1;
                const rowKey = JSON.stringify(row);
                // Cache check
                if (itemIndexCache.has(rowKey)) {
                    itemIndex = itemIndexCache.get(rowKey);
                }
                else {
                    // Calculate and cache index
                    if (scope.mobile || scope.tablet) {
                        itemIndex = scope.qmCards.findIndex(x => JSON.stringify(x) === rowKey);
                    }
                    else {
                        itemIndex = scope.qmCardToggle ?
                            scope.qmCards.findIndex(x => JSON.stringify(x) === rowKey) :
                            scope.qmItems.findIndex(x => JSON.stringify(x) === rowKey);
                    }
                    itemIndexCache.set(rowKey, itemIndex);
                }
                // Page correction only when necessary
                if (items.length < currentRangeStart) {
                    scope.qmPage = cachedPaginationInfo.totalPages - 1;
                    const newRangeStart = scope.qmPage * scope.qmLocalPaginationSize;
                    const newRangeEnd = (scope.qmPage + 1) * scope.qmLocalPaginationSize;
                    return newRangeStart <= itemIndex && itemIndex < newRangeEnd;
                }
                return currentRangeStart <= itemIndex && itemIndex < currentRangeEnd;
            };
            // Central function to create cards from table data (not original data)
            const createCardsFromTableData = (tableData) => {
                if (!scope.qmData.card || !tableData)
                    return [];
                const cards = [];
                tableData.forEach((tableItem, index) => {
                    // Extract the original data from the table item's _originalIndex
                    let originalData = null;
                    if (tableItem._originalIndex !== undefined) {
                        originalData = scope.qmData.data[tableItem._originalIndex];
                    }
                    // If we can't find original data, skip this item
                    if (!originalData)
                        return;
                    const card = scope.createCardObj(scope.qmData.card, originalData);
                    card._isStandardData = tableItem._isStandardData;
                    if (scope.qmData.hasOwnProperty('config')) {
                        card.style = {};
                        if (scope.qmData.config.hasOwnProperty('cardStyle')) {
                            card.style.cardClass = scope.qmData.config.cardStyle.class;
                        }
                        if (scope.qmData.config.hasOwnProperty('barStyle')) {
                            card.style.barClass = scope.qmData.config.barStyle.class;
                        }
                    }
                    cards.push(card);
                });
                return cards;
            };
            scope.getItems = () => {
                if (!scope.data)
                    return;
                let result = scope.data;
                // Only sort locally if server-side pagination is NOT active
                // When server-side pagination is active, data comes pre-sorted from the server
                if (scope.sortType && !isServerSidePagination()) {
                    result = sortData(result, scope.sortType, scope.sortReverse);
                }
                // Only filter locally if server-side pagination is NOT active
                // When server-side pagination is active, filtering should also be done server-side
                if (scope.qmFilter && !isServerSidePagination()) {
                    result = filterData(result, scope.qmFilter, scope.qmFilterProperties);
                }
                scope.qmItems = result;
                // Create cards from the same filtered data as the table
                if (scope.qmData.card != null) {
                    scope.qmCards = createCardsFromTableData(result);
                }
                // Clear cache when items change
                itemIndexCache.clear();
                cachedPaginationInfo = null;
                // Only perform calculations when necessary
                if (scope.qmCalculateProp && scope.qmItems) {
                    if (!Array.isArray(scope.qmCalculateProp)) {
                        scope.qmCalculateProp = [scope.qmCalculateProp];
                    }
                    scope.calcValues = {};
                    for (const prop of scope.qmCalculateProp) {
                        const sum = scope.qmItems.reduce((acc, item) => {
                            var _a;
                            const val = (_a = item[prop]) === null || _a === void 0 ? void 0 : _a.value;
                            return acc + (val || 0);
                        }, 0);
                        const head = scope.qmHead.find(h => h.model === prop);
                        if (scope.qmCalculatePropToTime && (head === null || head === void 0 ? void 0 : head.dType) === 'Time') {
                            scope.calcValues[prop] = scope.formatTime(sum);
                        }
                        else {
                            scope.calcValues[prop] = sum;
                        }
                        scope.qmCalculated = sum;
                    }
                }
            };
            scope.setOrderBy = () => {
                if (scope.sortType != null) {
                    return scope.sortType.model + ".value";
                }
                return null;
            };
            scope.mobileSort = {};
            scope.sortItemsForMobile = (items, sortMobile) => {
                if (sortMobile && items) {
                    if (typeof sortMobile === 'string') {
                        sortMobile = JSON.parse(sortMobile);
                    }
                    items = items.sort((a, b) => {
                        return (a[sortMobile.model] > b[sortMobile.model]) ? 1 : ((b[sortMobile.model] > a[sortMobile.model]) ? -1 : 0);
                    });
                    if (sortMobile.reverse) {
                        items = items.reverse();
                    }
                }
                return items ? items : [];
            };
            scope.sortProperties = [];
            const setSortProperties = () => {
                const props = [];
                scope.qmHead.forEach((h) => {
                    if (h.invisible || h.model === 'Button' || h.model === 'Avatar' || h.model === 'color' || h.dType === 'Checkbox')
                        return;
                    props.push({ value: { model: h.model, reverse: false }, key: h.key });
                    props.push({ value: { model: h.model, reverse: true }, key: h.key + ' (' + $languageService.translate(20000307, 'absteigend') + ')' });
                });
                scope.sortProperties = props.sort((a, b) => {
                    return (a.key > b.key) ? 1 : ((b.key > a.key) ? -1 : 0);
                });
                if (!scope.mobileSort.key && scope.qmHead[1]) {
                    if (scope.qmData.hasOwnProperty('config') && scope.qmData.config.hasOwnProperty('defaultSort')) {
                        scope.mobileSort.key = JSON.stringify({
                            model: scope.sortType.model,
                            reverse: scope.qmData.config.hasOwnProperty('sortReverse') ? scope.qmData.config.sortReverse === 'true' : false
                        });
                    }
                    else {
                        scope.mobileSort.key = JSON.stringify({ model: scope.qmHead[1].model, reverse: false });
                    }
                }
            };
            scope.cardAnchor = (link) => {
                if (link == null)
                    return;
                window.location.href = link;
            };
            scope.floorNumber = (number, digits) => {
                return $qui.qmcRounding(number, digits);
            };
            scope.formatTime = (number) => {
                let hours = Math.floor(Math.abs(number));
                let minutes = Math.round(Math.abs(number * 60 % 60));
                if (minutes < 10)
                    minutes = parseInt("0" + minutes);
                if (minutes > 59) {
                    minutes = 0;
                    hours++;
                }
                return hours + ":" + minutes;
            };
            const setTabletTable = (event) => {
                if (scope.mobile && !scope.tablet)
                    return;
                setTimeout(() => {
                    if (window.matchMedia("(orientation: portrait)").matches) {
                        scope.landscapeMode = false;
                    }
                    if (window.matchMedia("(orientation: landscape)").matches) {
                        scope.landscapeMode = true;
                    }
                    $qui.scopeApply(scope);
                }, 300);
            };
            if (localStorage.getItem('tableView') !== null) {
                scope.qmCardToggle = localStorage.getItem('tableView') === 'true';
            }
            else if (scope.tablet || scope.mobile) {
                setTimeout(() => {
                    setTabletTable(null);
                }, 500);
            }
            else if (scope.qmCardToggle == null) {
                scope.qmCardToggle = false;
            }
            else {
                scope.qmCardToggle = false;
            }
            $(window).unbind('orientationchange').bind('orientationchange', setTabletTable);
            const resolveExpression = (key, data) => {
                if (typeof key === 'string' && key.toLowerCase() === 'true')
                    return true;
                if (typeof key === 'string' && key.toLowerCase() === 'false')
                    return false;
                if (typeof key === 'boolean')
                    return key;
                let invert = false;
                if (typeof key === 'string') {
                    while (key.startsWith('!')) {
                        invert = !invert;
                        key = key.substring(1);
                    }
                }
                if (data && data.length > 0 && data[0].hasOwnProperty(key)) {
                    if (invert)
                        return !data[0][key];
                    else
                        return data[0][key];
                }
                return false;
            };
            scope.qmCreateTable = () => {
                if (scope.qmData == null || scope.isRendering)
                    return;
                scope.isRendering = true;
                scope.qmHead = [];
                scope.qmCards = [];
                if (scope.qmData.filter != null) {
                    scope.filter = {
                        model: scope.qmData.filter.model,
                        id: scope.qmData.filter.id
                    };
                }
                if (scope.qmLocalPagination !== false) {
                    scope.qmPage = Math.min(scope.qmLocalPaginationSize, scope.qmPage);
                    scope.qmPage = scope.qmPage ? scope.qmPage : 0;
                }
                setTimeout(() => {
                    // Only set default sort values on initial load, not when server-side pagination is active
                    // and the user has already selected a sort order
                    const shouldSetDefaultSort = !isServerSidePagination() || scope.sortType == null;
                    if (scope.qmData.hasOwnProperty('config')) {
                        if (scope.qmData.config.hasOwnProperty('defaultSort') && shouldSetDefaultSort) {
                            scope.sortType = {
                                model: scope.qmData.config.defaultSort
                            };
                        }
                        if (scope.qmData.config.hasOwnProperty('sortReverse') && shouldSetDefaultSort) {
                            scope.sortReverse = scope.qmData.config.sortReverse === 'true';
                        }
                    }
                    for (const key in scope.qmData.table) {
                        let invisible = false;
                        let calculate = false;
                        let hide = false;
                        let model = scope.qmData.table[key].label;
                        if (scope.qmData.table[key].dType === 'Avatar' || scope.qmData.table[key].dType === 'Button') {
                            model = scope.qmData.table[key].dType;
                        }
                        if (Array.isArray(scope.qmData.table[key]) && scope.qmData.table[key][0].dType === 'Button') {
                            model = scope.qmData.table[key][0].dType;
                        }
                        if (scope.qmData.table[key].hasOwnProperty("invisible")) {
                            invisible = resolveExpression(scope.qmData.table[key].invisible, scope.qmData.data);
                        }
                        if (scope.qmData.table[key].hasOwnProperty("hide")) {
                            hide = resolveExpression(scope.qmData.table[key].hide, scope.qmData.data);
                        }
                        if (scope.qmData.table[key].hasOwnProperty('calculate')) {
                            calculate = scope.qmData.table[key].calculate;
                        }
                        scope.qmHead.push({
                            key: key,
                            text: $languageService.translate(scope.qmData.table[key].lngTag, key),
                            model: model,
                            invisible: invisible,
                            hide: hide,
                            calculate: calculate,
                            dType: scope.qmData.table[key].dType,
                            noHeader: scope.qmData.table[key].noHeader
                        });
                        if (scope.sortType != null && scope.sortType.model === model) {
                            scope.sortType = {
                                key: key,
                                text: $languageService.translate(scope.qmData.table[key].lngTag, key),
                                model: model,
                                invisible: invisible,
                                hide: hide,
                                calculate: calculate
                            };
                        }
                    }
                    if (scope.sortType == null) {
                        scope.sortType = scope.qmHead[1];
                    }
                    setSortProperties();
                    let splitted;
                    if (scope.qmStandardData !== undefined) {
                        splitted = scope.qmStandardData.split(',');
                    }
                    const data = scope.sortItemsForMobile(scope.qmData.data ? scope.qmData.data : [], scope.mobileSort.key);
                    scope.data = (data ? data : []).map((obj, index) => {
                        let isStandard = false;
                        const x = {};
                        if (splitted !== undefined) {
                            for (let i = 0; i < splitted.length; i++) {
                                const standardDataColumnName = splitted[i].trim();
                                if (obj[standardDataColumnName]) {
                                    isStandard = true;
                                }
                            }
                        }
                        x._isStandardData = isStandard;
                        x._originalIndex = index; // Store the original data index for card matching
                        for (let i = 0; i < scope.qmHead.length; i++) {
                            if (Array.isArray(scope.qmData.table[scope.qmHead[i].key])) {
                                const y = [];
                                for (let j = 0; j < scope.qmData.table[scope.qmHead[i].key].length; j++) {
                                    y.push(scope.createTableObj(scope.qmData.table[scope.qmHead[i].key][j], obj, index));
                                }
                                x[scope.qmHead[i].model] = y;
                            }
                            else {
                                x[scope.qmHead[i].model] = scope.createTableObj(scope.qmData.table[scope.qmHead[i].key], obj, index);
                            }
                        }
                        if (scope.qmData.hasOwnProperty('config')) {
                            if (scope.qmData.config.hasOwnProperty('tableRowLink')) {
                                x._href = scope.createHref(scope.qmData.config.tableRowLink, obj);
                                x._tableRowLink = (path) => {
                                    location.href = path;
                                };
                            }
                            if (scope.qmData.config.hasOwnProperty('events')) {
                                if (scope.qmData.config.events.hasOwnProperty('click')) {
                                    x._tableRowLink = () => {
                                        scope.qmScopeCallback()[scope.qmData.config.events.click](obj);
                                    };
                                }
                            }
                        }
                        // Card creation is now handled centrally in getItems()
                        return x;
                    });
                    $timeout(() => {
                        // Create initial cards from all table data
                        if (scope.qmData.card != null) {
                            scope.qmCards = createCardsFromTableData(scope.data);
                        }
                        scope.getItems();
                        scope.isRendering = false;
                        $(document).ready(() => {
                            // do not run in main thread
                            $('[data-toggle="tooltip"]:not(.ng-hide):not(:has(.ng-hide))').filter(function () {
                                return this.scrollWidth > this.clientWidth || this.scrollHeight > this.clientHeight;
                            }).each((_, element) => {
                                $timeout(() => {
                                    $(element).tooltip();
                                });
                            });
                        });
                    });
                }, 50);
            };
            scope.createCardObj = (source, data) => {
                var _a, _b;
                const obj = {
                    title: null,
                    subtext: [],
                    buttons: []
                };
                if (source.hasOwnProperty('toggle')) {
                    obj[source.toggle.label] = {
                        value: data[source.toggle.label]
                    };
                }
                if (source.hasOwnProperty('avatar')) {
                    if (source.avatar.hasOwnProperty('label')) {
                        obj.avatar = {
                            name: data[source.avatar.name],
                            forename: data[source.avatar.forename],
                            value: data[source.avatar.label],
                            href: scope.createHref(source.avatar.href, data),
                            selected: data[source.avatar.selected]
                        };
                        if (source.avatar.hasOwnProperty('selectable')) {
                            obj.avatar.selectable = source.avatar.selectable;
                            if (source.avatar.hasOwnProperty('selectableExclude')) {
                                obj.avatar.selectable = !data[source.avatar.selectableExclude];
                            }
                            if (obj.avatar.selectable) {
                                obj.avatar.onChange = (state) => {
                                    scope.qmScopeCallback()[source.avatar.events.onChange](state, data);
                                };
                            }
                        }
                    }
                    if (source.avatar.hasOwnProperty('icon')) {
                        obj.avatar = {
                            icon: source.avatar.icon
                        };
                    }
                }
                if (source.hasOwnProperty('checkbox')) {
                    obj.checkbox = {
                        selected: data[source.checkbox.selected],
                        onChange: (state) => {
                            scope.qmScopeCallback()[source.checkbox.events.onChange](state, data);
                        }
                    };
                    if ((_a = source.checkbox.events) === null || _a === void 0 ? void 0 : _a.onChange) {
                        obj.checkbox.onChange = (state) => {
                            scope.qmScopeCallback()[source.checkbox.events.onChange](state, data);
                        };
                    }
                }
                if (Array.isArray(source.text.label)) {
                    let y = "";
                    for (let j = 0; j < source.text.label.length; j++) {
                        if (j === (source.text.label.length - 1) || !data[source.text.label[j]]) {
                            y = y + data[source.text.label[j]];
                        }
                        else {
                            y = y + data[source.text.label[j]] + ', ';
                        }
                    }
                    obj.title = {
                        dType: source.text.dType,
                        value: y
                    };
                }
                else {
                    obj.title = {
                        value: data[source.text.label],
                        dType: source.text.dType,
                    };
                }
                for (let j = 0; j < source.subtext.length; j++) {
                    const dType = source.subtext[j].dType;
                    switch (dType) {
                        case 'string':
                            if (Array.isArray(source.subtext[j].label)) {
                                let text = "";
                                for (let k = 0; k < source.subtext[j].label.length; k++) {
                                    text = text + " " + data[source.subtext[j].label[k]];
                                }
                                if (source.subtext[j].prefix) {
                                    text = source.subtext[j].prefix + text;
                                }
                                obj.subtext.push({
                                    dType: dType,
                                    value: text,
                                    type: data[source.subtext[j].type]
                                });
                            }
                            else {
                                let text = data[source.subtext[j].label];
                                if (source.subtext[j].prefix) {
                                    text = source.subtext[j].prefix + text;
                                }
                                obj.subtext.push({
                                    dType: dType,
                                    value: text,
                                    style: source.subtext[j].style ? data[source.subtext[j].style] : undefined,
                                    type: data[source.subtext[j].type]
                                });
                            }
                            break;
                        case 'Number':
                            obj.subtext.push({
                                dType: dType,
                                value: data[source.subtext[j].label],
                                style: source.subtext[j].style ? data[source.subtext[j].style] : undefined
                            });
                            break;
                        case 'Date':
                            obj.subtext.push({
                                dType: dType,
                                value: data[source.subtext[j].label],
                                withTime: source.subtext[j].withTime,
                                style: source.subtext[j].style ? data[source.subtext[j].style] : undefined
                            });
                            break;
                        case 'Bool':
                            obj.subtext.push({
                                dType: dType,
                                value: data[source.subtext[j].label],
                                text: source.subtext[j].text,
                                style: source.subtext[j].style ? data[source.subtext[j].style] : undefined
                            });
                            break;
                        default:
                            console.warn("createCardObj | Unknow Type : " + dType);
                            break;
                    }
                }
                if (Array.isArray(source.buttons)) {
                    for (let j = 0; j < source.buttons.length; j++) {
                        const btn = {
                            icon: source.buttons[j].icon,
                            events: {},
                            permission: scope.qmScopeCallback()[source.buttons[j].permission]
                        };
                        if (btn.permission == null)
                            btn.permission = true;
                        if (source.buttons[j].tooltip)
                            btn.tooltip = source.buttons[j].tooltip;
                        if (source.buttons[j].openModal)
                            btn.openModal = true;
                        if (source.buttons[j].targetModal != null)
                            btn.targetModal = source.buttons[j].targetModal;
                        if (source.buttons[j].click != null)
                            btn.click = new Callback(source.buttons[j].click, data);
                        if (source.buttons[j].href != null) {
                            btn.href = scope.createHref(source.buttons[j].href, data);
                        }
                        if (source.buttons[j].events) {
                            if (source.buttons[j].events.hasOwnProperty("hide")) {
                                if (source.buttons[j].events.hide.charAt(0) === '!') {
                                    btn.events.hide = !data[source.buttons[j].events.hide.substr(1, source.buttons[j].events.hide.length)];
                                }
                                else {
                                    btn.events.hide = data[source.buttons[j].events.hide];
                                }
                            }
                        }
                        if (source.buttons[j].hideSpacer != null) {
                            if (source.buttons[j].hideSpacer.charAt(0) === '!') {
                                btn.hideSpacer = !data[source.buttons[j].hideSpacer.substr(1, source.buttons[j].hideSpacer.length)];
                            }
                            else {
                                btn.hideSpacer = data[source.buttons[j].hideSpacer];
                            }
                        }
                        if (source.buttons[j].permissionByDataSet) {
                            btn.permission = data.permissions[source.buttons[j].permission];
                        }
                        obj.buttons.push(btn);
                    }
                }
                else {
                    const btn = {
                        icon: (_b = source.buttons) === null || _b === void 0 ? void 0 : _b.icon,
                        events: {},
                        permission: scope.qmScopeCallback()[source.buttons.permission]
                    };
                    if (btn.permission == null)
                        btn.permission = true;
                    if (source.buttons.hasOwnProperty('tooltip'))
                        btn.tooltip = source.buttons.tooltip;
                    if (source.buttons.openModal)
                        btn.openModal = true;
                    if (source.buttons.hide)
                        btn.hide = data[source.buttons.hide];
                    else
                        btn.hide = false;
                    if (source.buttons.targetModal != null)
                        btn.targetModal = source.buttons.targetModal;
                    if (source.buttons.click != null)
                        btn.click = new Callback(source.buttons.click, data);
                    if (source.buttons.href != null)
                        btn.href = scope.createHref(source.buttons.href, data);
                    if (source.buttons.hideSpacer) {
                        if (source.buttons.hideSpacer.charAt(0) === '!')
                            btn.hideSpacer = !data[source.buttons.hideSpacer.substr(1, source.hideSpacer.length)];
                        else
                            btn.hideSpacer = data[source.buttons.hideSpacer];
                    }
                    obj.buttons.push(btn);
                }
                if (source.hasOwnProperty("idProperty")) {
                    obj.id = data[source.idProperty];
                }
                return obj;
            };
            scope.createTableObj = (source, data, index) => {
                var _a, _b, _c, _d;
                const hide = source.hasOwnProperty('hide') ? resolveExpression(source.hide, [data]) : ((_a = source.events) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('hide')) ? resolveExpression(source.events.hide, [data]) : false;
                const invisible = source.hasOwnProperty('invisible') ? resolveExpression(source.invisible, [data]) : ((_b = source.events) === null || _b === void 0 ? void 0 : _b.hasOwnProperty('invisible')) ? resolveExpression(source.events.invisible, [data]) : false;
                const obj = {
                    dType: source.dType,
                    value: data[source.label],
                    invisible,
                    hide,
                    events: {
                        hide,
                        invisible
                    },
                };
                // Optimierte Objekterstellung
                Object.assign(obj, {
                    [source.label]: data[source.label],
                    style: source.hasOwnProperty('style') ? data[source.style] : undefined,
                    type: source.type ? data[source.type] : undefined
                });
                // Optimierte Switch-Case Logik
                switch (obj.dType) {
                    case 'Avatar':
                        Object.assign(obj, {
                            name: data[source.name],
                            forename: data[source.forename],
                            href: source.hasOwnProperty('href') ? scope.createHref(source.href, data) : undefined,
                            selected: source.hasOwnProperty('selected') ? data[source.selected] : undefined,
                            selectable: source.hasOwnProperty('selectable') ? source.selectable : undefined,
                            onChange: source.hasOwnProperty('selectable') ?
                                (state) => scope.qmScopeCallback()[source.events.onChange](state, data) : undefined
                        });
                        break;
                    case 'Button':
                        let buttonPermission = source.permission ? scope.qmScopeCallback()[source.permission] : true;
                        if (source.permissionByDataSet && source.permission) {
                            buttonPermission = ((_c = data.permissions) === null || _c === void 0 ? void 0 : _c[source.permission]) === true;
                        }
                        Object.assign(obj, {
                            icon: source.icon,
                            permission: buttonPermission,
                            href: source.href ? scope.createHref(source.href, data) : undefined,
                            targetModal: source.targetModal,
                            openModal: source.openModal,
                            click: source.click ? new Callback(source.click, data) : undefined,
                            lngTag: source.lngTag,
                            tooltip: source.tooltip
                        });
                        break;
                    case 'Bool':
                    case 'Color':
                    case 'Time':
                    case 'string':
                        break;
                    case 'Checkbox':
                        obj.selected = data[source.selected] ? data[source.selected] : false;
                        if (source.id != null)
                            obj.id = data[source.id];
                        if (((_d = source.events) === null || _d === void 0 ? void 0 : _d.onChange) != null) {
                            obj.onChange = (state, value) => {
                                scope.qmScopeCallback()[source.events.onChange](state, data, value, obj);
                            };
                        }
                        break;
                    case 'Date':
                        obj.withTime = source.withTime;
                        break;
                    case 'Number':
                        if (source.hasOwnProperty('calculate'))
                            obj.calculate = source.calculate;
                        break;
                    default:
                        console.warn("createTableObj | Unknow Type : " + obj.dType);
                        break;
                }
                return obj;
            };
            scope.createHref = (href, data) => {
                if (href != null && data != null) {
                    const rxp = /{{([^}]+)}}/g;
                    let match;
                    while ((match = rxp.exec(href)) !== null) {
                        href = href.replace(new RegExp(match[0], 'g'), data[match[1]]);
                    }
                    return href;
                }
                return "";
            };
            scope.getLink = (href) => {
                href = href.trim();
                if (!href.startsWith('http')) {
                    href = 'https://' + href;
                }
                return href;
            };
            // Cleanup event handlers when scope is destroyed
            scope.$on('$destroy', () => {
                $(window).off('resize.qmTable' + scope.randomId);
                $(window).unbind('orientationchange');
                if (resizeTimeout) {
                    clearTimeout(resizeTimeout);
                }
            });
        }
    };
}
angular.module('qmc-ui').directive('qmTable', ['QmcLanguageService', '$timeout', '$qui', qmTableDirective]);
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class UdfContainer {
            constructor() {
                this.show = false;
            }
            allDataValid() {
                var _a, _b, _c;
                return (((_a = this.data) === null || _a === void 0 ? void 0 : _a.definitionId) && this.data.definitionId !== QMC.Common.Constants.GUID_EMPTY && ((_b = this.data) === null || _b === void 0 ? void 0 : _b.definitionObjectType) &&
                    this.data.referenceId && this.data.referenceId !== QMC.Common.Constants.GUID_EMPTY && ((_c = this.data) === null || _c === void 0 ? void 0 : _c.referenceObjectType) &&
                    this.data.type >= 0 && this.data.type <= 5);
            }
        }
        angular.module('QMC.Udf').component('qmUdfContainer', {
            templateUrl: 'UserDefinedFields/Container',
            controller: [UdfContainer],
            controllerAs: 'vm',
            bindings: {
                data: '=',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class FormDirective {
            constructor(scope, $qui, udfService) {
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.rows = [];
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.wvDsData = {};
                this.timeValues = {};
                this.formWatcher = [];
                this.isTouched = false;
                this.touchWatcher = [];
                this.$postLink = () => {
                    if (!this.reference || !this.definition) {
                        console.warn('UDF-Form: reference, defintion or udf not set!', this.reference, this.definition, this.udf);
                        return;
                    }
                    this.init();
                    this.events();
                    this.reset = () => { this.createRowsFromUdf(); };
                };
                this.$onDestroy = () => {
                    this.clearFormWatcher();
                };
            }
            init() {
                this.createRowsFromUdf();
                this.loadWvAndDataSourcesFromUdf();
            }
            events() {
                this.scope.$watch('vm.udf', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.init();
                }, true);
                this.isTouched = false;
                this.touchWatcher.forEach(watcher => watcher());
                this.touchWatcher = [];
                for (let i = 0; i < this.udf.fields.length; i++) {
                    this.touchWatcher.push(this.scope.$watch(`vm.udf.fields[${i}].values`, (newVal, oldVal) => {
                        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
                            this.isTouched = true;
                    }, true));
                }
            }
            createRowsFromUdf() {
                var _a, _b, _c, _d;
                this.isTouched = false;
                this.rows = [];
                (_a = this.udf) === null || _a === void 0 ? void 0 : _a.fields.sort((x, y) => x.column - y.column).forEach(field => {
                    //convert dates
                    if ((field.fieldType === 10 || field.fieldType === 12) && field.values.length)
                        field.values[0] = this.$qui.createDateFromString(field.values[0]);
                    let row = this.rows.find(x => x.row === field.row);
                    if (!row) {
                        row = { row: field.row, fields: [field] };
                        this.rows.push(row);
                    }
                    else {
                        row.fields.push(field);
                    }
                });
                this.rows = this.rows.sort((a, b) => a.row - b.row);
                const maxColumns = Math.max(...(_d = (_c = (_b = this.udf) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.map(x => x.column)) !== null && _d !== void 0 ? _d : [0]);
                // per row fillup missing columns with blanks
                this.rows.forEach(row => {
                    for (let i = 0; i <= maxColumns; i++) {
                        if (!row.fields.find(x => x.column == i))
                            row.fields.push({
                                values: [],
                                wvId: QMC.Common.Constants.GUID_EMPTY,
                                fieldType: -1,
                                caption: '',
                                isRequired: false,
                                row: row.row,
                                column: i,
                                id: null,
                                objectId: null
                            });
                    }
                    row.fields = row.fields.sort((a, b) => a.column - b.column);
                });
                this.clearFormWatcher();
                //workaround for datetime: store time in seperate object, indexed by field id. Watch said objects property and actual value to keep both in sync
                for (let i = 0; i < this.udf.fields.length; i++) {
                    const field = this.udf.fields[i];
                    if (field.values && [40, 50, 60, 70].includes(field.fieldType)) { // ensure format of values for wvs and dss
                        field.values = field.values.map(x => (x === null || x === void 0 ? void 0 : x.toLocaleLowerCase) ? x.toLocaleLowerCase() : x);
                    }
                    if (this.udf.fields[i].fieldType !== 12)
                        continue;
                    this.timeValues[field.objectId] = angular.copy(field.values[0]);
                    this.formWatcher.push(this.scope.$watch(`vm.timeValues['${field.objectId}']`, (newVal, oldVal) => {
                        this.handleDateTimeWatch(field, newVal, oldVal);
                    }));
                    this.formWatcher.push(this.scope.$watch(`vm.udf.fields[${i}].values[0]`, (newVal, oldVal) => {
                        this.handleDateTimeWatch(field, newVal, oldVal);
                    }));
                }
            }
            handleDateTimeWatch(field, newVal, oldVal) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                    return;
                if (!newVal) {
                    field.values = [];
                    return;
                }
                field.values[0] = this.$qui.addTimeToDate(field.values[0], this.timeValues[field.objectId]);
            }
            loadWvAndDataSourcesFromUdf() {
                this.udf.fields.forEach(field => {
                    if (!field.wvId || this.wvDsData[field.wvId])
                        return;
                    this.wvDsData[field.wvId] = [];
                    if (field.fieldType === 40 || field.fieldType === 60)
                        this.udfService.getWv(field.wvId).then(data => this.wvDsData[field.wvId] = data.map(x => ({ text: x.name, value: x.objectId })));
                    if (field.fieldType === 50 || field.fieldType === 70)
                        this.udfService.getDs(field.wvId).then(data => this.wvDsData[field.wvId] = data.map(x => ({ text: x.caption, value: x.objectId })));
                });
            }
            clearFormWatcher() {
                this.formWatcher.forEach(x => x());
                this.formWatcher = [];
            }
        }
        angular.module('QMC.Udf').component('qmUdfForm', {
            templateUrl: 'UserDefinedFields/Form',
            controller: ['$scope', '$qui', 'QmcUdfService', FormDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                disabled: '=?',
                isValid: '=?',
                udf: '=',
                reset: '=?',
                isTouched: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class MediaDirective {
            constructor($qui, scope, udfService, mediaService, lng, stammdatenService) {
                this.$qui = $qui;
                this.scope = scope;
                this.udfService = udfService;
                this.mediaService = mediaService;
                this.lng = lng;
                this.stammdatenService = stammdatenService;
                this.files = [];
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.promptOptions = {
                    title: '',
                    yesNo: true,
                    icon: "qm-icon-garbage_can",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                    itemText: ''
                };
                this.$postLink = () => {
                    this.loadMedia();
                    this.events();
                };
            }
            events() {
                this.scope.$watch('vm.field', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.loadMedia();
                }, true);
                this.scope.$watch('vm.newForm.file', (newVal, oldVal) => {
                    var _a;
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    const file = this.newForm.file[this.newForm.file.length - 1];
                    if (!file)
                        return;
                    this.newForm.caption = file.name.substring(0, (_a = file.name.lastIndexOf('.')) !== null && _a !== void 0 ? _a : file.name.length);
                }, true);
            }
            async loadMedia() {
                // if we do not have a value, create one
                //if (!this.field.values.length) this.error = 'Media could not be initialized'
                //else this.error = undefined;
                if (!this.field.values.length) {
                    this.loading = true;
                    const mediaId = await this.createMedia();
                    if (mediaId) {
                        this.field.values.push(mediaId);
                        this.error = undefined;
                    }
                    else {
                        this.error = 'Media could not be initialized';
                        return;
                    }
                }
                this.loading = true;
                this.udfService.getUserDefinedFieldMedia(this.field.values[0])
                    .then(data => {
                    this.files = data;
                    this.files.forEach(file => {
                        //load thumbnails for fotos
                        if (file.mediaType === 1) {
                            this.mediaService.getMediaThumbnail(file.objectId, file.mediaType).then(data => {
                                file.thumbnail = data.base64.length ? 'data:' + data.mimeType + ';base64,' + data.base64 : '';
                            });
                        }
                    });
                })
                    .catch(() => this.files = [])
                    .finally(() => this.loading = false);
            }
            async createMedia() {
                return new Promise((resolve, reject) => {
                    this.stammdatenService.postNewDocument({
                        isMainDataSet: 0,
                        itemOrder: 0,
                        objectType: this.definition.objectType,
                        parentObjectId: QMC.Common.Constants.GUID_EMPTY,
                        parentObjectType: this.definition.objectType,
                        date: moment().startOf('day').toDate(),
                        title: this.field.caption,
                        subtitle: this.lng.translate(20036008, "über Flexfelder verbunden"),
                        isPrivate: false,
                        documentTypeId: this.field.fieldType === 80 ? 'e95b9228-1626-4eb3-a54c-b2b6ec7524f2' : 'd5b77c29-bd93-46f9-b1ec-322caf68292d',
                        mediaType: this.field.fieldType === 80 ? 1 : 2,
                        mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                        subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                        comment: ''
                    }).then((data) => {
                        const mediaId = data[0].value.createdObjectId;
                        return resolve(mediaId);
                    }).catch(() => {
                        return reject(new Error('Could not create media'));
                    });
                });
            }
            getIcon(file) {
                var _a, _b, _c;
                const extension = (_c = (_b = (_a = file === null || file === void 0 ? void 0 : file.fileName) === null || _a === void 0 ? void 0 : _a.substring(file.fileName.lastIndexOf('.') + 1)) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '';
                switch (extension) {
                    case 'png':
                    case 'jpg':
                    case 'jpeg':
                    case 'svg':
                    case 'bmp':
                    case 'gif':
                        return 'image-o';
                    case 'mov':
                    case 'webm':
                    case 'mpeg':
                    case 'mkv':
                    case 'mp4':
                        return 'video-o';
                    case 'zip':
                    case '7z':
                    case 'pkg':
                    case 'dmg':
                    case 'tar':
                    case 'gz':
                        return 'archive-o';
                    case 'pdf':
                        return 'pdf-o';
                    case 'doc':
                    case 'docx':
                        return 'word-o';
                    case 'ppt':
                    case 'pptx':
                        return 'powerpoint-o';
                    case 'text':
                    case 'txt':
                        return 'text-o';
                    case 'xls':
                    case 'xlsx':
                        return 'excel-o';
                    default: return 'o';
                }
            }
            getFileExtension(file) {
                var _a, _b, _c;
                return (_c = (_b = (_a = file === null || file === void 0 ? void 0 : file.fileName) === null || _a === void 0 ? void 0 : _a.substring(file.fileName.lastIndexOf('.') + 1)) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '';
            }
            getAcceptedFileTypes() {
                if (this.field.fieldType === 80)
                    return 'image/*';
                return '.doc,.docx,.xls,.xlsx,.pdf,.txt';
            }
            openFile(file) {
                this.selectedFile = file;
                $(`#previewModal${this.id}`).modal('show');
                this.loadingPreview = true;
                this.mediaService.getMediaFile(file.objectId, file.mediaType)
                    .then(data => this.selectedFile.base64 = data.base64)
                    .catch(() => this.selectedFile.base64 = '')
                    .finally(() => this.loadingPreview = false);
            }
            deleteFile(file) {
                this.promptOptions = {
                    ...this.promptOptions,
                    title: this.field.caption,
                    itemText: file.fileName
                };
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.loadingPreview = true;
                        this.loading = true;
                        this.mediaService.deleteMediaAttachementDirect(file.objectId)
                            .then(() => $(`#previewModal${this.id}`).modal('hide'))
                            .finally(() => {
                            this.loadingPreview = false;
                            this.loadMedia();
                        });
                    }
                }, `#prompt${this.id}`);
            }
            openNewFile() {
                this.newForm = {
                    caption: '',
                    file: []
                };
                $(`#newModal${this.id}`).modal('show');
            }
            uploadFile() {
                const file = this.newForm.file[this.newForm.file.length - 1];
                if (!file)
                    return;
                this.loadingNew = true;
                this.mediaService.postMediaAttachement({
                    documentId: this.field.values[0],
                    base64String: file.base64,
                    date: new Date(),
                    fileName: file.name,
                    caption: this.newForm.caption,
                    mediaType: this.field.fieldType === 80 ? 1 : 2 // if we have image type udf, set type 1 (foto), else type 2 (dokument)
                })
                    .then(() => $(`#newModal${this.id}`).modal('hide'))
                    .finally(() => {
                    this.loadMedia();
                    this.loadingNew = false;
                });
            }
        }
        angular.module('QMC.Udf').component('qmUdfMedia', {
            templateUrl: 'UserDefinedFields/Media',
            controller: ['$qui', '$scope', 'QmcUdfService', 'QmcMediaService', 'QmcLanguageService', 'StammdatenService', MediaDirective],
            controllerAs: 'vm',
            bindings: {
                field: '=',
                qmDisabled: '=?',
                definition: '='
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class SaveButtonDirective {
            constructor($qui, $scope) {
                this.$qui = $qui;
                this.$scope = $scope;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.$postLink = () => {
                    $(document).scroll(() => {
                        this.checkViewport();
                    });
                    setInterval(() => {
                        this.checkViewport();
                    }, 1000);
                };
            }
            checkViewport() {
                const element = document.getElementById(this.id);
                if (!element)
                    return;
                const rect = document.getElementById(this.id).getBoundingClientRect();
                if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
                    $(`#${this.id}_float`).fadeOut();
                }
                else {
                    $(`#${this.id}_float`).fadeIn();
                }
                this.$qui.scopeApply(this.$scope);
            }
        }
        angular.module('QMC.Udf').component('qmUdfSaveButton', {
            controller: ['$qui', '$scope', SaveButtonDirective],
            controllerAs: 'vm',
            bindings: {
                disabled: '=',
                hide: '=',
                callback: '='
            },
            templateUrl: 'UserDefinedFields/Save_Button'
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class StandardDirective {
            constructor($qui, scope, udfService, permissionService) {
                this.$qui = $qui;
                this.scope = scope;
                this.udfService = udfService;
                this.permissionService = permissionService;
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.$postLink = () => {
                    if (!this.reference || !this.definition) {
                        console.warn('UDF: reference or defintion not set!', this.reference, this.definition);
                        return;
                    }
                    this.loading = true;
                    this.loadPermissions();
                    this.init();
                    this.events();
                    this.save = (showNotification = true) => {
                        // nothing to save, yield
                        if (!this.udf.fields.length || !this.isTouched || !this.isValid)
                            return Promise.resolve(true);
                        const saveObject = {
                            values: {},
                            udfId: this.udf.udfId
                        };
                        this.udf.fields.forEach(field => {
                            saveObject.values[field.objectId] = field.values;
                        });
                        this.loading = true;
                        return this.udfService.updateUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, saveObject, this.timeframe).then(() => {
                            if (showNotification)
                                this.$qui.notify(this.$qui.successNote);
                            this.isTouched = false;
                            return true;
                        }).catch((e) => {
                            console.error('Error saving udf', e);
                            return false;
                        }).finally(() => {
                            this.init();
                        });
                    };
                };
            }
            init() {
                this.isValid = false;
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, this.timeframe).then(data => {
                    this.udf = data[0];
                }).finally(() => {
                    this.loading = false;
                    setTimeout(() => this.isTouched = false);
                });
            }
            events() {
                const initCheckFunc = (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    if (!this.reference || !this.definition) {
                        console.warn('UDF: reference or defintion not set!', this.reference, this.definition);
                        return;
                    }
                    this.init();
                };
                this.scope.$watch('vm.reference', (newVal, oldVal) => initCheckFunc(newVal, oldVal), true);
                this.scope.$watch('vm.definition', (newVal, oldVal) => initCheckFunc(newVal, oldVal), true);
                this.scope.$watch('vm.timeframe', (newVal, oldVal) => initCheckFunc(newVal, oldVal));
                this.scope.$watch('vm.definition.objectType', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.loadPermissions();
                });
                this.scope.$watch('vm.permissionObjectType', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.loadPermissions();
                });
            }
            loadPermissions() {
                var _a;
                this.permissionService.getPermissionsByObjectTypes([(_a = this.permissionObjectType) !== null && _a !== void 0 ? _a : this.definition.objectType]).then(data => {
                    this.permissions = data[0];
                }).catch(() => this.permissions = { view: false, modify: false, new: false, delete: false });
            }
        }
        angular.module('QMC.Udf').component('qmUdfStandard', {
            templateUrl: 'UserDefinedFields/Standard',
            controller: ['$qui', '$scope', 'QmcUdfService', 'QmcPermissionService', StandardDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                timeframe: '=?',
                permissionObjectType: '=?',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class SingletimeDirective {
            constructor(scope, $qui, udfService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.formState = 'new';
                this.definitionValues = [];
                this.promptOptions = {
                    title: this.lng.translate(20036006, 'Einzelzeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.ui = new Udf.UdfUi(this.lng);
                this.$postLink = () => {
                    if (!this.reference || !this.definition) {
                        console.warn('UDF: reference or defintion not set!', this.reference, this.definition);
                        return;
                    }
                    this.loading = true;
                    this.getDefinition();
                    this.permissionService.getPermissionsByObjectTypes([this.definition.objectType]).then(data => {
                        this.permissions = data[0];
                        this.events();
                        this.init();
                    }).catch(e => {
                        console.error('Error loading udf permission', e);
                        this.loading = false;
                    });
                };
            }
            init() {
                this.getUdfData();
            }
            addSingletime() {
                this.form = {
                    //fields: angular.copy(this.definitionValues.filter(x => ![80,81,82].includes(x.fieldType))), // media is not support on creation at the moment
                    fields: angular.copy(this.definitionValues),
                    id: null,
                    objectId: null,
                    udfId: null,
                    dateFrom: new Date()
                };
                this.formState = 'new';
                this.openFormModal();
            }
            openSingletime(udf) {
                this.form = angular.copy(udf);
                this.formState = 'edit';
                this.openFormModal();
            }
            openFormModal() {
                $(`#singletime-form-modal${this.id}`).modal('show');
                this.$qui.functionWaiter("initForm", this);
            }
            createSingletime() {
                this.loading = true;
                this.udfService.createSingletime(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, { dateFrom: this.form.dateFrom, dateTo: this.form.dateTo }).then(data => {
                    this.form.udfId = data.createdObjectId;
                    this.updateSingletime();
                }).catch(e => {
                    console.error('Error creating singletime', e);
                    this.loading = false;
                    this.init();
                });
            }
            updateSingletime() {
                const saveObject = {
                    values: {},
                    udfId: this.form.udfId,
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo
                };
                this.form.fields.forEach(field => {
                    saveObject.values[field.objectId] = field.values;
                });
                this.loading = true;
                this.udfService.updateUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, saveObject).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                }).catch((e) => {
                    console.error('Error saving udf', e);
                }).finally(() => {
                    this.init();
                    $(`#singletime-form-modal${this.id}`).modal('hide');
                });
            }
            deleteSingletime(udf) {
                this.promptOptions.itemText = this.createDateString(udf.dateFrom, udf.dateTo);
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (!data)
                        return;
                    this.loading = true;
                    this.udfService.deleteSingletime(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, udf.udfId).finally(() => this.init());
                }, `#udf-singletime-delete-prompt-${this.id}`);
            }
            isValidDate(date) {
                return moment(date).isValid();
            }
            events() {
                this.scope.$watch('vm.defintion', (newVal, oldVal) => {
                    if (newVal !== oldVal)
                        this.getDefinition();
                }, true);
            }
            getDefinition() {
                this.udfService.getUserDefinedFieldDefintion(this.definition.objectType, this.definition.id).then(data => {
                    this.definitionValues = data;
                }).catch(() => this.definitionValues = []);
            }
            getUdfData() {
                this.isValid = false;
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, null, false).then(data => {
                    data.forEach(x => {
                        if (x.dateFrom)
                            x.dateFrom = this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = this.$qui.createDateFromString(x.dateTo);
                    });
                    this.udfs = data.sort((a, b) => { var _a, _b, _c, _d; return (_d = (_b = (_a = b.dateFrom) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0 - ((_c = a.dateFrom) === null || _c === void 0 ? void 0 : _c.getTime())) !== null && _d !== void 0 ? _d : 0; });
                }).finally(() => {
                    this.loading = false;
                    this.isValid = true;
                });
            }
            createDateString(dateFrom, dateTo) {
                return this.ui.createDateString(dateFrom, dateTo);
            }
        }
        angular.module('QMC.Udf').component('qmUdfSingletime', {
            templateUrl: 'UserDefinedFields/Singletime',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', 'QmcPermissionService', SingletimeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                disabled: '=?',
                isValid: '=?',
                isTouched: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class TabDirective {
            constructor(scope, $qui, udfService, lng, $timeout) {
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.$timeout = $timeout;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.saveFunctions = {};
                this.isValid = false;
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.tabs = [];
                this.touched = [];
                this.valid = [];
                this.$postLink = () => {
                    if (!this.reference || !this.definition) {
                        console.warn('UDF: reference or defintion not set!', this.reference, this.definition);
                        return;
                    }
                    this.events();
                    this.init();
                    this.saveAll = (showNotification = true) => {
                        const promises = [];
                        for (const key in this.saveFunctions) {
                            promises.push(this.saveFunctions[key](false));
                        }
                        ;
                        return new Promise((resolve, reject) => {
                            Promise.all(promises).then(saveResults => {
                                if (saveResults.some(x => !x))
                                    this.$qui.notify({
                                        message: this.lng.translate(20002062, "Es konnten nicht alle Einträge gespeichert werden!"),
                                        title: this.lng.translate(20002015, "Fehler"),
                                        icon: "qm-icon-delete",
                                        status: "warning",
                                        timer: 3500
                                    });
                                else if (showNotification)
                                    this.$qui.notify(this.$qui.successNote);
                                resolve();
                            }).catch(reject);
                        });
                    };
                    this.scope.$watch('vm.touched', () => { this.isTouched = this.touched.reduce((prev, curr) => prev || curr, false); }, true);
                    this.scope.$watch('vm.valid', () => {
                        if (!this.tabs.length)
                            return;
                        this.isValid = this.tabs.every((_, i) => this.valid[i]);
                    }, true);
                };
            }
            events() {
                this.scope.$watch('vm.definition.objectType', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    if (!newVal)
                        this.tabs = [];
                    else
                        this.init();
                });
            }
            init() {
                this.loading = true;
                this.isValid = false;
                this.valid = [];
                this.udfService.getTabs(this.definition.objectType).then(data => {
                    this.tabs = data;
                    this.valid = data.map(() => false);
                    if (this.tabs.length) {
                        this.$timeout(() => this.$qui.waitForEl(`#udf-tab-0-button${this.id}`, () => { document.getElementById(`udf-tab-0-button${this.id}`).click(); }));
                    }
                }).catch((e) => {
                    console.error('Error getting tabs', e);
                    this.tabs = [];
                }).finally(() => {
                    this.loading = false;
                    if (!this.tabs.length)
                        this.isValid = true;
                });
            }
        }
        angular.module('QMC.Udf').component('qmUdfTab', {
            templateUrl: 'UserDefinedFields/Tab',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', '$timeout', TabDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                timeframe: '=?',
                permissionObjectType: '=?',
                saveAll: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class TabSingletimeDirective {
            constructor(scope, $qui, udfService, lng, permissionService, $timeout) {
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.ui = new Udf.UdfUi(this.lng);
                this.timeframeForm = {
                    state: 'new',
                    validation: {
                        isLoading: false,
                        warnings: [],
                        errors: []
                    }
                };
                this.promptOptions = {
                    title: this.lng.translate(20036006, 'Einzelzeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.$postLink = () => {
                    if (!this.reference || !this.definition) {
                        console.warn('UDF: reference or defintion not set!', this.reference, this.definition);
                        return;
                    }
                    this.permissionService.getPermissionsByObjectTypes([this.definition.objectType]).then(data => {
                        this.permissions = data[0];
                        this.events();
                        this.init();
                    }).catch(e => {
                        console.error('Error loading udf permission', e);
                        this.loading = false;
                    });
                };
            }
            events() {
                this.scope.$watch('vm.timeframeForm.form', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.timeframeForm.validation = {
                        isLoading: true,
                        warnings: [],
                        errors: []
                    };
                    this.udfService.valiadateTimeframe(this.definition.objectType, this.timeframeForm.form).then(data => {
                        this.timeframeForm.validation.errors = data.errors;
                        this.timeframeForm.validation.warnings = data.warnings;
                    }).catch((e) => {
                        console.error('Error validating udf-timeframe', e);
                        this.timeframeForm.validation.errors = [this.lng.translate(21003023, 'Der Datensatz konnte nicht erfolgreich validiert werden.')];
                    }).finally(() => this.timeframeForm.validation.isLoading = false);
                }, true);
            }
            init() {
                this.getUdfData();
            }
            getUdfData() {
                this.isValid = false;
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, null, false).then(data => {
                    data.forEach(x => {
                        if (x.dateFrom)
                            x.dateFrom = this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = this.$qui.createDateFromString(x.dateTo);
                    });
                    this.udfs = data;
                }).finally(() => {
                    this.loading = false;
                    this.isValid = true;
                });
            }
            addSingletime() {
                this.timeframeForm.form = {
                    id: null,
                    objectId: null,
                    dateFrom: new Date(),
                    referenceId: this.reference.id
                };
                this.timeframeForm.state = 'new';
                $(`#tabTimeframeModal-${this.id}`).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            }
            createTimeframe() {
                this.loading = true;
                this.udfService.createTabSingletime(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, { dateFrom: this.timeframeForm.form.dateFrom, dateTo: this.timeframeForm.form.dateTo }).then(() => {
                    this.getUdfData();
                    this.$qui.notify(this.$qui.successNote);
                }).catch(e => {
                    console.error('Error creating singletime', e);
                    this.loading = false;
                    this.init();
                });
            }
            deleteSingletime(udf) {
                this.promptOptions.itemText = this.createDateString(udf.dateFrom, udf.dateTo);
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (!data)
                        return;
                    this.loading = true;
                    this.udfService.deleteTabSingletime(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, udf.timeFrameId).finally(() => this.init());
                    $(`#tab-singletime-form-modal-${this.id}`).modal('hide');
                }, `#udf-tab-singletime-delete-prompt-${this.id}`);
            }
            openSingletime(udf) {
                $(`#tab-singletime-form-modal-${this.id}`).modal('show');
                this.selectedUdf = undefined;
                this.$timeout(() => {
                    this.selectedUdf = udf;
                });
                this.timeframeForm.form = {
                    dateFrom: udf.dateFrom,
                    dateTo: udf.dateTo,
                    referenceId: this.reference.id,
                    id: null,
                    objectId: null
                };
            }
            createDateString(dateFrom, dateTo) {
                return this.ui.createDateString(dateFrom, dateTo);
            }
            save(showNotification = true) {
                this.loading = true;
                this.saveTabs(showNotification);
                $(`#tab-singletime-form-modal-${this.id}`).modal('hide');
                this.init();
            }
        }
        angular.module('QMC.Udf').component('qmUdfTabSingletime', {
            templateUrl: 'UserDefinedFields/Tab_Singletime',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', 'QmcPermissionService', '$timeout', TabSingletimeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                save: '=',
                disabled: '=?',
                isValid: '=?',
                isTouched: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class TabTimeframeDirective {
            constructor(scope, $qui, udfService, lng) {
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.timeframes = [];
                this.timeframesMap = [];
                this.timeframeForm = { state: 'new' };
                this.promptOptions = {
                    title: this.lng.translate(20036003, 'Zeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.timeframeValidation = {
                    isLoading: false,
                    errors: [],
                    warnings: []
                };
                this.ui = new Udf.UdfUi(this.lng);
                this.$postLink = () => {
                    if (!this.reference || !this.definition) {
                        console.warn('UDF: reference or defintion not set!', this.reference, this.definition);
                        return;
                    }
                    this.loading = true;
                    this.events();
                    this.init();
                };
            }
            init() {
                this.loading = true;
                this.udfService.getTimeframes(this.definition.objectType, this.reference.id).then(data => {
                    var _a;
                    // sort timeframes by date and crete an appropriate object for the select
                    data.forEach(x => {
                        x.dateFrom = this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = this.$qui.createDateFromString(x.dateTo);
                    });
                    this.timeframes = data;
                    this.timeframesMap = data.sort((a, b) => b.dateFrom.getTime() - a.dateFrom.getTime()).map(x => ({ text: this.ui.createDateString(x.dateFrom, x.dateTo), value: x.objectId }));
                    //if current timeframeId is not in the list of timeframes, select the first (most recent) one
                    if (!this.timeframesMap.some(x => x.value === this.timeframeId))
                        this.timeframeIdSelect = (_a = this.timeframesMap[0]) === null || _a === void 0 ? void 0 : _a.value;
                }).finally(() => {
                    this.loading = false;
                });
            }
            events() {
                this.scope.$watch('vm.timeframeIdSelect', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    const action = () => {
                        this.timeframeId = newVal;
                    };
                    if (!oldVal || !this.isTouched || !this.hideSaveButton)
                        action();
                    else if (!this.isValid) {
                        this.promptOptions.itemText = '';
                        this.promptOptions.text = this.lng.translate(20002063, "Die eingegebenen Daten sind nicht valide und können nicht gespeichert werden. Möchten Sie die Eingaben anpassen?");
                        QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                            if (!data)
                                action();
                            else
                                this.timeframeIdSelect = oldVal;
                            $(`#udf-tab-timeframe-prompt-${this.id}`).modal('hide');
                        }, `#udf-tab-timeframe-prompt-${this.id}`, true);
                    }
                    else {
                        this.promptOptions.itemText = '';
                        this.promptOptions.text = this.lng.translate(20002064, "Es gibt nicht gespeicherte Änderungen. Möchten Sie diese vor dem Zeitraumwechsel speichern?");
                        QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                            if (data) {
                                this.save().then(action);
                            }
                            else {
                                action();
                            }
                        }, `#udf-tab-timeframe-prompt-${this.id}`);
                    }
                });
                this.scope.$watch('vm.timeframeForm.form', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.timeframeValidation = {
                        isLoading: true,
                        warnings: [],
                        errors: []
                    };
                    this.udfService.valiadateTimeframe(this.definition.objectType, this.timeframeForm.form).then(data => {
                        this.timeframeValidation.errors = data.errors;
                        this.timeframeValidation.warnings = data.warnings;
                    }).catch((e) => {
                        console.error('Error validating udf-timeframe', e);
                        this.timeframeValidation.errors = [this.lng.translate(21003023, 'Der Datensatz konnte nicht erfolgreich validiert werden.')];
                    }).finally(() => this.timeframeValidation.isLoading = false);
                }, true);
            }
            addTimeframe() {
                this.timeframeForm.form = {
                    id: null,
                    objectId: null,
                    dateFrom: new Date(),
                    referenceId: this.reference.id
                };
                this.timeframeForm.state = 'new';
                $(`#timeframeModal_${this.id}`).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            }
            openTimeframe(id) {
                this.timeframeForm.form = this.timeframes.find(x => x.objectId === id);
                this.timeframeForm.state = 'edit';
                $(`#timeframeModal_${this.id}`).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            }
            deleteTimeframe(id) {
                const item = this.timeframesMap.find(x => x.value === id);
                if (!item)
                    return;
                this.promptOptions.itemText = item.text;
                this.promptOptions.text = this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?");
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (!data)
                        return;
                    this.loading = true;
                    this.udfService.deleteTimeframe(this.definition.objectType, id, this.reference.id).catch((e) => {
                        console.error('Error deleting timeframe', e);
                    }).finally(() => {
                        this.init();
                    });
                }, `#udf-tab-timeframe-prompt-${this.id}`);
            }
            createTimeframe(form) {
                this.udfService.createTimeframe(this.definition.objectType, form).then(data => this.timeframeIdSelect = data.createdObjectId).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                }).finally(() => {
                    this.init();
                });
            }
            updateTimeframe(form) {
                this.udfService.updateTimeframe(this.definition.objectType, form.objectId, form).then(() => {
                    // workarround to update select components display
                    const tempId = this.timeframeId;
                    this.timeframeId = undefined;
                    this.$qui.scopeApply(this.scope);
                    this.$qui.notify(this.$qui.successNote);
                    setTimeout(() => this.timeframeId = tempId, 250);
                }).finally(() => {
                    this.init();
                });
            }
        }
        angular.module('QMC.Udf').component('qmUdfTabTimeframe', {
            templateUrl: 'UserDefinedFields/Tab_Timeframe',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', TabTimeframeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class TimeframeDirective {
            constructor(scope, $qui, udfService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.timeframes = [];
                this.timeframesMap = [];
                this.timeframeForm = { state: 'new' };
                this.promptOptions = {
                    title: this.lng.translate(20036003, 'Zeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.timeframeValidation = {
                    isLoading: false,
                    errors: [],
                    warnings: []
                };
                this.ui = new Udf.UdfUi(this.lng);
                this.$postLink = () => {
                    if (!this.reference || !this.definition) {
                        console.warn('UDF: reference or defintion not set!', this.reference, this.definition);
                        return;
                    }
                    this.loading = true;
                    this.permissionService.getPermissionsByObjectTypes([this.definition.objectType]).then(data => {
                        this.permissions = data[0];
                        this.events();
                        this.init();
                        this.save = (showNotification = true, timeframeId) => {
                            if (!this.udf)
                                return;
                            const saveObject = {
                                udfId: this.udf.udfId,
                                dateFrom: this.udf.dateFrom,
                                dateTo: this.udf.dateTo,
                                values: {}
                            };
                            this.udf.fields.forEach(field => {
                                saveObject.values[field.objectId] = field.values;
                            });
                            this.loading = true;
                            return this.udfService.updateUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, saveObject, timeframeId !== null && timeframeId !== void 0 ? timeframeId : this.timeframeId).then(() => {
                                if (showNotification)
                                    this.$qui.notify(this.$qui.successNote);
                                return true;
                            }).catch((e) => {
                                console.error('Error saving udf', e);
                                return false;
                            }).finally(() => {
                                this.getUdfData();
                            });
                        };
                    }).catch(e => {
                        console.error('Error loading udf', e);
                        this.loading = false;
                    });
                };
            }
            init() {
                this.isValid = false;
                this.loading = true;
                this.udfService.getTimeframes(this.definition.objectType).then(data => {
                    var _a;
                    // sort timeframes by date and crete an appropriate object for the select
                    data.forEach(x => {
                        x.dateFrom = this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = this.$qui.createDateFromString(x.dateTo);
                    });
                    this.timeframes = data;
                    this.timeframesMap = data.sort((a, b) => b.dateFrom.getTime() - a.dateFrom.getTime()).map(x => ({ text: this.ui.createDateString(x.dateFrom, x.dateTo), value: x.objectId }));
                    //if current timeframeId is not in the list of timeframes, select the first (most recent) one
                    if (!this.timeframesMap.some(x => x.value === this.timeframeId))
                        this.timeframeId = (_a = this.timeframesMap[0]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!this.timeframeId || this.timeframeId === QMC.Common.Constants.GUID_EMPTY)
                        this.isValid = true;
                }).finally(() => {
                    this.loading = false;
                });
                this.$qui.functionWaiter("ui.createForm", this);
            }
            events() {
                this.scope.$watch('vm.timeframeId', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    const action = () => {
                        if (this.timeframeId)
                            this.getUdfData();
                        else
                            this.udf = undefined;
                    };
                    if (!oldVal || !this.isTouched || !this.hideSaveButton)
                        action();
                    else if (!this.isValid) {
                        this.promptOptions.itemText = '';
                        this.promptOptions.text = this.lng.translate(20002063, "Die eingegebenen Daten sind nicht valide und können nicht gespeichert werden. Möchten Sie die Eingaben anpassen?");
                        QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                            if (!data)
                                action();
                            else
                                this.timeframeId = oldVal;
                            $(`#udf-timeframe-prompt-${this.id}`).modal('hide');
                        }, `#udf-timeframe-prompt-${this.id}`, true);
                    }
                    else {
                        this.promptOptions.itemText = '';
                        this.promptOptions.text = this.lng.translate(20002064, "Es gibt nicht gespeicherte Änderungen. Möchten Sie diese vor dem Zeitraumwechsel speichern?");
                        QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                            if (data) {
                                this.save(true, oldVal).then(action);
                            }
                            else {
                                action();
                            }
                        }, `#udf-timeframe-prompt-${this.id}`);
                    }
                });
                this.scope.$watch('vm.timeframeForm.form', (newVal, oldVal) => {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    this.timeframeValidation = {
                        isLoading: true,
                        warnings: [],
                        errors: []
                    };
                    this.udfService.valiadateTimeframe(this.definition.objectType, this.timeframeForm.form).then(data => {
                        this.timeframeValidation.errors = data.errors;
                        this.timeframeValidation.warnings = data.warnings;
                    }).catch((e) => {
                        console.error('Error validating udf-timeframe', e);
                        this.timeframeValidation.errors = [this.lng.translate(21003023, 'Der Datensatz konnte nicht erfolgreich validiert werden.')];
                    }).finally(() => this.timeframeValidation.isLoading = false);
                }, true);
            }
            getUdfData() {
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, this.timeframeId).then(data => {
                    this.udf = data[0];
                }).finally(() => {
                    this.loading = false;
                });
            }
            addTimeframe() {
                this.timeframeForm.form = {
                    id: null,
                    objectId: null,
                    dateFrom: new Date()
                };
                this.timeframeForm.state = 'new';
                $(`#timeframeModal_${this.id}`).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            }
            openTimeframe(id) {
                this.timeframeForm.form = this.timeframes.find(x => x.objectId === id);
                this.timeframeForm.state = 'edit';
                $(`#timeframeModal_${this.id}`).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            }
            deleteTimeframe(id) {
                const item = this.timeframesMap.find(x => x.value === id);
                if (!item)
                    return;
                this.promptOptions.itemText = item.text;
                this.promptOptions.text = this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?");
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (!data)
                        return;
                    this.loading = true;
                    this.udfService.deleteTimeframe(this.definition.objectType, id).catch((e) => {
                        console.error('Error deleting timeframe', e);
                    }).finally(() => {
                        this.init();
                    });
                }, `#udf-timeframe-prompt-${this.id}`);
            }
            createTimeframe(form) {
                this.udfService.createTimeframe(this.definition.objectType, form).then(data => this.timeframeId = data.createdObjectId).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                }).finally(() => {
                    this.init();
                });
            }
            updateTimeframe(form) {
                this.udfService.updateTimeframe(this.definition.objectType, form.objectId, form).then(() => {
                    // workarround to update select components display
                    const tempId = this.timeframeId;
                    this.timeframeId = undefined;
                    this.$qui.notify(this.$qui.successNote);
                    setTimeout(() => this.timeframeId = tempId, 250);
                }).finally(() => {
                    this.init();
                });
            }
        }
        angular.module('QMC.Udf').component('qmUdfTimeframe', {
            templateUrl: 'UserDefinedFields/Timeframe',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', 'QmcPermissionService', TimeframeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        class ValueDisplayDirective {
            constructor(scope, $qui, lng, udfService) {
                this.scope = scope;
                this.$qui = $qui;
                this.lng = lng;
                this.udfService = udfService;
                this.value = '';
                this.wv = [];
                this.$postLink = () => {
                    this.scope.$watch('vm.field.wvId', () => {
                        if (this.field.fieldType === 40 || this.field.fieldType === 60) { //wv
                            this.udfService.getWv(this.field.wvId).then(data => this.wv = data.map(x => ({ text: x.name, value: x.id }))).catch(() => this.wv = []).finally(() => this.value = this.getValueString());
                        }
                        if (this.field.fieldType === 50 || this.field.fieldType === 70) { //ds
                            this.udfService.getDs(this.field.wvId).then(data => this.wv = data.map(x => ({ text: x.caption, value: x.id }))).catch(() => this.wv = []).finally(() => this.value = this.getValueString());
                        }
                    });
                    this.scope.$watch('vm.field.values', (newVal, oldVal) => {
                        if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                            return;
                        this.getValue();
                    }, true);
                    this.getValue();
                };
            }
            getValue() {
                this.value = this.getValueString();
                // for media display the names of the files
                if ([80, 81, 82].includes(this.field.fieldType)) {
                    this.value = '';
                    if (this.field.values[0]) {
                        this.udfService.getUserDefinedFieldMedia(this.field.values[0]).then(data => {
                            this.value = data.map(x => x.caption).join(', ');
                        });
                    }
                }
            }
            getValueString() {
                let result = '';
                switch (this.field.fieldType) {
                    case 1: // decimal
                        result = this.$qui.qmcRounding(this.field.values[0]);
                        break;
                    case 2: // bool
                        result = this.field.values[0] ? '✔' : '';
                        break;
                    case 10: // date
                        result = this.field.values[0] ? moment(this.field.values[0]).format('DD.MM.YYYY') : '';
                        break;
                    case 12: // datetime
                        result = this.field.values[0] ? moment(this.field.values[0]).format('DD.MM.YYYY HH:mm') : '';
                        break;
                    case 15: // headline
                    case 16: // seperator
                        break;
                    case 40: // WV
                    case 60: // WV mutli
                    case 50: // DS
                    case 70: // DS multi
                        const captions = [];
                        this.field.values.forEach(id => { var _a, _b; return captions.push((_b = (_a = this.wv.find(x => x.value === id)) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : ''); });
                        result = captions.join('; ');
                        break;
                    default:
                        result = this.field.values[0];
                        break;
                }
                return result;
            }
        }
        angular.module('QMC.Udf').component('qmUdfValue', {
            controller: ['$scope', '$qui', 'QmcLanguageService', 'QmcUdfService', ValueDisplayDirective],
            controllerAs: 'vm',
            bindings: {
                field: '=',
            },
            template: '<span class="udf-inline-flex">\
			<strong>{{vm.field.caption}}</strong>\
			<span class="pull-right" style="word-break: break-word; max-height: 5em; text-align: right; overflow: hidden">{{vm.value}}</span>\
		</span>',
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        let UserDefinedFieldContainerType;
        (function (UserDefinedFieldContainerType) {
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Unsupported"] = -1] = "Unsupported";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Standard"] = 0] = "Standard";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Timeframe"] = 1] = "Timeframe";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["SingleTimeframe"] = 2] = "SingleTimeframe";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Tab"] = 3] = "Tab";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["TabWithTimeFrame"] = 4] = "TabWithTimeFrame";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["TabWithSingleTimeframe"] = 5] = "TabWithSingleTimeframe";
        })(UserDefinedFieldContainerType || (UserDefinedFieldContainerType = {}));
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        let QmcUdfService = class QmcUdfService extends QMC.Common.BaseService {
            constructor() {
                super(...arguments);
                this.cache = {
                    wv: {},
                    wvTimestamp: {},
                    ds: {},
                    dsTimestamp: {},
                    container: {},
                    containerTimestamp: {}
                };
                this.modulePath = '/UserDefinedFields';
            }
            ///////////////// BASE /////////////////
            timestampExceedsThreshold(date, threshold) {
                const now = new Date();
                threshold = threshold !== null && threshold !== void 0 ? threshold : 5 * 60 * 1000; // 5min
                return (now.getTime() - date.getTime()) > threshold;
            }
            getWv(id) {
                let cache = this.cache.wv[id];
                if (cache) {
                    const deferred = this.$q.defer();
                    if (cache === 'loading') {
                        setTimeout(() => deferred.resolve(this.getWv(id)), 100);
                        return deferred.promise;
                    }
                    else if (!this.timestampExceedsThreshold(this.cache.wvTimestamp[id])) {
                        deferred.resolve(cache);
                        return deferred.promise;
                    }
                }
                this.cache.wv[id] = 'loading';
                return super.get(`/WV/${id}`, {}, (data) => {
                    data.forEach(x => {
                        x.id = x.id.toLocaleLowerCase();
                        x.objectId = x.objectId.toLocaleLowerCase();
                    });
                    this.cache.wv[id] = data;
                    this.cache.wvTimestamp[id] = new Date();
                    return data;
                });
            }
            getDs(id) {
                let cache = this.cache.ds[id];
                if (cache) {
                    const deferred = this.$q.defer();
                    if (cache === 'loading') {
                        setTimeout(() => deferred.resolve(this.getDs(id)), 100);
                        return deferred.promise;
                    }
                    else if (!this.timestampExceedsThreshold(this.cache.dsTimestamp[id])) {
                        deferred.resolve(cache);
                        return deferred.promise;
                    }
                }
                this.cache.ds[id] = 'loading';
                return super.get(`/DataSource/${id}`, {}, (data) => {
                    data.forEach(x => {
                        x.id = x.id.toLocaleLowerCase();
                        x.objectId = x.objectId.toLocaleLowerCase();
                    });
                    this.cache.ds[id] = data;
                    this.cache.dsTimestamp[id] = new Date();
                    return data;
                });
            }
            ///////////////// Standard /////////////////
            getUserDefinedFieldDefintion(definitionObjectType, definitionId) {
                return super.get(`/${this.modulePath}/${definitionObjectType}/${definitionId}`, {}, (data) => {
                    return data;
                });
            }
            getUserDefinedFields(referenceObjectType) {
                let cache = this.cache.container[referenceObjectType];
                if (cache) {
                    const deferred = this.$q.defer();
                    if (cache === 'loading') {
                        setTimeout(() => deferred.resolve(this.getUserDefinedFields(referenceObjectType)), 100);
                        return deferred.promise;
                    }
                    // threshold is 1min
                    else if (!this.timestampExceedsThreshold(this.cache.containerTimestamp[referenceObjectType], 60000)) {
                        deferred.resolve(cache.map(udf => ({ ...udf, isValid: false })));
                        return deferred.promise;
                    }
                }
                this.cache.container[referenceObjectType] = 'loading';
                return super.get(`/${this.modulePath}/${referenceObjectType}`, {}, (data) => {
                    const containers = data.map(udf => ({ ...udf, isValid: false }));
                    this.cache.container[referenceObjectType] = containers;
                    this.cache.containerTimestamp[referenceObjectType] = new Date();
                    return containers;
                });
            }
            getUserDefinedField(referenceObjectType, referenceId, definitionObjectType, definitionId, timeframe, createDefaults) {
                return super.get(`/${this.modulePath}/${referenceObjectType}/${referenceId}/${definitionObjectType}/${definitionId}`, { timeframe, createDefaults }, (data) => {
                    return data;
                });
            }
            updateUserDefinedField(referenceObjectType, referenceId, definitionObjectType, definitionId, data, timeframe) {
                return super.put(`/${this.modulePath}/${referenceObjectType}/${referenceId}/${definitionObjectType}/${definitionId}?${timeframe ? 'timeframe=' + timeframe : ''}`, data).then((data) => {
                    return data;
                });
            }
            ///////////////// TIMEFRAME /////////////////
            getTimeframes(definitionObjectType, referenceId) {
                return super.get(`/${this.modulePath}/Timeframe/${definitionObjectType}`, { referenceId }, (data) => {
                    return data;
                });
            }
            createTimeframe(definitionObjectType, data) {
                return super.post(`/${this.modulePath}/Timeframe/${definitionObjectType}`, data).then((data) => {
                    return data;
                });
            }
            updateTimeframe(definitionObjectType, timeframeId, data) {
                return super.put(`/${this.modulePath}/Timeframe/${definitionObjectType}/${timeframeId}`, data).then((data) => {
                    return data;
                });
            }
            deleteTimeframe(definitionObjectType, timeframeId, referenceId) {
                return super.delete(`/${this.modulePath}/Timeframe/${definitionObjectType}/${timeframeId}?referenceId=${referenceId}`).then((data) => {
                    return data;
                });
            }
            valiadateTimeframe(definitionObjectType, data) {
                return super.post(`/${this.modulePath}/Timeframe/Validation/${definitionObjectType}`, data).then((data) => {
                    return data;
                });
            }
            ///////////////// SINGLETIME /////////////////
            createSingletime(referenceObjectType, referenceId, definitionObjectType, definitionId, data) {
                return super.post(`/${this.modulePath}/Singletime/${referenceObjectType}/${referenceId}/${definitionObjectType}/${definitionId}`, data).then((data) => {
                    return data;
                });
            }
            deleteSingletime(referenceObjectType, referenceId, definitionObjectType, definitionId, singletimeId) {
                return super.delete(`/${this.modulePath}/Singletime/${referenceObjectType}/${referenceId}/${definitionObjectType}/${definitionId}/${singletimeId}`).then((data) => {
                    return data;
                });
            }
            createTabSingletime(referenceObjectType, referenceId, definitionObjectType, definitionId, data) {
                return super.post(`/${this.modulePath}/Singletime/Tabs/${referenceObjectType}/${referenceId}/${definitionObjectType}/${definitionId}`, data).then((data) => {
                    return data;
                });
            }
            deleteTabSingletime(referenceObjectType, referenceId, definitionObjectType, definitionId, singletimeId) {
                return super.delete(`/${this.modulePath}/Singletime/Tabs/${referenceObjectType}/${referenceId}/${definitionObjectType}/${definitionId}/${singletimeId}`).then((data) => {
                    return data;
                });
            }
            ///////////////// Tabs /////////////////
            getTabs(definitionObjectType) {
                return super.get(`/${this.modulePath}/Tabs/${definitionObjectType}`, {}, (data) => {
                    return data;
                });
            }
            ///////////////// Media /////////////////
            getUserDefinedFieldMedia(mediaId) {
                return super.get(`/${this.modulePath}/Media/${mediaId}`, {}, (data) => {
                    return data;
                });
            }
            postUserDefinedFieldMedia(data) {
                return super.post(`/${this.modulePath}/Media`, data).then(data => { return data; });
            }
        };
        QmcUdfService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Udf', 'QmcUdfService')
        ], QmcUdfService);
        Udf.QmcUdfService = QmcUdfService;
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        class UdfUi extends QMC.Common.UserInterface {
            constructor(lng) {
                super();
                this.lng = lng;
                /**
                * Client detail info form
                * @memberOf UserInterface
                */
                this.timeframeForm = {
                    form: [{
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            required: true,
                            config: {
                                displayDateTo: true,
                                dateFromNotRequired: false
                            }
                        }],
                    actions: {
                        put: "updateTimeframe",
                        post: "createTimeframe"
                    }
                };
            }
            createDateString(dateFrom, dateTo) {
                const format = 'DD.MM.YYYY';
                if (dateFrom && dateTo)
                    return moment(dateFrom).format(format) + ' - ' + moment(dateTo).format(format);
                else if (dateFrom && !dateTo)
                    return this.lng.translate(20000124, 'Ab') + ' ' + moment(dateFrom).format(format);
                else if (!dateFrom && dateTo)
                    return this.lng.translate(20000125, 'Bis') + ' ' + moment(dateTo).format(format);
                else
                    return this.lng.translate(20000324, 'Unbestimmt');
            }
        }
        Udf.UdfUi = UdfUi;
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        class DocumentDetailUI extends Common.UserInterface {
            constructor() {
                super(...arguments);
                /**
        * Client detail document table
        * @memberOf UserInterface
        */
                this.attachedFilesTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Dateiname": {
                            "label": "fileName",
                            "dType": "string",
                            "lngTag": "21006017"
                        },
                        "Dateigröße": {
                            "label": "fileSize",
                            "dType": "string",
                            "lngTag": "21006018"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "allowPreview",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteFile",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-document_attachment"
                        },
                        "text": {
                            "label": "fileName",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "date",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "allowPreview",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteFile",
                                "permissionByDataSet": true
                            },
                            {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }
                        ]
                    },
                    "data": null,
                };
            }
        }
        Common.DocumentDetailUI = DocumentDetailUI;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        let DocumentFolderStructureDirective = class DocumentFolderStructureDirective {
            constructor($qui, lng, permissionService, stammdatenService, userService, $state, $timeout) {
                this.$qui = $qui;
                this.lng = lng;
                this.permissionService = permissionService;
                this.stammdatenService = stammdatenService;
                this.userService = userService;
                this.$state = $state;
                this.$timeout = $timeout;
                this.restrict = 'E';
                this.templateUrl = './Documents/DocumentFolderStructure';
                this.replace = true;
                this.scope = {
                    qmParent: '=',
                    qmObjectType: '=',
                    qmParentObjectType: '=',
                    qmCreate: '=',
                    qmPersonMode: '=?'
                };
                this.link = (scope) => {
                    scope.vm = scope;
                    scope.id = Math.random().toString(36).substring(2, 11);
                    scope.idDeletePrompt = 'promptDeleteDocumentDirective_' + scope.id;
                    scope.showFolderStructure = true;
                    scope.allowDownload = false;
                    scope.loading = {
                        folder: false,
                        permission: false
                    };
                    scope.wv = {
                        documentTypeWvList: [],
                        mainCategoryWvList: [],
                        subCategoryWvList: []
                    };
                    scope.fileObject = {
                        id: null,
                        objectId: null,
                        base64String: null,
                        date: null,
                        documentId: null,
                        fileName: null,
                    };
                    scope.ui = new QMC.Common.DocumentDetailUI();
                    scope.firstLoad = true;
                    scope.directiveCreated = false;
                    scope.fileChoser = {
                        files: []
                    };
                    scope.$watch('qmParent', (newVal, oldVal) => {
                        if (newVal === oldVal && scope.directiveCreated)
                            return;
                        scope.directiveCreated = false;
                        scope.qmCreate();
                    });
                    scope.$watch('qmObjectType', (newVal, oldVal) => {
                        if (newVal === oldVal || !newVal)
                            return;
                        scope.directiveCreated = false;
                        scope.qmCreate();
                    });
                    scope.qmCreate = () => {
                        const createdFor = {
                            objectType: scope.qmObjectType,
                            parent: scope.qmParent
                        };
                        if (!scope.qmObjectType || JSON.stringify(scope.createdFor) === JSON.stringify(createdFor))
                            return;
                        scope.createdFor = createdFor;
                        scope.initForm();
                        scope.loading.permission = true;
                        this.permissionService.getPermissionsByObjectTypes([scope.qmObjectType, 920002, 905002, 905004]).then((data) => {
                            var _a, _b;
                            //920002 - Web Dokumente herunterladen
                            //905004 - Dokumentenverwaltung - Ordner
                            scope.moduleAccess = ((_a = data[0]) === null || _a === void 0 ? void 0 : _a.moduleAccess) && ((_b = data[0]) === null || _b === void 0 ? void 0 : _b.view);
                            scope.new = data[0].new && data[2].new;
                            scope.modify = data[0].modify && data[2].modify;
                            scope.delete = data[0].delete && data[2].delete;
                            scope.print = data[0].print;
                            scope.webAllowDownload = data[1].openFile;
                            scope.newFolder = scope.new;
                            scope.showMappings = data[3].view;
                            scope.foldersTreeList = [];
                            scope.foldersTreeListHierarchyEdit = [];
                            scope.lastFolderSelected = undefined;
                            scope.loading.folder = false;
                            scope.ui.attachedFilesTable.data = [];
                            this.$qui.functionWaiter("ui.createTable", scope);
                            if (scope.qmParent === null || scope.qmParent === undefined) {
                                return;
                            }
                            //this.$qui.getTableAutoload(this.userService).then((ltd) => {
                            //	scope.shouldLoadTableData = ltd;
                            // as agreed in DA-5088 this should always be true for documents. So no manual loading here
                            scope.shouldLoadTableData = true;
                            if (scope.shouldLoadTableData) {
                                scope.getData();
                            }
                            //});
                            scope.$watch('form.mainCategoryId', (newVal, oldVal) => {
                                if (newVal != oldVal) {
                                    scope.getSubCategoryList();
                                }
                            }, true);
                            scope.selectedFolderHierarchyId = QMC.Common.Constants.GUID_EMPTY;
                            scope.selectedFolderId = QMC.Common.Constants.GUID_EMPTY;
                            scope.hierachyTitle = this.lng.translate(21006021, "Kein übergeordneter Ordner");
                            $('#edit-form-document-' + scope.qmParent + scope.id).on('hidden.bs.modal', () => {
                                scope.hierachyTitle = this.lng.translate(21006021, "Kein übergeordneter Ordner");
                            });
                            scope.$watch('fileChoser.files', () => {
                                if (scope.fileChoser.files && scope.fileChoser.files.length > 0) {
                                    scope.fileObject.fileName = scope.fileChoser.files[0].name;
                                    scope.fileObject.base64String = scope.fileChoser.files[0].base64;
                                    scope.postFileToFolder(scope.selectedFolderId);
                                    scope.fileChoser.files = [];
                                }
                            }, true);
                            scope.loading.permission = false;
                            this.$qui.scopeApply(scope);
                            if (scope.showMappings) {
                                this.stammdatenService.getDocumentMappingForObjecttype(scope.qmObjectType).then(data => {
                                    scope.mappings = data;
                                });
                            }
                        });
                        scope.directiveCreated = true;
                    };
                    //setValidationBack - in some cases (like for Tasks) the directive (with its Dialogs and so on) is included in another Dialog/Form that has to validate if the form.$invalid is false before
                    //allowing the user to save. since the folder structure form has also its own internal validation, the main dialog/form finds that the folder structure form is not valid and set $invalid to true also for it
                    //the user is not allowed to save so this trick is "pausing" the folder structure form validation on creating the directive and resets the validation back when the user wants to create or edit a folder
                    scope.initForm = (setValidationBack = false) => {
                        scope.formStateDocuDirective = "new";
                        scope.documentListItem = {
                            id: scope.qmParent,
                            objectId: scope.qmParent,
                            version: null,
                            date: null,
                            title: null,
                            subTitle: null,
                            isPrivate: false,
                            mainCategory: null,
                            parentObjectType: scope.qmParentObjectType,
                            objectType: scope.qmObjectType
                        };
                        scope.document = {
                            id: scope.qmParent,
                            objectId: scope.qmParent,
                            version: null,
                            title: null,
                            subTitle: null,
                            comment: "",
                            isPrivate: false,
                            documentTypeId: null,
                            attachedDocuments: [],
                            parentObjectType: scope.qmParentObjectType,
                            objectType: scope.qmObjectType
                        };
                        scope.form = {
                            id: scope.qmParent,
                            parentObjectId: null,
                            fkParentHierarchy: QMC.Common.Constants.GUID_EMPTY,
                            documentTypeId: setValidationBack ? null : QMC.Common.Constants.GUID_EMPTY,
                            mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                            subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                            objectId: null,
                            version: null,
                            title: setValidationBack ? null : "",
                            subTitle: null,
                            comment: null,
                            isPrivate: false,
                            attachedDocuments: null,
                            parentObjectType: scope.qmParentObjectType,
                            objectType: scope.qmObjectType
                        };
                        scope.selectedFolderHierarchyId = QMC.Common.Constants.GUID_EMPTY;
                        this.$qui.scopeApply(scope);
                    };
                    /************** UI HELPER *************/
                    scope.getData = (noFolderCreation = false) => {
                        scope.backupForm = null;
                        scope.loading.folder = true;
                        this.stammdatenService.getDocumentList(scope.qmParent).then(async (data) => {
                            var _a, _b;
                            // if we are not in personMode and got no Folder, create a default Folder. Also check if a folder is currently in creation to prevent double creation
                            if (!noFolderCreation && scope.moduleAccess && !scope.qmPersonMode && !(data === null || data === void 0 ? void 0 : data.length) && !scope.addingFolder) {
                                let caption = (_b = (_a = (await this.userService.getUserSettings(['DOKUMENTE.TREE.NameForAutoCreatedFolder'], false))[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : this.lng.translate(20013157, 'Allgemein');
                                scope.form = {
                                    id: scope.qmParent,
                                    parentObjectId: null,
                                    fkParentHierarchy: QMC.Common.Constants.GUID_EMPTY,
                                    mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                                    subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                                    objectId: null,
                                    version: null,
                                    title: caption,
                                    subTitle: null,
                                    comment: null,
                                    isPrivate: false,
                                    attachedDocuments: null,
                                    parentObjectType: scope.qmParentObjectType,
                                    objectType: scope.qmObjectType
                                };
                                scope.addDocFolder(false);
                            }
                            scope.foldersTreeList = data;
                            scope.foldersTreeListHierarchyEdit = angular.copy(data);
                            if (!scope.lastFolderSelected) {
                                scope.changeFolder(data[0]);
                            }
                            else {
                                scope.changeFolder(scope.lastFolderSelected);
                            }
                            // decide wether or not folder structure should be visible
                            scope.showFolderStructure = (data.length > 1 || scope.qmPersonMode);
                            scope.loading.folder = false;
                        });
                    };
                    scope.getSubCategoryList = () => {
                        const data = [];
                        if (scope.wv.subCategoryWvList) {
                            for (const element of scope.wv.subCategoryWvList) {
                                if ((element.parentWvId === scope.form.mainCategoryId) && !(/^\s*$/).test(element.name)) {
                                    data.push(element);
                                }
                            }
                            scope.subCategoryWvList = data.map(x => ({ text: x.name, value: x.objectId }));
                            if (data.length === 0) {
                                scope.form.subCategoryId = QMC.Common.Constants.GUID_EMPTY;
                            }
                        }
                    };
                    scope.openMappingsModal = () => {
                        $(`#mappingsModal${scope.id}`).modal('show');
                    };
                    /************** Folder Functions *************/
                    scope.changeFolder = (data) => {
                        if (!data) {
                            scope.newFolder = scope.new;
                            return;
                        }
                        ;
                        $('#' + scope.selectedFolderId).removeClass('active-folder');
                        scope.selectedFolderId = data.id;
                        scope.lastFolderSelected = data;
                        scope.getFolder(data);
                        const toggler = document.getElementsByClassName("qm-subfolders");
                        if (scope.firstLoad) {
                            scope.getDocumentUserConfig();
                        }
                        else {
                            for (const element of Array.from(toggler)) {
                                if (element.id === data.id) {
                                    element.parentElement.querySelector(".nested").classList.toggle("active");
                                    element.parentElement.querySelector(".foldername").classList.toggle("foldername-down");
                                }
                            }
                        }
                        scope.firstLoad = false;
                        $('#' + scope.selectedFolderId).addClass('active-folder');
                    };
                    scope.getEditFolderHierarchy = () => {
                        scope.formStateDocuDirective = "edit";
                        if (!scope.form.parentObjectId && scope.backupForm) {
                            scope.selectedFolderHierarchyId = scope.backupForm.fkParentHierarchy;
                            scope.form = scope.backupForm;
                        }
                        else {
                            scope.form.fkParentHierarchy = scope.selectedFolderHierarchyId;
                        }
                        scope.foldersTreeListHierarchyEdit = angular.copy(scope.foldersTreeList);
                        scope.hideUnderFolders();
                        scope.getSelectedHierarchyName();
                        if (scope.selectedFolderHierarchyId != QMC.Common.Constants.GUID_EMPTY) {
                            scope.hierachyTitle = this.lng.translate(21006019, "Untergeordnet von") + ": " + scope.hierachyTitle;
                        }
                        else {
                            scope.hierachyTitle = this.lng.translate(21006021, "Kein übergeordneter Ordner");
                        }
                        document.getElementById('untergeordnetVon' + scope.id).setAttribute("collapse", "close");
                    };
                    scope.hideUnderFolders = (hierarchyFolder = null) => {
                        if (!hierarchyFolder) {
                            for (let i = scope.foldersTreeListHierarchyEdit.length - 1; i >= 0; i--) {
                                if (scope.foldersTreeListHierarchyEdit[i].id === scope.form.id) {
                                    if (scope.foldersTreeListHierarchyEdit[i].children != null) {
                                        scope.foldersTreeListHierarchyEdit[i].children.splice(0, scope.foldersTreeListHierarchyEdit[i].children.length);
                                    }
                                }
                                else if (scope.foldersTreeListHierarchyEdit[i].children != null) {
                                    scope.hideUnderFolders(scope.foldersTreeListHierarchyEdit[i].children);
                                }
                            }
                        }
                        else {
                            for (let i = hierarchyFolder.length - 1; i >= 0; i--) {
                                if (hierarchyFolder[i].id === scope.form.id) {
                                    if (hierarchyFolder[i].children != null) {
                                        hierarchyFolder[i].children.splice(0, hierarchyFolder[i].children.length);
                                    }
                                }
                                else if (hierarchyFolder[i].children != null) {
                                    scope.hideUnderFolders(hierarchyFolder[i].children);
                                }
                            }
                        }
                    };
                    scope.getSelectedHierarchyName = (hierarchyFolder = null) => {
                        if (hierarchyFolder === null) {
                            const folders = scope.foldersTreeListHierarchyEdit.filter((x) => x.objectId === scope.form.fkParentHierarchy);
                            if (folders.length > 0) {
                                scope.hierachyTitle = folders[0].title;
                            }
                            else {
                                for (let i = scope.foldersTreeListHierarchyEdit.length - 1; i >= 0; i--) {
                                    const folders = scope.foldersTreeListHierarchyEdit[i].children.filter((x) => x.objectId === scope.form.fkParentHierarchy);
                                    if (folders.length > 0) {
                                        scope.hierachyTitle = folders[0].title;
                                        break;
                                    }
                                    else if (scope.foldersTreeListHierarchyEdit[i].children != null) {
                                        scope.getSelectedHierarchyName(scope.foldersTreeListHierarchyEdit[i].children);
                                    }
                                }
                            }
                        }
                        else {
                            for (let i = hierarchyFolder.length - 1; i >= 0; i--) {
                                const folders = hierarchyFolder[i].children.filter((x) => x.objectId === scope.form.fkParentHierarchy);
                                if (folders.length > 0) {
                                    scope.hierachyTitle = folders[0].title;
                                    break;
                                }
                                else if (hierarchyFolder[i].children != null) {
                                    scope.getSelectedHierarchyName(hierarchyFolder[i].children);
                                }
                            }
                        }
                    };
                    scope.selectFolderHierarchy = (data) => {
                        if (data.id != scope.selectedFolderId || scope.formStateDocuDirective === "new") {
                            $('#' + scope.selectedFolderHierarchyId).removeClass('active-folder');
                            if (scope.selectedFolderHierarchyId === data.id) {
                                scope.selectedFolderHierarchyId = QMC.Common.Constants.GUID_EMPTY;
                                scope.form.fkParentHierarchy = scope.selectedFolderHierarchyId;
                            }
                            else {
                                scope.selectedFolderHierarchyId = data.id;
                                scope.form.fkParentHierarchy = scope.selectedFolderHierarchyId;
                            }
                            scope.getSelectedHierarchyName();
                            if (scope.selectedFolderHierarchyId != QMC.Common.Constants.GUID_EMPTY) {
                                scope.hierachyTitle = this.lng.translate(21006019, "Untergeordnet von") + ": " + scope.hierachyTitle;
                            }
                            else {
                                scope.hierachyTitle = this.lng.translate(21006021, "Kein übergeordneter Ordner");
                            }
                            $('#' + scope.selectedFolderHierarchyId).addClass('active-folder');
                        }
                    };
                    scope.saveDocFolderChanges = () => {
                        if (scope.formStateDocuDirective === "edit") {
                            scope.putDocFolder();
                        }
                        else {
                            scope.addDocFolder();
                        }
                    };
                    /************** Service Functions *************/
                    scope.addDocFolder = (showNotification = true) => {
                        if (!scope.new)
                            return;
                        scope.addingFolder = true;
                        scope.form.parentObjectId = scope.qmParent;
                        scope.form.isPrivate = true;
                        scope.form.date = new Date();
                        this.stammdatenService.postNewDocument(scope.form).then((dataDocFolder) => {
                            scope.formStateDocuDirective = "new";
                            if (showNotification)
                                this.$qui.notify(this.$qui.successNote);
                        }).finally(() => this.$timeout(() => {
                            scope.getData(true);
                            scope.addingFolder = false;
                        }));
                    };
                    scope.putDocFolder = () => {
                        if (!scope.modify)
                            return;
                        scope.form.parentObjectId = scope.qmParent;
                        this.stammdatenService.editDocument(scope.qmParent, scope.form.objectId, scope.form).then((e) => {
                            this.$qui.notify(this.$qui.successNote);
                            scope.getData(true);
                        });
                    };
                    scope.deleteDocFolder = () => {
                        if (!scope.delete)
                            return;
                        scope.promptOptions = {
                            title: this.lng.translate(21006026, "Ordner löschen"),
                            yesNo: true,
                            icon: "qm-icon-history2",
                            text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                            itemText: scope.form.title
                        };
                        const containerId = scope.form.id;
                        QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                            if (data)
                                setTimeout(this.stammdatenService.deleteDocument(scope.qmParent, containerId).then(() => {
                                    scope.lastFolderSelected = null;
                                    this.$qui.notify(this.$qui.deleteNote);
                                    $('#edit-form-document-' + scope.qmParent + scope.id).modal('hide');
                                    scope.getData(true);
                                }), 300);
                        }, `#${scope.idDeletePrompt}`);
                    };
                    scope.getWv = () => {
                        scope.wv = {
                            documentTypeWvList: [],
                            mainCategoryWvList: [],
                            subCategoryWvList: []
                        };
                        this.stammdatenService.getDocumentWV().then((data) => {
                            scope.wv = data;
                            scope.documentTypeWvList = scope.wv.documentTypeWvList.map(x => ({ text: x.name, value: x.objectId }));
                            scope.mainCategoryWvList = scope.wv.mainCategoryWvList.map(x => ({ text: x.name, value: x.objectId }));
                        });
                    };
                    scope.getWv();
                    scope.getDocumentUserConfig = () => {
                        this.stammdatenService.getDocumentsUserConfig().then((data) => {
                            scope.documentUserConfig = data;
                            if (!scope.documentUserConfig.folderStructureIsCollapsable) {
                                const toggler = document.getElementsByClassName("qm-subfolders");
                                for (const element of Array.from(toggler)) {
                                    if (element.parentElement.querySelector(".nested"))
                                        element.parentElement.querySelector(".nested").classList.toggle("active");
                                    if (element.parentElement.querySelector(".foldername"))
                                        element.parentElement.querySelector(".foldername").classList.toggle("foldername-down");
                                }
                                this.$qui.scopeApply(scope);
                            }
                        });
                    };
                    scope.postFileToFolder = (docuId) => {
                        if (scope.newFile !== true)
                            return;
                        $('#uploadingScreen' + scope.id).modal('show');
                        scope.fileObject.documentId = docuId;
                        scope.fileObject.date = new Date();
                        scope.fileObject.objectType = scope.qmObjectType;
                        this.stammdatenService.addFileToDocument(scope.fileObject).then(() => {
                            this.$qui.notify(this.$qui.successNote, this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                            $('#uploadingScreen' + scope.id).modal('hide');
                            scope.getData(true);
                        });
                    };
                    scope.getFolder = (dataFolder) => {
                        const containerId = dataFolder.id;
                        const folderIsTemplate = dataFolder.fkTemplate !== QMC.Common.Constants.GUID_EMPTY;
                        this.stammdatenService.getDocument(scope.qmParent, containerId).then((dataDocument) => {
                            var _a, _b;
                            const folderCategoryId = (_a = dataDocument.mainCategoryId) !== null && _a !== void 0 ? _a : QMC.Common.Constants.GUID_EMPTY;
                            const attachmentCategoryIds = ((_b = dataDocument.attachedDocuments) !== null && _b !== void 0 ? _b : []).map((a) => { var _a; return (_a = a.mainCategoryId) !== null && _a !== void 0 ? _a : folderCategoryId; });
                            const categoryIds = [folderCategoryId, ...attachmentCategoryIds];
                            const categoryPermissionsPromise = this.loadCategoryPermissions(scope.qmObjectType, categoryIds);
                            // Align with WinClient behavior (FraDokumentAnhaenge): evaluate parent permission with document object type.
                            const parentPermissionObjectType = scope.qmObjectType;
                            const permParentPromise = this.permissionService.getPermissionsForDataset(scope.qmParent, parentPermissionObjectType);
                            const permObjectPromise = this.permissionService.getPermissionsForDataset(containerId, null);
                            Promise.all([categoryPermissionsPromise, permParentPromise, permObjectPromise])
                                .then(([categoryPermMap, permParentResult, permObjectResult]) => {
                                var _a;
                                const permParent = permParentResult === null || permParentResult === void 0 ? void 0 : permParentResult[0];
                                const permObject = permObjectResult === null || permObjectResult === void 0 ? void 0 : permObjectResult[0];
                                const folderCategory = this.getCategoryPermission(categoryPermMap, folderCategoryId);
                                scope.newFile = (permParent === null || permParent === void 0 ? void 0 : permParent.new) === true && (folderCategory === null || folderCategory === void 0 ? void 0 : folderCategory.new) === true;
                                scope.newFolder = (folderCategory === null || folderCategory === void 0 ? void 0 : folderCategory.new) === true && scope.new;
                                scope.modifyFolder = (permObject === null || permObject === void 0 ? void 0 : permObject.modify) === true && (folderCategory === null || folderCategory === void 0 ? void 0 : folderCategory.modify) === true && !folderIsTemplate && scope.moduleAccess && scope.modify;
                                scope.deleteFolder = (permObject === null || permObject === void 0 ? void 0 : permObject.delete) === true && (folderCategory === null || folderCategory === void 0 ? void 0 : folderCategory.delete) === true && scope.delete
                                    && dataDocument.attachedDocuments.length === 0 && !this.hasChildren(dataDocument, scope.foldersTreeList);
                                scope.printFile = (permObject === null || permObject === void 0 ? void 0 : permObject.print) === true && (folderCategory === null || folderCategory === void 0 ? void 0 : folderCategory.print) === true;
                                scope.form = angular.copy(dataDocument);
                                scope.backupForm = angular.copy(dataDocument);
                                if (dataFolder.fkParentHierarchy != null) {
                                    scope.selectedFolderHierarchyId = dataFolder.fkParentHierarchy;
                                }
                                else {
                                    scope.selectedFolderHierarchyId = dataFolder.id;
                                }
                                if (scope.form) {
                                    scope.form.fkParentHierarchy = scope.selectedFolderId;
                                    scope.backupForm.fkParentHierarchy = scope.selectedFolderHierarchyId;
                                }
                                scope.hierachyTitle = this.lng.translate(21006021, "Kein übergeordneter Ordner");
                                if ((permObject === null || permObject === void 0 ? void 0 : permObject.view) === true) {
                                    scope.documentType = this.getWvName(dataDocument.documentTypeId, scope.wv);
                                    scope.mainCategory = this.getWvName(dataDocument.mainCategoryId, scope.wv);
                                    scope.subCategory = this.getWvName(dataDocument.subCategoryId, scope.wv);
                                    scope.ui.attachedFilesTable.data = ((_a = dataDocument.attachedDocuments) !== null && _a !== void 0 ? _a : []).map((attachment) => {
                                        var _a;
                                        const documentCategoryId = (_a = attachment.mainCategoryId) !== null && _a !== void 0 ? _a : folderCategoryId;
                                        const documentCategory = this.getCategoryPermission(categoryPermMap, documentCategoryId);
                                        const permissions = this.buildAttachmentPermissions(scope.webAllowDownload, permObject, documentCategory);
                                        return {
                                            ...attachment,
                                            fileSize: this.fileSizeConvert(attachment.fileSize),
                                            stateLink: this.createStateLink(attachment, scope.qmParent),
                                            permissions
                                        };
                                    }).filter((attachment) => {
                                        var _a;
                                        const documentCategoryId = (_a = attachment.mainCategoryId) !== null && _a !== void 0 ? _a : folderCategoryId;
                                        const documentCategory = this.getCategoryPermission(categoryPermMap, documentCategoryId);
                                        return (documentCategory === null || documentCategory === void 0 ? void 0 : documentCategory.view) === true;
                                    });
                                }
                                else {
                                    scope.ui.attachedFilesTable.data = [];
                                }
                                this.$qui.functionWaiter("ui.createTable", scope);
                                this.$qui.scopeApply(scope);
                            })
                                .catch(() => {
                                scope.newFile = false;
                                scope.ui.attachedFilesTable.data = [];
                                this.$qui.functionWaiter("ui.createTable", scope);
                                this.$qui.scopeApply(scope);
                            });
                        }).catch(() => {
                            scope.initForm();
                            scope.newFolder = scope.new;
                            scope.modifyFolder = false;
                            scope.ui.attachedFilesTable.data = [];
                            this.$qui.functionWaiter("ui.createTable", scope);
                        });
                    };
                    /************** File handling *************/
                    scope.previewDocument = (dataFile) => {
                        var _a;
                        scope.allowDownload = ((_a = dataFile === null || dataFile === void 0 ? void 0 : dataFile.permissions) === null || _a === void 0 ? void 0 : _a.allowDownload) === true;
                        scope.downloadFile(dataFile, true);
                    };
                    scope.downloadFile = (dataFile, prev = false) => {
                        var _a, _b;
                        const allowed = prev
                            ? ((_a = dataFile === null || dataFile === void 0 ? void 0 : dataFile.permissions) === null || _a === void 0 ? void 0 : _a.allowPreview) === true
                            : ((_b = dataFile === null || dataFile === void 0 ? void 0 : dataFile.permissions) === null || _b === void 0 ? void 0 : _b.allowDownload) === true;
                        if (!allowed) {
                            return;
                        }
                        scope.fileInfos = undefined;
                        $('#downloadingScreen' + scope.id).modal('show');
                        this.stammdatenService.downloadAttachment(scope.selectedFolderId, dataFile.objectId).then((data) => {
                            $('#downloadingScreen' + scope.id).modal('hide');
                            try {
                                let filename = "datei";
                                for (const document of scope.form.attachedDocuments) {
                                    if (document.objectId === data.objectId) {
                                        filename = document.fileName;
                                    }
                                }
                                // get filename suffix and contenttype
                                const temp = filename.split('.');
                                const ext = temp[temp.length - 1];
                                scope.fileInfos = {
                                    base64: data.base64,
                                    fileType: ext,
                                    fileName: filename
                                };
                                this.$qui.scopeApply(scope);
                                if (prev)
                                    $('#previewModal' + scope.id).modal('show');
                                else {
                                    const blob = this.$qui.base64ToBlob(scope.fileInfos.base64, this.$qui.extToMime(scope.fileInfos.fileType));
                                    this.$qui.downloadBlob(scope.fileInfos.fileName, blob);
                                }
                            }
                            catch (e) {
                                console.log("downloadDocument Fehler: ", e);
                                this.$qui.notify({
                                    message: e,
                                    title: 'Download Error',
                                    icon: 'qm-icon-error',
                                    status: 'warning',
                                    timer: 10000
                                });
                            }
                        });
                    };
                    scope.deleteFileFromFolder = (dataFile) => {
                        var _a;
                        if (((_a = dataFile === null || dataFile === void 0 ? void 0 : dataFile.permissions) === null || _a === void 0 ? void 0 : _a.deleteFile) !== true) {
                            return;
                        }
                        //a small change for a new pull request
                        $('#loadingScreen' + scope.id).modal('toggle');
                        $('.modal-backdrop').remove();
                        scope.promptOptions = {
                            title: this.lng.translate(21006027, "Datei löschen"),
                            yesNo: true,
                            icon: "qm-icon-history2",
                            text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                            itemText: dataFile.fileName
                        };
                        if (!dataFile.referenceId || dataFile.referenceId === QMC.Common.Constants.GUID_EMPTY) {
                            scope.promptOptions.text += `\r\n${this.lng.translate(21006031, 'Alle ggf. verlinktem Dokumente werden hierbei ebenfalls gelöscht.')}`;
                        }
                        QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                            if (data) {
                                setTimeout(() => {
                                    $('.modal-backdrop').remove();
                                    this.stammdatenService.deleteFile(scope.selectedFolderId, dataFile.objectId).then((data) => {
                                        this.$qui.notify(this.$qui.deleteNote);
                                        scope.getData(true);
                                    });
                                }, 300);
                            }
                        }, `#${scope.idDeletePrompt}`);
                    };
                    scope.openReference = (data) => {
                        if (!data.stateLink)
                            return;
                        this.$state.go(data.stateLink.state, { id: data.stateLink.parentId, dataId: data.stateLink.referenceId });
                    };
                    scope.$on('$destroy', function () {
                        // remove all modals
                        $('#previewModal' + scope.id).remove();
                        $('#uploadingScreen' + scope.id).remove();
                        $('#downloadingScreen' + scope.id).remove();
                        $('#untergeordnetVon' + scope.id).remove();
                        $('#edit-form-document-' + scope.qmParent + scope.id).remove();
                        $('promptDeleteDocumentDirective_' + scope.id).remove();
                    });
                    scope.getSubFolderDocumentCount = (folder) => {
                        var _a;
                        const getChildren = (members) => {
                            let children = [];
                            const flattenMembers = members.map(m => {
                                var _a;
                                if ((_a = m.children) === null || _a === void 0 ? void 0 : _a.length) {
                                    children = [...children, ...m.children];
                                }
                                return m;
                            });
                            return flattenMembers.concat(children.length ? getChildren(children) : children);
                        };
                        const allFolders = [folder, ...getChildren((_a = folder.children) !== null && _a !== void 0 ? _a : [])];
                        return allFolders.reduce((prev, current) => (prev + current.documentCount), 0);
                    };
                };
            }
            loadCategoryPermissions(objectType, categoryIds) {
                const uniqueIds = [];
                for (const id of categoryIds) {
                    if (id != null && uniqueIds.indexOf(id) === -1) {
                        uniqueIds.push(id);
                    }
                }
                if (uniqueIds.length === 0) {
                    return Promise.resolve(new Map());
                }
                return Promise.all(uniqueIds.map((categoryId) => this.permissionService
                    .getMediaPermissions(objectType, QMC.Common.Constants.WV_DOCUMENT_RUBRIC, categoryId)
                    .then((permissions) => ({ categoryId, permission: permissions === null || permissions === void 0 ? void 0 : permissions[0] })))).then((results) => {
                    const map = new Map();
                    for (const { categoryId, permission } of results) {
                        if (permission) {
                            map.set(categoryId, permission);
                        }
                    }
                    return map;
                });
            }
            getCategoryPermission(categoryPermMap, categoryId) {
                if (categoryId == null) {
                    return undefined;
                }
                return categoryPermMap.get(categoryId);
            }
            buildAttachmentPermissions(webAllowDownload, permObject, documentCategory) {
                return {
                    allowPreview: (permObject === null || permObject === void 0 ? void 0 : permObject.openFile) === true && (documentCategory === null || documentCategory === void 0 ? void 0 : documentCategory.openFile) === true,
                    allowDownload: webAllowDownload === true && (permObject === null || permObject === void 0 ? void 0 : permObject.print) === true && (documentCategory === null || documentCategory === void 0 ? void 0 : documentCategory.print) === true,
                    deleteFile: (permObject === null || permObject === void 0 ? void 0 : permObject.delete) === true && (documentCategory === null || documentCategory === void 0 ? void 0 : documentCategory.delete) === true,
                };
            }
            createStateLink(data, parentId) {
                if (!data.referenceObjectType || !data.referenceId)
                    return undefined;
                let state = '';
                switch (data.referenceObjectType) {
                    case 120002:
                        state = 'employee.address';
                        break;
                    case 120004:
                        state = 'employee.communication';
                        break;
                    case 120012:
                        state = 'employee.contactperson';
                        break;
                    case 120020:
                        state = 'employee.checklist';
                        break;
                    case 120046:
                        state = 'employee.vaccination';
                        break;
                    case 140002:
                        state = 'detail.disease';
                        break;
                    case 140003:
                        state = 'detail.doctorsvisit';
                        break;
                    case 140005:
                        state = 'detail.vaccination';
                        break;
                    case 140006:
                        state = 'detail.contactperson';
                        break;
                    case 140021:
                        state = 'detail.address';
                        break;
                    case 140023:
                        state = 'detail.communication';
                        break;
                    case 140027:
                        state = 'detail.legal';
                        break;
                    case 140057:
                        state = 'detail.checklist';
                        break;
                    case 140068:
                        state = 'detail.education';
                        break;
                    default: return undefined;
                }
                return {
                    state,
                    parentId,
                    referenceId: data.referenceId
                };
            }
            hasChildren(folder, foldersTreeList) {
                for (const element of foldersTreeList) {
                    if (element.id === folder.id) {
                        return element.children.length > 0;
                    }
                }
                return false;
            }
            fileSizeConvert(sizeInBytes) {
                if (sizeInBytes === 0) {
                    return '0 Bytes';
                }
                ;
                const kbUnit = 1024;
                const usedSizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                const i = Math.floor(Math.log(sizeInBytes) / Math.log(kbUnit));
                return parseFloat((sizeInBytes / Math.pow(kbUnit, i)).toFixed(2)) + ' ' + usedSizes[i];
            }
            getWvName(id, wv) {
                const wvObjNames = ['documentTypeWvList', 'mainCategoryWvList', 'subCategoryWvList'];
                for (const wvName of wvObjNames) {
                    for (const element of wv[wvName]) {
                        if (element.id !== null) {
                            if (id === element.id)
                                return element.name;
                        }
                    }
                }
                return "";
            }
        };
        DocumentFolderStructureDirective = __decorate([
            QMC.Directive('QMC.Documents', 'qmDocumentFolderStructure', ['$qui', 'QmcLanguageService', 'QmcPermissionService', 'StammdatenService', 'UserService', '$state', '$timeout'])
        ], DocumentFolderStructureDirective);
        Documents.DocumentFolderStructureDirective = DocumentFolderStructureDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        let DocumentViewerDirective = class DocumentViewerDirective {
            constructor($qui, permissionService) {
                this.$qui = $qui;
                this.permissionService = permissionService;
                this.restrict = 'E';
                this.templateUrl = './Documents/DocumentViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmFileType: '=',
                    qmReportFileId: '=',
                    qmAllowDownload: '=?'
                };
                this.link = (scope, _element, attrs) => {
                    scope.allowDownload = false;
                    scope.allowPrint = false;
                    const applyDownloadPermission = (allowed) => {
                        scope.allowDownload = allowed;
                        this.$qui.scopeApply(scope);
                    };
                    if (angular.isDefined(attrs.qmAllowDownload)) {
                        scope.$watch('qmAllowDownload', (allowed) => applyDownloadPermission(allowed === true));
                        applyDownloadPermission(scope.qmAllowDownload === true);
                    }
                    else {
                        this.permissionService.getPermissionsByObjectType(920002).then((data) => {
                            var _a, _b;
                            applyDownloadPermission(((_a = data[0]) === null || _a === void 0 ? void 0 : _a.openFile) === true);
                            scope.allowPrint = ((_b = data[0]) === null || _b === void 0 ? void 0 : _b.print) === true;
                        });
                    }
                    scope.prepareViewing = false;
                    scope.$watch('qmData', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.$watch('qmFileName', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.$watch('qmFileType', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.downloadBase64 = () => {
                        if (!scope.allowDownload) {
                            return;
                        }
                        const temp = scope.qmFileName.split('.');
                        let ext = scope.qmFileType;
                        if (temp.length > 1)
                            ext = temp[temp.length - 1];
                        const contentType = this.$qui.extToMime(ext);
                        this.$qui.notify(this.$qui.downloadNote);
                        const blob = this.$qui.base64ToBlob(scope.qmData, contentType);
                        this.$qui.downloadBlob(scope.qmFileName, blob);
                    };
                };
            }
            handleFile(scope) {
                scope.prepareViewing = true;
                scope.error = undefined;
                if (scope.qmData && scope.qmFileName && scope.qmFileType)
                    scope.prepareViewing = false;
                else
                    scope.error = 'Keine Vorschau möglich';
            }
        };
        DocumentViewerDirective = __decorate([
            QMC.Directive('QMC.Documents', 'qmDocumentViewer', ['$qui', 'QmcPermissionService'])
        ], DocumentViewerDirective);
        Documents.DocumentViewerDirective = DocumentViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        let PdfViewerDirective = class PdfViewerDirective {
            constructor($qui, $sce, qmcBase) {
                this.$qui = $qui;
                this.$sce = $sce;
                this.qmcBase = qmcBase;
                this.restrict = 'E';
                this.templateUrl = './Documents/PdfViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmScale: '@',
                    qmPage: '@',
                    qmCallback: '&',
                    qmCallbackButton: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = (scope, element) => {
                    let iframeEl;
                    let messageHandler;
                    let viewerToken = 0;
                    const buildViewerUrl = () => {
                        const params = new URLSearchParams();
                        params.set('_t', String(viewerToken));
                        if (scope.qmDisableDownload) {
                            params.set('disableDownload', 'true');
                        }
                        if (scope.qmDisablePrint) {
                            params.set('disablePrint', 'true');
                        }
                        const viewerPath = this.qmcBase + '/js/pdf/web/viewer.html?' + params.toString();
                        return this.$sce.trustAsResourceUrl(viewerPath);
                    };
                    const sendPdfToViewer = () => {
                        if (!(iframeEl === null || iframeEl === void 0 ? void 0 : iframeEl.contentWindow) || !scope.qmData) {
                            return;
                        }
                        iframeEl.contentWindow.postMessage({
                            type: 'qm-pdf-open',
                            base64: scope.qmData,
                            fileName: scope.qmFileName
                        }, window.location.origin);
                    };
                    const updateToolbarRestrictions = () => {
                        if (!(iframeEl === null || iframeEl === void 0 ? void 0 : iframeEl.contentWindow)) {
                            return;
                        }
                        iframeEl.contentWindow.postMessage({
                            type: 'qm-pdf-viewer-update',
                            disableDownload: !!scope.qmDisableDownload,
                            disablePrint: !!scope.qmDisablePrint
                        }, window.location.origin);
                    };
                    const loadPdf = () => {
                        if (!scope.qmData) {
                            scope.viewerSrc = undefined;
                            scope.qmPdf = undefined;
                            scope.qmLoading = false;
                            this.$qui.scopeApply(scope);
                            return;
                        }
                        viewerToken += 1;
                        scope.qmPdf = 'loading';
                        scope.qmLoading = true;
                        scope.viewerSrc = buildViewerUrl();
                        this.$qui.scopeApply(scope);
                    };
                    messageHandler = (event) => {
                        var _a, _b;
                        if (event.origin !== window.location.origin) {
                            return;
                        }
                        if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === 'qm-pdf-opened') {
                            scope.qmPdf = 'ready';
                            scope.qmLoading = false;
                            this.$qui.scopeApply(scope);
                        }
                        if (((_b = event.data) === null || _b === void 0 ? void 0 : _b.type) === 'qm-pdf-error') {
                            scope.qmPdf = 'error';
                            scope.qmLoading = false;
                            this.$qui.scopeApply(scope);
                        }
                    };
                    window.addEventListener('message', messageHandler);
                    scope.$evalAsync(() => {
                        iframeEl = element[0].querySelector('iframe');
                        if (!iframeEl) {
                            return;
                        }
                        iframeEl.addEventListener('load', sendPdfToViewer);
                    });
                    scope.$watch('qmData', (newVal, oldVal) => {
                        if (newVal === oldVal) {
                            return;
                        }
                        loadPdf();
                    });
                    scope.$watchGroup(['qmDisableDownload', 'qmDisablePrint'], () => {
                        updateToolbarRestrictions();
                    });
                    scope.$on('$destroy', () => {
                        window.removeEventListener('message', messageHandler);
                    });
                    scope.downloadBase64 = () => {
                        if (!scope.qmData || scope.qmDisableDownload) {
                            return;
                        }
                        this.$qui.notify(this.$qui.downloadNote);
                        const blob = this.$qui.base64ToBlob(scope.qmData, 'application/pdf');
                        let fileName = scope.qmFileName || 'document.pdf';
                        if (!/\.pdf$/i.test(fileName)) {
                            fileName = `${fileName}.pdf`;
                        }
                        this.$qui.downloadBlob(fileName, blob);
                    };
                    loadPdf();
                };
            }
        };
        PdfViewerDirective = __decorate([
            QMC.Directive('QMC.Documents', 'qmPdfViewer', ['$qui', '$sce', 'qmcBase'])
        ], PdfViewerDirective);
        Documents.PdfViewerDirective = PdfViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        let SpreadViewerDirective = class SpreadViewerDirective {
            constructor($qui, reportingService) {
                this.$qui = $qui;
                this.reportingService = reportingService;
                this.restrict = 'EA';
                this.templateUrl = './Documents/SpreadViewer';
                this.replace = true;
                this.scope = {
                    qmSpread: '=',
                    qmSpreadName: '=',
                    qmSpreadId: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = (scope) => {
                    scope.$on('$destroy', () => {
                        $('#spreadDownloadNameModal').remove();
                    });
                    const elementId = 'spreadsheetViewer';
                    const reportingService = this.reportingService;
                    const $qui = this.$qui;
                    scope.loading = true;
                    scope.chkbx = {
                        editable: true
                    };
                    let location = window.location.href.substring(0, window.location.href.indexOf('#'));
                    if (!location.endsWith('/'))
                        location = location + '/';
                    const igScripts = [
                        location + 'igniteui/js/infragistics.js',
                    ];
                    // Detect if library loaded
                    const isLoadedScript = (lib) => {
                        return document.querySelectorAll('[src="' + lib + '"]').length > 0;
                    };
                    // Load library
                    const loadScript = (lib) => {
                        console.log('loading Script', lib);
                        const script = document.createElement('script');
                        script.async = false;
                        script.setAttribute('src', lib);
                        document.getElementsByTagName('body')[0].prepend(script);
                        return script;
                    };
                    for (let i = 0; i < igScripts.length; i++) {
                        if (!isLoadedScript(igScripts[i])) {
                            loadScript(igScripts[i]);
                        }
                    }
                    function openSpreadFile() {
                        scope.errortext = undefined;
                        $.ig.excel.Workbook.load(scope.qmSpread, (workbook) => {
                            if ($("#" + elementId).igSpreadsheet !== undefined && workbook !== null) {
                                //load specific workbook
                                $("#" + elementId).igSpreadsheet("option", "workbook", workbook);
                            }
                            $qui.scopeApply(scope);
                        }, (error) => {
                            console.error("IG:", error, scope.qmSpread);
                            scope.errortext = error + ' ';
                            $("#" + elementId).igSpreadsheet("destroy");
                            $qui.scopeApply(scope);
                        });
                    }
                    function allScriptsLoaded() {
                        for (let i = 0; i < igScripts.length; i++) {
                            if (!isLoadedScript(igScripts[i]) || typeof $("#" + elementId).igSpreadsheet !== 'function' || !$.ig) {
                                return false;
                            }
                        }
                        return true;
                    }
                    function initSpreadsheet() {
                        if (!allScriptsLoaded()) {
                            setTimeout(() => {
                                initSpreadsheet();
                            }, 250);
                            return;
                        }
                        $("#" + elementId).igSpreadsheet({
                            height: window.innerHeight - 100 + "",
                            width: "100%",
                            language: "de",
                            isFormulaBarVisible: scope.chkbx.editable,
                            editModeEntering: () => {
                                return scope.chkbx.editable;
                            }
                        });
                        $('.ui-igspreadsheet-formulabartextareasplitter').click((event) => {
                            event.preventDefault();
                        });
                        scope.loading = false;
                        scope.$watch("chkbx.editable", (oldVal, newVal) => {
                            if (oldVal === newVal)
                                return;
                            $("#" + elementId).igSpreadsheet("option", "isFormulaBarVisible", scope.chkbx.editable);
                        });
                        if (scope.qmSpread && scope.qmSpread.length > 0)
                            openSpreadFile();
                        $qui.scopeApply(scope);
                    }
                    window.onresize = () => { initSpreadsheet(); };
                    const handleFileChange = () => {
                        if (!allScriptsLoaded()) {
                            setTimeout(() => { initSpreadsheet(); }, 250);
                            return;
                        }
                        setTimeout(() => {
                            initSpreadsheet();
                            openSpreadFile();
                        }, 50);
                    };
                    scope.$watch("qmSpread", () => {
                        if (scope.qmSpread === undefined)
                            return;
                        if (scope.qmSpread === null)
                            return;
                        handleFileChange();
                    });
                    scope.$watch("qmSpreadName", () => {
                        var _a;
                        if ((_a = scope.qmSpreadName) === null || _a === void 0 ? void 0 : _a.includes('.')) {
                            if (scope.originalName === undefined) {
                                scope.originalName = scope.originalName === scope.qmSpreadName ? scope.originalName : scope.qmSpreadName;
                                scope.originalSuffix = scope.originalName.split('.')[scope.originalName.split('.').length - 1];
                                scope.qmSpreadName = scope.originalName.substring(0, scope.originalName.lastIndexOf('.'));
                            }
                        }
                        $qui.scopeApply(scope);
                    }, true);
                    scope.removeInvalidChars = (fileName) => {
                        const fileNameNoWhiteSpace = fileName.replace(/[\s]/g, "_");
                        return fileNameNoWhiteSpace.replace(/[\/\?\#\[\]\@\!\$\&\§\'\(\)\*\+\,\;\:\=]/g, "-"); //vgl: https://stackoverflow.com/questions/2366260/whats-valid-and-whats-not-in-a-uri-query
                    };
                    const downloadFile = (data, suffix) => {
                        let name = scope.qmSpreadName;
                        if (suffix && !name.endsWith(suffix)) {
                            name += suffix;
                        }
                        if (window.navigator.userAgent.indexOf("MSIE") > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                            window.navigator.msSaveOrOpenBlob(data, name);
                        }
                        else {
                            const blobUrl = URL.createObjectURL(data);
                            const a = document.createElement('a');
                            a.style["display"] = "none";
                            document.body.append(a);
                            a.href = blobUrl;
                            a.download = name;
                            a.target = '_blank';
                            a.click();
                            setTimeout(() => {
                                window.URL.revokeObjectURL(blobUrl);
                                document.body.removeChild(a);
                            }, 4E4);
                        }
                    };
                    scope.downloadPdfFile = () => {
                        $('#genericLoadingModal').modal('show');
                        reportingService.getFinishedSpreadServerJobAsPdf(scope.qmSpreadId, scope.qmSpreadName).then((data) => {
                            downloadFile($qui.base64ToBlob(data.base64, 'application/pdf'), '.pdf');
                            $('#genericLoadingModal').modal('hide');
                        }).catch((e) => {
                            $('#genericLoadingModal').modal('hide');
                            console.error(e);
                        });
                    };
                    scope.downloadSpreadFile = () => {
                        // make sure to change cell before saving since the component needs a cellchange to flush the current content into its datamodell
                        let cell = $("#" + elementId).igSpreadsheet("option", "activeCell");
                        cell = cell === 'A1' ? 'A2' : 'A1';
                        $("#" + elementId).igSpreadsheet("option", "activeCell", cell);
                        $("#" + elementId).igSpreadsheet('option', 'workbook')
                            .save({ type: 'blob' }, (data) => {
                            downloadFile(data, scope.originalSuffix ? '.' + scope.originalSuffix : '.xlsx');
                        }, (error) => {
                            console.warn('Fehler beim Download: : ' + error); //testweise
                        });
                    };
                    scope.downloadOriginalSpreadFile = () => {
                        var _a;
                        console.log(scope.qmSpreadName, scope.originalSuffix);
                        let name = scope.removeInvalidChars(scope.qmSpreadName);
                        if (scope.originalSuffix)
                            name += '.' + scope.originalSuffix;
                        else {
                            name += '.xlsx';
                        }
                        const blob = this.$qui.base64ToBlob(scope.qmSpread, this.$qui.extToMime((_a = scope.originalSuffix) !== null && _a !== void 0 ? _a : 'xlsx'));
                        this.$qui.downloadBlob(name, blob);
                    };
                    scope.print = () => {
                        const area = document.getElementsByClassName('ui-igspreadsheet-formulabar')[0].nextSibling.cloneNode(true);
                        // dont show tab item area
                        area.childNodes.forEach((x) => {
                            const cl = x.classList;
                            if (cl.contains('ui-igspreadsheet-tabitemarea')) {
                                x.remove();
                            }
                        });
                        const iframe = document.createElement('iframe');
                        document.body.appendChild(iframe);
                        iframe.style.display = 'none';
                        iframe.onload = () => {
                            setTimeout(() => {
                                iframe.contentDocument.title = scope.qmSpreadName;
                                const style = iframe.contentWindow.document.createElement('style');
                                style.type = 'text/css';
                                style.innerText = '@page {size: auto; margin: 0;}/* div {border: 1px solid lightgrey;}*/';
                                iframe.contentWindow.document.head.appendChild(style);
                                iframe.contentWindow.document.body.appendChild(area);
                                iframe.focus();
                                iframe.contentWindow.print();
                                URL.revokeObjectURL(iframe.src);
                                setTimeout(iframe.remove, 5);
                            }, 1);
                        };
                        iframe.src = '';
                    };
                };
            }
        };
        SpreadViewerDirective = __decorate([
            QMC.Directive('QMC.Documents', 'qmSpreadViewer', ['$qui', 'ReportingService'])
        ], SpreadViewerDirective);
        Documents.SpreadViewerDirective = SpreadViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        let ImageViewerDirective = class ImageViewerDirective {
            constructor($qui) {
                this.$qui = $qui;
                this.restrict = 'E';
                this.templateUrl = './Documents/ImageViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmFileType: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = (scope) => {
                    scope.prepareViewing = false;
                    scope.$watch('qmData', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.$watch('qmFileName', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.$watch('qmFileType', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.downloadBase64 = () => {
                        const contentType = scope.getMimeType();
                        this.$qui.notify(this.$qui.downloadNote);
                        const blob = this.$qui.base64ToBlob(scope.qmData, contentType);
                        this.$qui.downloadBlob(scope.qmFileName, blob);
                    };
                    scope.getMimeType = () => {
                        let mime = this.$qui.extToMime(scope.qmFileType);
                        if (!mime || mime.length === 0) {
                            const temp = scope.qmFileName.split('.');
                            if (temp.length < 2) {
                                scope.error = true;
                            }
                            const ext = temp[temp.length - 1];
                            mime = this.$qui.extToMime(ext);
                        }
                        return mime;
                    };
                    this.handleFile(scope);
                    scope.print = () => {
                        const win = window.open('', '');
                        win.document.write([
                            '<html>',
                            '   <head>',
                            '   </head>',
                            '   <body onload="window.print()" onafterprint="window.close()">',
                            '       <img src="' + scope.src + '"/>',
                            '   </body>',
                            '</html>'
                        ].join(''));
                        win.document.close();
                    };
                };
            }
            handleFile(scope) {
                scope.error = false;
                if (scope.qmData && scope.qmFileName) {
                    scope.src = `data:${scope.getMimeType()};base64,${scope.qmData}`;
                }
                else {
                    scope.error = true;
                }
            }
        };
        ImageViewerDirective = __decorate([
            QMC.Directive('QMC.Documents', 'qmImageViewer', ['$qui'])
        ], ImageViewerDirective);
        Documents.ImageViewerDirective = ImageViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        let TextViewerDirective = class TextViewerDirective {
            constructor($qui, $sce, mediaService, lngService) {
                this.$qui = $qui;
                this.$sce = $sce;
                this.mediaService = mediaService;
                this.lngService = lngService;
                this.restrict = 'E';
                this.templateUrl = './Documents/TextViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmFileType: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = (scope) => {
                    scope.callbackButton = {
                        label: this.lngService.translate(21006014, 'Herunterladen'),
                        icon: 'fa fa-download'
                    };
                    scope.prepareViewing = false;
                    scope.$watch('qmData', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.$watch('qmFileName', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.$watch('qmFileType', (newVal, oldVal) => {
                        if (newVal !== oldVal)
                            this.handleFile(scope);
                    });
                    scope.downloadBase64 = () => {
                        const contentType = scope.getMimeType();
                        this.$qui.notify(this.$qui.downloadNote);
                        const blob = this.$qui.base64ToBlob(scope.qmData, contentType);
                        this.$qui.downloadBlob(scope.qmFileName, blob);
                    };
                    scope.getMimeType = () => {
                        let mime = this.$qui.extToMime(scope.qmFileType);
                        if (!mime || mime.length === 0) {
                            const temp = scope.qmFileName.split('.');
                            if (temp.length < 2) {
                                scope.error = true;
                            }
                            const ext = temp[temp.length - 1];
                            mime = this.$qui.extToMime(ext);
                        }
                        return mime;
                    };
                    this.handleFile(scope);
                    scope.print = () => {
                        const win = window.open('', '');
                        win.document.write([
                            '<html>',
                            '   <head>',
                            '   </head>',
                            '   <body onload="window.print()" onafterprint="window.close()">',
                            '       ' + document.getElementById('textViewerPrintArea').innerHTML +
                                '   </body>',
                            '</html>'
                        ].join(''));
                        win.document.close();
                    };
                };
            }
            handleFile(scope) {
                scope.error = false;
                scope.loading = false;
                scope.html = undefined;
                scope.pdf = undefined;
                if (scope.qmData && scope.qmFileName) {
                    // directly supported files could be shown directly (ach was *facepalm*)
                    if (['txt', 'text', 'html'].includes(scope.qmFileType)) {
                        scope.html = this.$sce.trustAsHtml(atob(scope.qmData));
                    }
                    // others get translated by api to pdf
                    else {
                        scope.loading = true;
                        this.mediaService.convertToPdf(scope.qmData, scope.qmFileType).then((data) => {
                            scope.pdf = data;
                            scope.loading = false;
                        });
                    }
                }
                else {
                    scope.error = true;
                }
            }
        };
        TextViewerDirective = __decorate([
            QMC.Directive('QMC.Documents', 'qmTextViewer', ['$qui', '$sce', 'QmcMediaService', 'QmcLanguageService'])
        ], TextViewerDirective);
        Documents.TextViewerDirective = TextViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
/// <reference path="../../typings/jquery/jquery.d.ts" />
/// <reference path="../../typings/angularjs/angular.d.ts" />
angular.module('qmc-ui').factory('DeviceService', ['$window', function ($window) {
        const ctx = $window.QmcMobileContext;
        return {
            setBodyClass: function () {
                ctx.ensureMobileBodyClass();
            },
            isMobile: function () {
                return ctx.getMobileLabel();
            },
            isMobileBool: function () {
                return ctx.isMobileDevice();
            },
            isTabletBool: function () {
                return ctx.isTabletDevice();
            }
        };
    }]);

//# sourceMappingURL=../maps/qmc.common.js.map
